module.exports = {
	en: {
		'common.strings.home': 'HOME',
		'common.worldChampionship': 'Clash of Clans World Championship 2026',
		'common.strings.schedule': 'SCHEDULE',
		'common.strings.stage1': 'Open Qualifier',
		'common.strings.stage2': 'Monthly Qualifier',
		'common.strings.stage3': 'Monthly Finals',
		'common.strings.stage4': 'Stage 4',
		'common.strings.stage5': 'Stage 5',
		'common.strings.championshipFinals': 'Championship Finals',
		'common.strings.prizes': 'PRIZE POOL',
		'common.strings.goldenTicketWinners': 'GOLDEN TICKET WINNERS',
		'common.strings.silverTicketWinners': 'SILVER TICKET WINNERS',
		'common.strings.roster': 'ROSTER',
		'common.strings.captain': 'Captain',
		'common.strings.upcomingMatches': 'UPCOMING MATCH',
		'common.strings.pastMatches': 'COMPLETED MATCHES',
		'common.strings.ladderLeaderboard': 'LADDER LEADERBOARD',
		'common.strings.points': 'Points',
		'common.strings.record': 'Record',
		'common.strings.rank': 'Rank',
		'common.strings.wins': 'Wins',
		'common.strings.losses': 'Losses',
		'common.strings.gdpr': 'GDPR',
		'common.strings.participantList': 'PARTICIPANT LIST',
		'common.strings.round': 'ROUND {roundNumber}',
		'common.strings.qualified': 'QUALIFIED',
		'common.strings.eliminated': 'ELIMINATED',
		'common.strings.checkin': 'Check In',
		'common.button.confirm': 'Confirm',
		'common.button.submit': 'Submit',
		'common.button.cancel': 'Cancel',
		'common.button.viewEvent': 'View Event',
		'common.button.viewAll': 'View All',
		'common.button.backToEvent': 'Back To Event',
		'common.button.goBack': 'Go Back',
		'common.button.inviteMembers': 'Choose Team',
		'common.button.ready': "I'm Ready!",
		'common.button.skip': 'Skip For Now',
		'common.button.save': 'Save',
		'common.button.saveChanges': 'Save Changes',
		'common.button.back': 'Back',
		'common.button.register': 'Register',
		'common.button.pickTeam': 'Pick Team',
		'common.button.leaveTeam': 'Leave Team',
		'common.button.createTeam': 'Create Team',
		'common.strings.ready': 'Ready',
		'common.strings.notReady': 'Not Ready',
		'common.button.done': 'Done',
		'common.strings.january': 'January',
		'common.strings.february': 'February',
		'common.strings.march': 'March',
		'common.strings.april': 'April',
		'common.strings.may': 'May',
		'common.strings.june': 'June',
		'common.strings.july': 'July',
		'common.strings.august': 'August',
		'common.strings.september': 'September',
		'common.strings.october': 'October',
		'common.strings.november': 'November',
		'common.strings.december': 'December',
		'common.strings.contactSupport': 'Contact Support',
		'common.strings.error.required': 'Field is required',
		'common.strings.success': 'Success!',
		'common.strings.ohNo': 'Oh No!',
		'common.strings.wait': 'Hey, wait!',
		'common.strings.tooltip.discord':
			'You can use the official Clash of Clans World Championship Discord server to connect with your teammates.',
		'common.strings.forfeitWin': 'FFW',
		'common.strings.forfeitLoss': 'FFL',
		'common.strings.bye': 'BYE',
		'common.strings.teamInvite': 'Invite members',
		'common.button.join': 'Join',
		'common.strings.discordConnected': 'Discord account connected',
		'common.strings.selectedAsCaptain':
			'You have been chosen to represent your clan in the World Championships and assigned as the Team Captain. Please register below by {DATETIME}.',
		'common.strings.pending': 'Needs to register',
		'common.strings.today': 'Today',
		'common.strings.registrationClosesIn': 'Registration closes in {time}',
		'common.strings.startsIn': '[X] Starts in {time}',
		'common.strings.endsIn': '[X] Ends in {time}',
		'common.strings.days': 'd',
		'common.strings.hours': 'h',
		'common.strings.minutes': 'm',
		'common.strings.seconds': 's',
		'common.strings.changeCaptain': 'Change Captain',
		'common.strings.chooseCaptain': 'Choose Captain',
		'common.strings.backToHub': 'Back to Tournament Hub',
		'common.strings.missingCaptainLeader':
			'Your team is missing a Captain. You must pick a Captain before you can compete.',
		'common.strings.missingCaptain':
			'Your team is missing a Captain. Please ask your Clan Leader to pick a Captain.',
		'common.strings.captainRoleMismatchPersonal':
			'You are the Team Captain but are not a co-leader or leader. Ask your clan leader to promote you or pick a new Captain.',
		'common.strings.captainRoleMismatchLeader':
			'Your Captain is not a clan leader or co-leader. Either select a new Captain or promote the current Captain to leader or co-leader.',
		'common.strings.captainRoleMismatch':
			'Your Captain is not a co-leader or leader. Ask your clan leader to promote your Captain to co-leader or leader, or select a new Captain.',
		'common.strings.rosterIncompleteLeader':
			'You have invited players who have not yet registered. Please ask your team members to register.',
		'common.strings.rosterIncomplete':
			'At least one team member has not completed registration. Please ask your team members to register as soon as possible.',
		'common.strings.rosterReady':
			'Your team is ready to play. The Team Captain must check in. Good luck!',
		'common.button.next': 'Next',
		'common.strings.leader': 'Leader',
		'common.strings.coLeader': 'Co-leader',
		'common.strings.elder': 'Elder',
		'common.strings.member': 'Member',
		'common.errors.critical': 'A critical error has occurred. Please restart the application.',
		'common.button.startWar': 'START WAR',
		'common.strings.statusRegRosterCaptain':
			'Registration closes on {DATETIME}.<BR/> Once all members have completed registration, please lock your team by tapping the "Lock Team" button! Once your team is locked clan hopping is not possible.',
		'common.strings.statusRegRosterMember':
			'You have been chosen to represent the team! Registration closes at {DATETIME}. Please complete registration and head to the  "My Team" tab to follow the status of your Team.',
		'common.strings.statusRegClosedNotMember':
			"The team to represent your clan has been selected. Registration closes on {DATETIME}. Follow your clan's journey under the Competition tab!",
		'common.strings.opponentTeamCheckInOpen': 'Your opponent has yet to START WAR.',
		'common.strings.opponentTeamCheckedIn': 'Your opponent is ready to START WAR.',
		'common.strings.currentTeamCheckInOpen': 'Your team has yet to START WAR.',
		'common.strings.currentTeamCheckedIn': 'Your team is ready to START WAR.',
		'common.strings.opponentTeamMissedCheckedIn':
			'Your opponent has missed the match check in window.',
		'common.strings.currentTeamMissedCheckIn':
			'Your team has missed the match check in window.',
		'common.button.tournamentCheckin': 'Tournament Check In',
		'common.strings.tooltipAttackOrder':
			'Both teams must follow the correct Attack Order <strong>(Rule 3.2.3 in the Official Ruleset).</strong><br/><br/>',
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			'If your opponent is not following the proper Attack Order, please open a ticket and report your match on Discord.',
		'common.strings.dayTwoAttackOrder5v5':
			'<u>This match has dedicated attack orders.</u><br/><strong>{HOMETEAM} Attacks</strong> when there is 37min, 29min, 21min, 13min, 5min left in the War.<br/><strong>{AWAYTEAM} Attacks</strong> when there is 33min, 25min, 17min, 9min, 1min left in the War.',
		'common.button.lockRoster': 'Lock Team',
		'common.strings.tooltip.notPartOfClan': 'This team member is not currently in the Clan.',
		'common.strings.locked': 'Team is Locked',
		'common.strings.notLocked': 'Team is Not Locked',
		'common.homeMessage.getReady':
			'Get ready for the Clash of Clans World Championship 2026 Tournament to begin!',
		'common.homeMessage.registerAndSelectATeam':
			'Register and select at least {rosterMinSize} clan members to represent your clan in your Clash of Clans World Championship team.',
		'common.homeMessage.leaderHasntRegisteredYet':
			'Your Clan Leader has not yet registered for Clash of Clans World Championship.',
		'common.homeMessage.thNotHighEnough': 'Your Town Hall must be Level 18 to participate.',
		'common.homeMessage.clanRequired':
			'You must be in a Clan to participate in the Clash of Clans World Championship.',
		'common.homeMessage.rosterNotComplete.leader':
			'Your team members must be IN THE CLAN, SELECTED, and REGISTERED in order to lock your team. If a team member leaves before the team is locked, they will need to be re-selected by the Clan Leader. Once your team is locked, team members can leave and return to the Clan without being re-selected.',
		'common.homeMessage.rosterNotComplete.captain':
			'All team members must be IN THE CLAN, SELECTED, and REGISTERED in order to lock your team. If a team member leaves before the team is locked, they will need to be re-selected by the Clan Leader. Once your team is locked, team members can leave and return to the Clan without being re-selected.',
		'common.homeMessage.rosterNotComplete.member':
			'You have been chosen to represent the team. Please note that if you leave the clan between now and your team being locked in, the Clan Leader will be required to re-select you for participation. Once your team is locked, you may leave and return to the Clan without being re-selected.',
		'common.homeMessage.rosterNotComplete.fallback':
			'The team to represent your clan has not yet been selected.',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			'At least {rosterMinSize} players on your team have successfully registered. The Team Captain must lock the team in order to begin playing matches. Once your team is locked, no adjustments to the team lineup can be made.',
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			'At least {rosterMinSize} players on your team have successfully registered. You must lock your team in order to play ladder matches. Once your team is locked, no adjustments to the team lineup can be made.',
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			'In order to begin playing ladder matches, the Team Captain must lock your team. Once your team is locked, no adjustments to the team lineup can be made.',
		'common.homeMessage.rosterLocked':
			'At least {rosterMinSize} players on your team have successfully registered, and the team is locked in! Once the ladder begins, the Team Captain can begin playing matches by tapping "Find Match." Remember, all players must be IN THE CLAN, and the Clan CANNOT be in any other War during a World Championship match. Players can play normal Clan Wars and Clan War Leagues in other Clans but CANNOT play in a Friendly War during a World Championship match.',
		'common.homeMessage.rosterLocked.captain':
			'At least {rosterMinSize} players on your team have successfully registered, and the team is locked in! Once the ladder begins, you can begin playing matches by tapping "Find Match." Remember, all players must be IN THE CLAN, and the Clan CANNOT be in any other War during a World Championship match. Players can play normal Clan Wars and Clan War Leagues in other Clans but CANNOT play in a Friendly War during a World Championship match.',
		'common.homeMessage.ladderInProgress':
			'The ladder has begun! The Team Captain can find a match by tapping "Find Match". Remember, all members must be IN THE CLAN and not a part of a friendly or active War in order to find a match.',
		'common.homeMessage.ladderInProgress.captain':
			'The ladder has begun! You can find a match by tapping the "Find Match" button. Remember, all members must be IN THE CLAN and not a part of a friendly or active War in order to find a match. Please make sure all members are ready to play before finding a match.',
		'common.homeMessage.followTeam':
			'You can follow your team’s journey through the Competition tab!',
		'common.homeMessage.finishedTop90.captain':
			'If your ladder placement was 170th place or better, please check Discord for an important announcement. The Top 128 teams will advance to the Monthly Qualifier. Team members MUST be back in the Clan before match check in.',
		'common.homeMessage.finishedTop90.member':
			'If your ladder placement was 170th place or better, please check Discord for an important announcement. The Top 128 teams will advance to the Monthly Qualifier. The Team Captain is responsible for match check in.',
		'common.homeMessage.preSegment.postLadder.captain':
			'Teams that have advanced to the next stage of competition will need to complete match check in. Remember, all team members MUST be back in the Clan before match check in. You are responsible for match check in. The match check in period is 5 minutes.',
		'common.homeMessage.preSegment.postLadder.member':
			'Teams that have advanced to the next stage of competition will need to complete match check in. Remember, all team members MUST be back in the Clan before match check in. The Team Captain is responsible for match check in. The match check in period is 5 minutes.',
		'common.homeMessage.tournamentInProgress.captain':
			'The tournament is in progress! Tap “Check In” within 5 minutes of every round start time. Check the "Clash of Clans Esports" Discord for critical tournament information!',
		'common.homeMessage.tournamentInProgress.member':
			'The tournament is in progress! The Team Captain must tap “Check In” within 5 minutes of every round start time. Check the "Clash of Clans Esports" Discord for critical tournament information!',
		'common.homeMessage.phase1InProgress':
			'The 2026 World Championship is in progress. You can follow the rest of the Tournament through the Competition tab or by following <a href="https://twitter.com/CoCEsports">@CoCEsports</a>!',
		'common.strings.goodLuckMessage':
			'Congratulations! Good luck on the rest of your World Championship Finals journey!',
		'common.strings.phaseOneComplete':
			'This month\'s competition has been completed. Follow <a href="https://twitter.com/CoCEsports">@CoCEsports</a> for more!',
		'common.strings.ladderEndsIn': 'Ladder ends in',
		'common.strings.matchCheckinStartsIn': 'Match check in starts in',
		'common.strings.matchCheckinEndsIn': 'Match check in ends in',
		'common.homeMessage.teamIncomplete':
			"Registration for the competition is now closed. As your team did not complete registration in time, your team is unable to compete in this month's competition.",
		'common.homeMessage.preSegment.ladder.captain':
			'If your ladder placement was 170th place or better, please check Discord for an important announcement. The Top 128 teams will advance to the Monthly Qualifier. Team members MUST be back in the Clan before match check in.',
		'common.homeMessage.preSegment.ladder.member':
			'If your ladder placement was 170th place or better, please check Discord for an important announcement. The Top 128 teams will advance to the Monthly Qualifier. The Team Captain is responsible for match check in.',
		'common.button.leaveQueue': 'Leave Queue',
		'common.button.findMatch': 'Find Match',
		'common.strings.phase': 'STAGE {#}',
		'common.strings.lowerBracket': 'Lower Bracket',
		'common.strings.upperBracket': 'Upper Bracket',
		'common.strings.noMatches': 'No Matches',
		'common.strings.noData': 'No Data',
		'common.button.manageRoster': 'Manage Team',
		'common.button.withdraw': 'Withdraw',
		'common.strings.readyToPlay': 'Your registration was successful! You are ready to play!',
		'common.strings.registration.opens': 'REGISTRATION OPENS:',
		'common.strings.registration.closes': 'REGISTRATION CLOSES:',
		'common.strings.worldChampionshipFinals': 'World Championship Finals',
		'common.strings.lastChanceQualifier': 'Last Chance Qualifier',
		'common.strings.starts': 'Starts',
		'common.strings.ends': 'Ends',
		'common.strings.eliminationType': 'Elimination Type:',
		'common.strings.group': 'Group',
		'common.strings.notPicked5': 'Please pick at least {rosterMinSize} clan members',
		'common.strings.notPickedLeader': 'You must select at least 1 Clan Leader or Co-leader',
		'common.button.accept': 'Accept',
		'common.button.decline': 'Decline',
		'common.strings.gamesPlayed': 'GP',
		'common.strings.wars': 'Wars',
		'common.strings.worldFinalsFinalists': 'World Championship Finalists',
		'common.strings.followNow': 'Follow Now!',
		'common.strings.worldFinalsWinner':
			'Congratulation to Synchronic Gaming for being crowned the 2024 World Champions!<br/><br/>We hope to see you again in 2026.',
		'common.starts': 'Starts',
		'common.ends': 'Ends',
		'common.eliminationType': 'Elimination Type:',
		'common.eliminationType.doubleElim': 'Elimination Type: Double Elimination',
		'common.eliminationType.swiss': 'Elimination Type: Swiss',
		'common.eliminationType.ladder': 'Elimination Type: Ladder',
		'common.strings.maxLimitMatchesHeader': 'Match Limited Reached',
		'common.strings.maxLimitMatchesPerDay':
			'You have already played 6 matches in the past 24 hours. Please try again later. ',
		'common.strings.homeTeam': 'Home',
		'common.strings.awayTeam': 'Away',
		'common.strings.wfDay1': 'World Championship Finals Day 1',
		'common.strings.wfDay2': 'World Championship Finals Day 2',
		'common.strings.wfDay3': 'World Championship Finals Day 3',
		'common.strings.wfHeroText':
			'The 8 best teams in the world will compete at the Clash of Clans World Championship Finals in Atlanta, Georgia, for a $700,000 USD prize pool and the 2026 World Champion title.<br /><br>\n\nTune in 31 October - 2 November on <a href="[EVENT LINK]" target=""_blank"">Events Platform</a> and earn in-game rewards!',
		'common.strings.wfCongrats':
			'Congratulations to [TEAM] for earning the 2026 World Champion title!\n\nThe Clash of Clans World Championship will return in 2026; we hope to see you there!\n\nBe sure to follow our Esports, Twitter, and Instagram for all the latest news.',
		'common.strings.seeYouNextYear':
			'Congratulations to [TEAM] for being crowned World Champions! The Clash of Clans World Championship will return in 2026; we hope to see you there! Be sure to follow our Esports <a href="https://twitter.com/CoCEsports">Twitter</a> and <a href="https://www.instagram.com/esportscoc">Instagram</a> for all the latest news on what is coming up in 2026!\n',
		'common.strings.wfFinalists': '2026 WORLD CHAMPIONSHIP FINALISTS',
		'common.strings.wfHowToWatch':
			'The 8 best teams in the World will battle it out for the title of 2026 Clash of Clans World Champion and the biggest share of the $700,000 USD prize pool!<br /><br />Tune in November 14–15 <a href="https://event.supercell.com/clashofclans/en">on the Event Site</a> and earn in-game rewards while you watch!',
		'common.strings.wfSchedule':
			'Teams compete against each other in a Double Elimination Bracket to crown the 2026 Clash of Clans World Champion.<br><br>\n\nDAY 1 BEGINS: 31 Oct [LOCAL TIME DAY 1]<br>\n\n- Match 1 - 6<br><br>\n\nDAY 2 BEGINS: 1 Nov [LOCAL TIME DAY 2]<br>\n\n- Match 7 - 12<br><br>\n\nDAY 3 BEGINS: 2 Nov [LOCAL TIME DAY 3]<br>\n\n- Match 13 - 15<br><br>\n\nWatch on <a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/en</a>&nbsp;and earn in-game rewards!',
		'common.strings.mfPrizes': 'MONTHLY FINALS PRIZE POOL',
		'common.strings.championshipPrizes': 'CHAMPIONSHIP FINALS PRIZE POOL',
		'common.message.selectFivePlayersForWar':
			'Please select the {rosterMinSize} players that will participate in the War.',
		'common.strings.selectFivePlayersForMq':
			'Please confirm the {rosterMinSize} players that will participate in the Monthly Qualifier and Monthly Final. Only the {rosterMinSize} selected players will remain on the roster.',
		'common.strings.lcqWinner': 'LCQ Winner',
		'common.strings.chinaQualifier': 'China Qualifier',
		'common.strings.chinaWinner': 'China Winner',
		'common.strings.communityTournament': 'Community Tournament',
		'common.strings.chinaRegionalQualifier': 'Chinese Regional Qualifier',
		'common.strings.townHall': 'Town Hall',
		'common.strings.townHallLevel': 'Town Hall Level',
		'common.button.waitMatchFinish': 'Waiting for match to finish',
		'common.strings.checkInMonthlyQualifier': 'Check your team in for the Monthly Qualifiers',
		'common.strings.checkedin': 'Checked In',
		'common.strings.leaderboard': 'Leaderboard',
		'common.strings.noResults': 'No Results',
		'common.thcup.worldChampionship': 'Town Hall Cups',
		'common.thcup.homeMessage.phase1InProgress':
			'The 2026 Town Hall Cup is in progress. You can follow the rest of the Tournament through the Competition tab or by following <a href="https://twitter.com/CoCEsports">@CoCEsports</a>!',
		'common.thcup.homeMessage.getReady':
			'Get ready for the Clash of Clans Town Hall Cup Tournament to begin!',
		'common.thcup.homeMessage.thNotHighEnough':
			'Your Town Hall must be Level 9, 12, or 15 to participate.',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'Your Clan Leader has not yet registered for Clash of Clans Town Hall Cup.',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'Register and select {rosterMinSize} Clan members to represent your Clan on your Clash of Clans Town Hall Cup team.',
		'common.thcup.homeMessage.clanRequired':
			'You must be in a Clan to participate in the Clash of Clans Town Hall Cup.',
		'common.thcup.homeMessage.rosterLocked':
			'{rosterMinSize} players on your team have successfully registered, and the team is locked in! Once the ladder begins, the Team Captain can begin playing matches by tapping "Find Match." Remember, all players must be IN THE CLAN, and the Clan CANNOT be in any other War during a Town Hall Cup match. Players can play normal Clan Wars and Clan War Leagues in other Clans but CANNOT play in a Friendly War during a Town Hall Cup match.',
		'common.thcup.homeMessage.rosterLocked.captain':
			'{rosterMinSize} players on your team have successfully registered, and the team is locked in! Once the ladder begins, you can begin playing matches by tapping "Find Match." Remember, all players must be IN THE CLAN, and the Clan CANNOT be in any other War during a Town Hall Cup match. Players can play normal Clan Wars and Clan War Leagues in other Clans but CANNOT play in a Friendly War during a Town Hall Cup match.',
		'common.thcup.homeMessage.preSegment.ladder.captain':
			'If your ladder placement was 170th place or better, please check Discord for an important announcement. The Top 128 teams will advance to the Monthly Qualifier. Team members MUST be back in the Clan before match check in.',
		'common.thcup.homeMessage.preSegment.ladder.member':
			'If your ladder placement was 170th place or better, please check Discord for an important announcement. The Top 128 teams will advance to the Monthly Qualifier. The Team Captain is responsible for match check in.',
		'common.thcup.homeMessage.finishedTop90.captain':
			'If your ladder placement was 8th place or better, please check Discord for an important announcement. The Top 8 teams will advance to the Finals. Team members MUST be back in the Clan before match check in.',
		'common.thcup.homeMessage.finishedTop90.member':
			'If your ladder placement was 8th place or better, please check Discord for an important announcement. The Top 8 teams will advance to the Finals. The Team Captain is responsible for match check in.',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			'Teams that have advanced to the next stage of competition will need to complete match check in. Remember, all team members MUST be back in the Clan before match check in. You are responsible for match check in. The match check in period is 5 minutes.',
		'common.thcup.homeMessage.preSegment.postLadder.member':
			'Teams that have advanced to the next stage of competition will need to complete match check in. Remember, all team members MUST be back in the Clan before match check in. The Team Captain is responsible for match check in. The match check in period is 5 minutes.',
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'The tournament is in progress! Tap “Check In” within 5 minutes of every round start time. Check the "Clash of Clans Esports" Discord for critical tournament information!',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'The tournament is in progress! The Team Captain must tap “Check In” within 5 minutes of every round start time. Check the "Clash of Clans Esports" Discord for critical tournament information!',
		'common.thcup.strings.stage1': 'Ladder',
		'common.thcup.strings.stage2': 'Monthly Qualifier',
		'common.thcup.strings.mfPrizes': 'FINALS PRIZE POOL',
		'common.strings.dayTwoAttackOrder3v3':
			'<u>This match has dedicated attack orders.</u><br/><strong>{HOMETEAM} Attacks</strong> when there is 21min, 13min, 5min left in the War.<br/><strong>{AWAYTEAM} Attacks</strong> when there is 17min, 9min, 1min left in the War.',
		'common.strings.dayTwoAttackOrder2v2':
			'<u>This match has dedicated attack orders.</u><br/><strong>{HOMETEAM} Attacks</strong> when there is 13min, 5min left in the War.<br/><strong>{AWAYTEAM} Attacks</strong> when there is 9min, 1min left in the War.',
	},
	fr: {
		'common.strings.home': 'ACCUEIL',
		'common.worldChampionship': 'Championnat du monde Clash of Clans 2026',
		'common.strings.schedule': 'PROGRAMME',
		'common.strings.stage1': 'Qualifications ouvertes',
		'common.strings.stage2': 'Qualifications mensuelles',
		'common.strings.stage3': 'Finales mensuelles',
		'common.strings.stage4': 'Étape 4',
		'common.strings.stage5': 'Étape 5',
		'common.strings.championshipFinals': 'Finale du championnat',
		'common.strings.prizes': 'CAGNOTTE',
		'common.strings.goldenTicketWinners': "GAGNANTS DES TICKETS D'OR",
		'common.strings.silverTicketWinners': "GAGNANTS DES TICKETS D'ARGENT",
		'common.strings.roster': 'COMPOSITION',
		'common.strings.captain': 'Capitaine',
		'common.strings.upcomingMatches': 'MATCH SUIVANT',
		'common.strings.pastMatches': 'MATCHS TERMINÉS',
		'common.strings.ladderLeaderboard': 'RANG EN CLASSÉ',
		'common.strings.points': 'Points',
		'common.strings.record': 'Record',
		'common.strings.rank': 'Rang',
		'common.strings.wins': 'Victoires',
		'common.strings.losses': 'Défaites',
		'common.strings.gdpr': 'RGPD',
		'common.strings.participantList': 'LISTE DES PARTICIPANTS',
		'common.strings.round': 'ROUND {roundNumber}',
		'common.strings.qualified': 'QUALIFIÉ',
		'common.strings.eliminated': 'ÉLIMINÉ',
		'common.strings.checkin': 'Enregistrement',
		'common.button.confirm': 'Confirmer',
		'common.button.submit': 'Envoyer',
		'common.button.cancel': 'Annuler',
		'common.button.viewEvent': "Voir l'événement",
		'common.button.viewAll': 'Voir tout',
		'common.button.backToEvent': "Retour à l'événement",
		'common.button.goBack': 'Retour',
		'common.button.inviteMembers': 'Choisir une équipe',
		'common.button.ready': "C'est parti !",
		'common.button.skip': 'Plus tard',
		'common.button.save': 'Sauvegarder',
		'common.button.saveChanges': 'Enregistrer',
		'common.button.back': 'Retour',
		'common.button.register': "S'inscrire",
		'common.button.pickTeam': 'Choisir une équipe',
		'common.button.leaveTeam': "Quitter l'équipe",
		'common.button.createTeam': "Créer l'équipe",
		'common.strings.ready': 'Prêt',
		'common.strings.notReady': 'Pas prêt',
		'common.button.done': 'Terminé',
		'common.strings.january': 'Janvier',
		'common.strings.february': 'Février',
		'common.strings.march': 'Mars',
		'common.strings.april': 'Avril',
		'common.strings.may': 'Mai',
		'common.strings.june': 'Juin',
		'common.strings.july': 'Juillet',
		'common.strings.august': 'Août',
		'common.strings.september': 'Septembre',
		'common.strings.october': 'Octobre',
		'common.strings.november': 'Novembre',
		'common.strings.december': 'Décembre',
		'common.strings.contactSupport': "Contacter l'assistance",
		'common.strings.error.required': 'Champ obligatoire',
		'common.strings.success': 'Et voilà !',
		'common.strings.ohNo': 'Oh, non !',
		'common.strings.wait': 'Hé, attendez !',
		'common.strings.tooltip.discord':
			'Vous pouvez utiliser le serveur Discord officiel du Championnat du monde Clash of Clans pour communiquer avec les membres de votre équipe.',
		'common.strings.forfeitWin': 'VPF',
		'common.strings.forfeitLoss': 'DPF',
		'common.strings.bye': 'BYE',
		'common.strings.teamInvite': 'Inviter des membres',
		'common.button.join': 'Rejoindre',
		'common.strings.discordConnected': 'Compte Discord connecté',
		'common.strings.selectedAsCaptain':
			'Vous avez été sélectionné pour représenter votre clan lors du championnat et avez été assigné au rôle de capitaine. Veuillez vous inscrire avant le {DATETIME}.',
		'common.strings.pending': "Doit s'inscrire",
		'common.strings.today': "Aujourd'hui",
		'common.strings.registrationClosesIn': 'Fermeture des inscriptions dans {time}',
		'common.strings.startsIn': '[X] commence dans {time}',
		'common.strings.endsIn': '[X] commence dans {time}',
		'common.strings.days': 'j',
		'common.strings.hours': 'h',
		'common.strings.minutes': 'min',
		'common.strings.seconds': 's',
		'common.strings.changeCaptain': 'Changer de capitaine',
		'common.strings.chooseCaptain': 'Choisir le capitaine',
		'common.strings.backToHub': 'Retour au portail du tournoi',
		'common.strings.missingCaptainLeader':
			"Votre équipe n'a pas de capitaine. Vous devez choisir un capitaine pour pouvoir participer.",
		'common.strings.missingCaptain':
			"Votre équipe n'a pas de capitaine. Demandez au chef du clan de choisir un capitaine.",
		'common.strings.captainRoleMismatchPersonal':
			"Vous êtes capitaine mais nous n'êtes pas chef de clan ou chef adjoint. Demandez au chef de votre clan de vous promouvoir ou choisissez un nouveau capitaine",
		'common.strings.captainRoleMismatchLeader':
			"Votre capitaine n'est pas chef de clan ou chef adjoint. Veuillez promouvoir le capitaine au rang de chef ou de chef adjoint, ou veuillez choisir un autre capitaine.",
		'common.strings.captainRoleMismatch':
			"Votre capitaine n'est pas chef ou chef adjoint. Demandez au chef de votre clan de promouvoir le capitaine au rang de chef ou de chef adjoint, ou de choisir un autre capitaine.",
		'common.strings.rosterIncompleteLeader':
			"Vous avez invité des joueurs qui ne sont pas encore inscrits. Demandez aux membres de l'équipe de s'inscrire.",
		'common.strings.rosterIncomplete':
			"Un ou plusieurs membres de l'équipe n'ont pas terminé leur inscription. Demandez-leur de s'inscrire dès que possible.",
		'common.strings.rosterReady':
			"Votre équipe est prête à jouer ! Le capitaine d'équipe est chargé de l'enregistrement. Bonne chance !",
		'common.button.next': 'Suivant',
		'common.strings.leader': 'Chef',
		'common.strings.coLeader': 'Chef adjoint',
		'common.strings.elder': 'Aîné',
		'common.strings.member': 'Membre',
		'common.errors.critical': "Une erreur est survenue. Veuillez redémarrer l'application.",
		'common.button.startWar': 'DÉCLARER LA GUERRE',
		'common.strings.statusRegRosterCaptain':
			"Fermeture des inscriptions : {DATETIME}.<BR/>Lorsque tous les membres sont inscrits, verrouillez votre équipe en appuyant sur Verrouiller l'équipe ! Après le verrouillage, il n'est plus possible de quitter le clan.",
		'common.strings.statusRegRosterMember':
			"Vous avez été sélectionné pour représenter l'équipe ! Les inscriptions ferment à {DATETIME}. Terminez l'inscription et rendez-vous dans l'onglet Mon équipe pour suivre le statut de votre équipe.",
		'common.strings.statusRegClosedNotMember':
			"L'équipe qui représente votre clan a été sélectionnée. Les inscriptions ferment le {DATETIME}. Suivez le parcours de votre clan dans l'onglet Compétition !",
		'common.strings.opponentTeamCheckInOpen':
			"Votre adversaire n'a pas encore déclaré la guerre.",
		'common.strings.opponentTeamCheckedIn': 'Votre adversaire est prêt à déclarer la guerre.',
		'common.strings.currentTeamCheckInOpen': "Votre équipe n'a pas encore déclaré la guerre.",
		'common.strings.currentTeamCheckedIn': 'Votre équipe est prête à déclarer la guerre.',
		'common.strings.opponentTeamMissedCheckedIn':
			"Votre adversaire ne s'est pas présenté à temps.",
		'common.strings.currentTeamMissedCheckIn': "Votre équipe ne s'est pas présentée à temps.",
		'common.button.tournamentCheckin': 'Enregistrement au tournoi',
		'common.strings.tooltipAttackOrder':
			"Les deux équipes doivent suivre l'ordre d'attaque (<strong>règle 3.2.3 du règlement officiel</strong>).<br/><br/>",
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			"Si votre adversaire ne suit pas l'ordre d'attaque établi, ouvrez un ticket et signalez votre match sur Discord.",
		'common.strings.dayTwoAttackOrder5v5':
			"<u>Ce match doit suivre un ordre d'attaque.</u><br/><strong>{HOMETEAM} attaque</strong> lorsqu'il reste 37, 29, 21, 13 et 5 minutes à la guerre.<br/><strong>{AWAYTEAM} attaque</strong> lorsqu'il reste 33, 25, 17, 9 et 1 minute à la guerre.",
		'common.button.lockRoster': 'Verrouiller l’équipe',
		'common.strings.tooltip.notPartOfClan':
			'Ce membre ne fait pas partie du clan actuellement.',
		'common.strings.locked': 'Équipe verrouillée',
		'common.strings.notLocked': 'Équipe non verrouillée',
		'common.homeMessage.getReady':
			'Préparez-vous pour le début du Championnat du monde Clash of Clans 2026 !',
		'common.homeMessage.registerAndSelectATeam':
			'Inscrivez-vous et sélectionnez {rosterMinSize} membres pour représenter votre clan lors du championnat du monde Clash of Clans.',
		'common.homeMessage.leaderHasntRegisteredYet':
			"Le chef de votre clan ne s'est pas encore inscrit au championnat du monde Clash of Clans.",
		'common.homeMessage.thNotHighEnough':
			"Vous devez avoir atteint le niveau 18 de l'hôtel de ville pour participer.",
		'common.homeMessage.clanRequired':
			"Vous devez faire partie d'un clan pour participer au championnat du monde Clash of Clans.",
		'common.homeMessage.rosterNotComplete.leader':
			"Pour verrouiller l'équipe, tous les membres doivent faire partie du clan, avoir été sélectionnés et s'être inscrits. Si un joueur quitte l'équipe avant le verrouillage, il devra à nouveau être sélectionné par le chef de clan. Une fois l'équipe verrouillée, les joueurs peuvent quitter et rejoindre le clan sans avoir à être à nouveau sélectionnés.",
		'common.homeMessage.rosterNotComplete.captain':
			"Pour verrouiller l'équipe, tous les membres doivent faire partie du clan, avoir été sélectionnés et s'être inscrits. Si un joueur quitte l'équipe avant le verrouillage, il devra à nouveau être sélectionné par le chef de clan. Une fois l'équipe verrouillée, les joueurs peuvent quitter et rejoindre le clan sans avoir à être à nouveau sélectionnés.",
		'common.homeMessage.rosterNotComplete.member':
			"Vous avez été sélectionné pour représenter l'équipe ! Remarque : si vous quittez le clan avant le verrouillage de l'équipe, le chef de clan devra à nouveau vous sélectionner pour participer. Une fois l'équipe verrouillée, vous pouvez quitter et rejoindre le clan sans avoir à être à nouveau sélectionné.",
		'common.homeMessage.rosterNotComplete.fallback':
			"L'équipe qui représente votre clan n'a pas encore été sélectionnée.",
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			"Au moins {rosterMinSize} joueurs de l'équipe ont terminé leur inscription. Le capitaine doit maintenant verrouiller l'équipe pour participer aux matchs. L'équipe ne peut plus être modifiée après le verrouillage.",
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			"Au moins {rosterMinSize} joueurs de l'équipe ont terminé leur inscription. Vous devez maintenant verrouiller l'équipe pour participer aux matchs. L'équipe ne peut plus être modifiée après le verrouillage.",
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			"Le capitaine doit verrouiller l'équipe pour participer aux matchs classés. L'équipe ne peut plus être modifiée après le verrouillage.",
		'common.homeMessage.rosterLocked':
			"Au moins {rosterMinSize} joueurs de l'équipe ont terminé leur inscription et l'équipe est verrouillée ! Lorsque la compétition commence, le capitaine peut appuyer sur Trouver un match pour trouver des adversaires. Tous les joueurs doivent être DANS LE CLAN, et le clan ne peut PAS être dans une autre guerre pendant un match du Championnat du monde. Les joueurs peuvent participer aux guerres de clans classiques et à la ligue de guerre de clans dans d'autres clans, mais ne peuvent pas être dans une guerre amicale pendant un match du Championnat du monde.",
		'common.homeMessage.rosterLocked.captain':
			"Au moins {rosterMinSize} joueurs de l'équipe ont terminé leur inscription et l'équipe est verrouillée ! Lorsque la compétition commence, vous pouvez appuyer sur Trouver un match pour trouver des adversaires. Tous les joueurs doivent être DANS LE CLAN, et le clan ne peut PAS être dans une autre guerre pendant un match du Championnat du monde. Les joueurs peuvent participer aux guerres de clans classiques et à la ligue de guerre de clans dans d'autres clans, mais ne peuvent PAS être dans une guerre amicale pendant un match du Championnat du monde.",
		'common.homeMessage.ladderInProgress':
			'La compétition classée a commencé ! Le capitaine peut appuyer sur Trouver un match pour trouver des adversaires. Remarque : tous les joueurs doivent faire partie du clan et ne doivent pas avoir commencé une guerre active ou amicale.',
		'common.homeMessage.ladderInProgress.captain':
			'La compétition classée a commencé ! Vous pouvez appuyer sur Trouver un match pour trouver des adversaires. Remarque : tous les joueurs doivent faire partie du clan et ne doivent pas avoir commencé une guerre active ou amicale. Assurez-vous que tous les membres sont prêts à jouer avant de trouver un match.',
		'common.homeMessage.followTeam':
			"Suivez le parcours de votre équipe dans l'onglet Compétition !",
		'common.homeMessage.finishedTop90.captain':
			"Si votre rang en Classé est égal ou supérieur à 170, rendez-vous sur Discord pour suivre les annonces. Les 128 meilleures équipes accéderont aux qualifications mensuelles. Les joueurs doivent être de retour dans le clan avant le début de l'enregistrement.",
		'common.homeMessage.finishedTop90.member':
			"Si votre rang en Classé est égal ou supérieur à 170, rendez-vous sur Discord pour suivre les annonces. Les 128 meilleures équipes accéderont aux qualifications mensuelles. Le capitaine est responsable de l'enregistrement au match.",
		'common.homeMessage.preSegment.postLadder.captain':
			"Les équipes qualifiées pour la prochaine étape de la compétition doivent s'enregistrer au match. Rappel : les joueurs doivent être de retour dans le clan avant le début de l'enregistrement. Vous êtes responsable de l’enregistrement au match. La période d'enregistrement est de 5 minutes.",
		'common.homeMessage.preSegment.postLadder.member':
			"Les équipes qualifiées pour la prochaine étape de la compétition doivent s'enregistrer au match. Rappel : les joueurs doivent être de retour dans le clan avant le début de l'enregistrement. Le capitaine est responsable de l'enregistrement au match. La période d'enregistrement est de 5 minutes.",
		'common.homeMessage.tournamentInProgress.captain':
			'Le tournoi est en cours ! Enregistrez-vous dans les 5 minutes après le début de chaque round en appuyant sur Enregistrement. Consultez le Discord Clash of Clans Esports pour les informations importantes du tournoi !',
		'common.homeMessage.tournamentInProgress.member':
			'Le tournoi est en cours ! Le capitaine dispose de 5 minutes après le début de chaque round pour appuyer sur Enregistrement. Consultez le Discord Clash of Clans Esports pour les informations importantes du tournoi !',
		'common.homeMessage.phase1InProgress':
			'Le Championnat du monde 2026 est en cours. Pour ne rien manquer du reste du tournoi, consultez régulièrement l\'onglet Compétition ou suivez <a href="https://twitter.com/CoCEsports">@CoCEsports</a> !',
		'common.strings.goodLuckMessage':
			"Félicitations ! Bonne chance pour votre aventure jusqu'à la finale du mondial !",
		'common.strings.phaseOneComplete':
			'La compétition du mois est terminée. Suivez <a href="https://twitter.com/CoCEsports">@CoCEsports</a> pour en savoir plus !',
		'common.strings.ladderEndsIn': 'La saison classée se termine dans',
		'common.strings.matchCheckinStartsIn': "L'enregistrement au match commence dans",
		'common.strings.matchCheckinEndsIn': "L'enregistrement au match se termine dans",
		'common.homeMessage.teamIncomplete':
			"Les inscriptions pour la compétition sont terminées. Comme votre équipe ne s'est pas inscrite à temps, elle ne pourra pas participer à la compétition du mois.",
		'common.homeMessage.preSegment.ladder.captain':
			"Si votre rang en Classé est égal ou supérieur à 170, rendez-vous sur Discord pour suivre les annonces. Les 128 meilleures équipes accéderont aux qualifications mensuelles. Les joueurs doivent être de retour dans le clan avant le début de l'enregistrement.",
		'common.homeMessage.preSegment.ladder.member':
			"Si votre rang en Classé est égal ou supérieur à 170, rendez-vous sur Discord pour suivre les annonces. Les 128 meilleures équipes accéderont aux qualifications mensuelles. Le capitaine est responsable de l'enregistrement au match.",
		'common.button.leaveQueue': 'Quitter la file',
		'common.button.findMatch': 'Trouver un match',
		'common.strings.phase': 'ÉTAPE {#}',
		'common.strings.lowerBracket': 'Bracket inférieur',
		'common.strings.upperBracket': 'Bracket supérieur',
		'common.strings.noMatches': 'Aucun match',
		'common.strings.noData': 'Aucune donnée',
		'common.button.manageRoster': 'Gérer la composition',
		'common.button.withdraw': 'Se retirer',
		'common.strings.readyToPlay': 'Votre inscription est terminée. Vous êtes prêt(e) à jouer !',
		'common.strings.registration.opens': 'OUVERTURE DES INSCRIPTIONS:',
		'common.strings.registration.closes': 'FERMETURE DES INSCRIPTIONS:',
		'common.strings.worldChampionshipFinals': 'Finale du championnat du monde',
		'common.strings.lastChanceQualifier': 'Qualifications de la dernière chance',
		'common.strings.starts': 'Début',
		'common.strings.ends': 'Fin',
		'common.strings.eliminationType': "Type d'élimination :",
		'common.strings.group': 'Groupe',
		'common.strings.notPicked5': 'Choisissez au moins {rosterMinSize} membres du clan',
		'common.strings.notPickedLeader':
			'Vous devez sélectionner au moins 1 chef de clan ou chef adjoint',
		'common.button.accept': 'Accepter',
		'common.button.decline': 'Refuser',
		'common.strings.gamesPlayed': 'PJ',
		'common.strings.wars': 'Guerres',
		'common.strings.worldFinalsFinalists': 'World Championship Finalists',
		'common.strings.followNow': 'Suivez Ici !',
		'common.strings.worldFinalsWinner':
			'Félicitations à <TEAM>, nos nouveaux champions du monde 2026 !<br/><br/>Nous espérons vous revoir sur scène en 2026.',
		'common.starts': 'Début',
		'common.ends': 'Fin',
		'common.eliminationType': "Type d'élimination :",
		'common.eliminationType.doubleElim': "Type d'élimination : élimination double",
		'common.eliminationType.swiss': "Type d'élimination : système suisse",
		'common.eliminationType.ladder': "Type d'élimination : mode classé",
		'common.strings.maxLimitMatchesHeader': 'Limite de matchs atteinte.',
		'common.strings.maxLimitMatchesPerDay':
			'Vous avez déjà joué 6 matchs au cours des dernières 24 heures. Veuillez réessayer plus tard.',
		'common.strings.homeTeam': 'Accueil',
		'common.strings.awayTeam': 'Indisponible',
		'common.strings.wfDay1': 'Finale du Championnat du monde - Jour 1',
		'common.strings.wfDay2': 'Finale du Championnat du monde - Jour 2',
		'common.strings.wfDay3': 'Finale du Championnat du monde - Jour 3',
		'common.strings.wfHeroText':
			'Les 8 meilleures équipes du monde s\'affronteront lors de la finale du Championnat du monde Clash of Clans à Atlanta, dans l\'État de Géorgie, pour une cagnotte totale de 700 000 $ et le titre de Champions du monde 2026 !<br /><br>\n\nConnectez-vous sur le <a href="[EVENT LINK]" target=""_blank"">site des événements</a> du 31 octobre au 2 novembre pour gagner des récompenses en jeu !',
		'common.strings.wfCongrats':
			'Félicitations à [TEAM] qui ont remporté le titre de champions du monde 2026 ! Le Championnat du monde Clash of Clans revient en 2026, nous avons hâte de vous retrouver ! Suivez nos comptes e-sport Twitter et Instagram pour ne rien manquer des actualités !',
		'common.strings.seeYouNextYear':
			'Félicitations à [TEAM], nos nouveaux champions du monde ! Le Championnat du monde Clash of Clans revient en 2026, nous avons hâte de vous retrouver ! Suivez nos comptes e-sport <a href="https://twitter.com/CoCEsports">Twitter</a> et <a href="https://www.instagram.com/esportscoc">Instagram</a> pour ne rien manquer des actualités en 2026 !\n',
		'common.strings.wfFinalists': 'FINALISTES DU CHAMPIONNAT DU MONDE 2026',
		'common.strings.wfHowToWatch':
			'Les huit meilleures équipes au monde s\'affrontent pour remporter le titre de champions du monde de Clash of Clans 2026 et la plus grosse partie de la cagnotte, qui s\'élève à 700 000 $ !<br /><br />Connectez-vous sur le <a href="https://event.supercell.com/clashofclans/fr">site des événements</a> du 14 au 15 novembre pour gagner des récompenses en jeu pendant que vous regardez la compétition !',
		'common.strings.wfSchedule':
			'Les équipes s\'affrontent dans un bracket à élimination double pour couronner les champions du monde 2026 de Clash of Clans.<br><br>\n\nDÉBUT DU JOUR 1 : 31 octobre [LOCAL TIME DAY 1]<br>\n\n- Matchs 1 - 6<br><br>\n\nDÉBUT DU JOUR 2 : 1er novembre [LOCAL TIME DAY 2]<br>\n\n- Matchs 7 - 12<br><br>\n\nDÉBUT DU JOUR 3 : 2 novembre [LOCAL TIME DAY 3]<br>\n\n- Matchs 13 - 15<br><br>\n\nSuivez l\'événement sur <a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/fr</a> pour récupérer des récompenses en jeu !',
		'common.strings.mfPrizes': 'CAGNOTTE DE LA FINALE MENSUELLE',
		'common.strings.championshipPrizes': 'CAGNOTTE DE LA FINALE DU CHAMPIONNAT',
		'common.message.selectFivePlayersForWar':
			'Choisissez les {rosterMinSize} joueurs qui participeront à la guerre.',
		'common.strings.selectFivePlayersForMq':
			"Veuillez confirmer les {rosterMinSize} joueurs qui participeront aux qualifications mensuelles et à la finale mensuelle. Seuls les {rosterMinSize} joueurs sélectionnés feront partie de l'équipe.",
		'common.strings.lcqWinner': 'Vainqueur des QDC',
		'common.strings.chinaQualifier': 'Qualifications de Chine',
		'common.strings.chinaWinner': 'Vainqueur de Chine',
		'common.strings.communityTournament': 'Tournoi de la communauté',
		'common.strings.chinaRegionalQualifier': 'Qualifications régionales chinoises',
		'common.strings.townHall': 'Hôtel de ville',
		'common.strings.townHallLevel': "Niveau de l'hôtel de ville",
		'common.button.waitMatchFinish': 'En attente de la fin du match',
		'common.strings.checkInMonthlyQualifier':
			'Inscrivez votre équipe aux qualifications mensuelles',
		'common.strings.checkedin': 'Enregistré',
		'common.strings.leaderboard': 'Classement',
		'common.strings.noResults': 'Aucun résultat',
		'common.thcup.worldChampionship': 'Coupe des hôtels de ville',
		'common.thcup.homeMessage.phase1InProgress':
			'La Coupe des hôtels de ville 2026 est en cours. Pour ne rien manquer du reste du tournoi, consultez régulièrement l\'onglet Compétition ou suivez <a href="https://twitter.com/CoCEsports">@CoCEsports</a> !',
		'common.thcup.homeMessage.getReady':
			'Préparez-vous pour le début des Coupes des hôtels de ville Clash of Clans !',
		'common.thcup.homeMessage.thNotHighEnough':
			'Vous devez avoir un hôtel de ville niveau 9, 12 ou 15  pour participer.',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			"Le chef de votre clan ne s'est pas encore inscrit à la Coupe des hôtels de ville.",
		'common.thcup.homeMessage.registerAndSelectATeam':
			'Inscrivez-vous et sélectionnez au moins {rosterMinSize} membres pour représenter votre clan lors de la Coupe des hôtels de ville Clash of Clans.',
		'common.thcup.homeMessage.clanRequired':
			"Vous devez faire partie d'un clan pour participer à la Coupe des hôtels de ville Clash of Clans.",
		'common.thcup.homeMessage.rosterLocked':
			"Au moins {rosterMinSize} joueurs de l'équipe ont terminé leur inscription et l'équipe est verrouillée ! Lorsque la compétition commence, le capitaine peut appuyer sur Trouver un match pour trouver des adversaires. Rappel : tous les joueurs doivent être DANS LE CLAN, et le clan ne peut PAS être dans une autre guerre pendant un match de Coupe des hôtels de ville. Les joueurs peuvent participer aux guerres de clans classiques et à la ligue de guerre de clans dans d'autres clans, mais ne peuvent pas être dans une guerre amicale pendant un match de Coupe des hôtels de ville.",
		'common.thcup.homeMessage.rosterLocked.captain':
			"Au moins {rosterMinSize} joueurs de l'équipe ont terminé leur inscription et l'équipe est verrouillée ! Lorsque la compétition commence, vous pouvez appuyer sur Trouver un match pour trouver des adversaires. Rappel : tous les joueurs doivent être DANS LE CLAN, et le clan ne peut PAS être dans une autre guerre pendant un match de Coupe des hôtels de ville. Les joueurs peuvent participer aux guerres de clans classiques et à la ligue de guerre de clans dans d'autres clans, mais ne peuvent pas être dans une guerre amicale pendant un match de Coupe des hôtels de ville.",
		'common.thcup.homeMessage.preSegment.ladder.captain':
			"Si votre rang en Classé est égal ou supérieur à 8e, rendez-vous sur Discord pour suivre les annonces. Les 8 meilleures équipes se qualifient pour la finale. Les joueurs doivent être de retour dans le clan avant le début de l'enregistrement.",
		'common.thcup.homeMessage.preSegment.ladder.member':
			"Si votre rang en Classé est égal ou supérieur à 8e, rendez-vous sur Discord pour suivre les annonces. Les 8 meilleures équipes se qualifient pour la finale. Le capitaine est responsable de l'enregistrement au match.",
		'common.thcup.homeMessage.finishedTop90.captain':
			"Si votre rang en Classé est égal ou supérieur à 8e, rendez-vous sur Discord pour suivre les annonces. Les 8 meilleures équipes se qualifient pour la finale. Les joueurs doivent être de retour dans le clan avant le début de l'enregistrement.",
		'common.thcup.homeMessage.finishedTop90.member':
			"Si votre rang en Classé est égal ou supérieur à 8e, rendez-vous sur Discord pour suivre les annonces. Les 8 meilleures équipes se qualifient pour la finale. Le capitaine est responsable de l'enregistrement au match.",
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			"Les équipes qualifiées pour la prochaine étape de la compétition doivent s'enregistrer au match. Rappel : les joueurs doivent être de retour dans le clan avant le début de l'enregistrement. Vous êtes responsable de l’enregistrement au match. La période d'enregistrement est de 5 minutes.",
		'common.thcup.homeMessage.preSegment.postLadder.member':
			"Les équipes qualifiées pour la prochaine étape de la compétition doivent s'enregistrer au match. Rappel : les joueurs doivent être de retour dans le clan avant le début de l'enregistrement. Le capitaine est responsable de l'enregistrement au match. La période d'enregistrement est de 5 minutes.",
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'Le tournoi est en cours ! Appuyez sur Enregistrement dans les 5 minutes avant le début de chaque round. Consultez le Discord Clash of Clans Esports pour les informations importantes du tournoi !',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'Le tournoi est en cours ! Le capitaine doit appuyer sur Enregistrement dans les 5 minutes avant le début de chaque round. Consultez le Discord Clash of Clans Esports pour les informations importantes du tournoi !',
		'common.thcup.strings.stage1': 'Mode Classé',
		'common.thcup.strings.stage2': 'Qualifications mensuelles',
		'common.thcup.strings.mfPrizes': 'CAGNOTTE DE LA FINALE',
		'common.strings.dayTwoAttackOrder3v3':
			"<u>Ce match doit suivre un ordre d'attaque.</u><br/><strong>{HOMETEAM} attaque</strong> lorsqu'il reste 21, 13 et 5 minutes à la guerre.<br/><strong>{AWAYTEAM} attaque</strong> lorsqu'il reste 17, 9 et 1 minute à la guerre.",
		'common.strings.dayTwoAttackOrder2v2':
			"<u>Ce match doit suivre un ordre d'attaque.</u><br/><strong>{HOMETEAM} attaque</strong> lorsqu'il reste 13 et 5 minutes à la guerre.<br/><strong>{AWAYTEAM} attaque</strong> lorsqu'il reste 9 et 1 minute à la guerre.",
	},
	it: {
		'common.strings.home': 'HOME',
		'common.strings.schedule': 'PROGRAMMA',
		'common.strings.stage1': 'Qualificazione aperta a tutti',
		'common.strings.stage2': 'Qualificazione mensile',
		'common.strings.stage3': 'Finali mensili',
		'common.strings.stage4': '4ª fase',
		'common.strings.stage5': '5ª tappa',
		'common.strings.championshipFinals': 'Finali del Torneo mondiale',
		'common.strings.prizes': 'MONTEPREMI',
		'common.strings.goldenTicketWinners': "POSSESSORI DEI BIGLIETTI D'ORO",
		'common.strings.silverTicketWinners': "POSSESSORI DEI BIGLIETTI D'ARGENTO",
		'common.strings.roster': 'ROSA',
		'common.strings.captain': 'Capitano',
		'common.strings.upcomingMatches': 'SCONTRO IN PROGRAMMA',
		'common.strings.pastMatches': 'SCONTRI COMPLETATI',
		'common.strings.ladderLeaderboard': 'CLASSIFICA',
		'common.strings.points': 'Punti',
		'common.strings.record': 'Record',
		'common.strings.rank': 'Posizione',
		'common.strings.wins': 'Vittorie',
		'common.strings.losses': 'Sconfitte',
		'common.strings.gdpr': 'RGPD',
		'common.strings.participantList': 'LISTA DELLE PARTECIPANTI',
		'common.strings.round': '{roundNumber}º TURNO',
		'common.strings.qualified': 'QUALIFICATE',
		'common.strings.eliminated': 'ELIMINATE',
		'common.strings.checkin': 'Registrazione',
		'common.button.confirm': 'Conferma',
		'common.button.submit': 'Invia',
		'common.button.cancel': 'Annulla',
		'common.button.viewEvent': 'Vedi evento',
		'common.button.viewAll': 'Vedi tutto',
		'common.button.backToEvent': "Torna all'evento",
		'common.button.goBack': 'Indietro',
		'common.button.inviteMembers': 'Scegli squadra',
		'common.button.ready': 'Tutto pronto!',
		'common.button.skip': 'Non ora',
		'common.button.save': 'Salva',
		'common.button.saveChanges': 'Salva modifiche',
		'common.button.back': 'Indietro',
		'common.button.register': 'Iscriviti',
		'common.button.pickTeam': 'Scegli squadra',
		'common.button.leaveTeam': 'Abbandona squadra',
		'common.button.createTeam': 'Crea squadra',
		'common.strings.ready': 'Pronto/a',
		'common.strings.notReady': 'Non pronto/a',
		'common.button.done': 'Fatto',
		'common.strings.january': 'Gennaio',
		'common.strings.february': 'Febbraio',
		'common.strings.march': 'Marzo',
		'common.strings.april': 'Aprile',
		'common.strings.may': 'Maggio',
		'common.strings.june': 'Giugno',
		'common.strings.july': 'Luglio',
		'common.strings.august': 'Agosto',
		'common.strings.september': 'Settembre',
		'common.strings.october': 'Ottobre',
		'common.strings.november': 'Novembre',
		'common.strings.december': 'Dicembre',
		'common.strings.contactSupport': "Contatta l'assistenza",
		'common.strings.error.required': 'Campo obbligatorio',
		'common.strings.success': 'Ben fatto!',
		'common.strings.ohNo': 'Oh no!',
		'common.strings.wait': 'Aspetta!',
		'common.strings.tooltip.discord':
			'Puoi usare il server ufficiale del Torneo mondiale di Clash of Clans su Discord per parlare con gli altri membri della tua squadra.',
		'common.strings.forfeitWin': 'V (A)',
		'common.strings.forfeitLoss': 'S (A)',
		'common.strings.bye': 'ESENTI',
		'common.strings.teamInvite': 'Invita membri',
		'common.button.join': 'Unisciti',
		'common.strings.discordConnected': 'Account Discord connesso',
		'common.strings.selectedAsCaptain':
			'Ti hanno scelto per rappresentare il clan nel Torneo mondiale in qualità di capitano. Iscriviti qui sotto entro questa data: {DATETIME}.',
		'common.strings.pending': 'Deve iscriversi',
		'common.strings.today': 'Oggi',
		'common.strings.registrationClosesIn': 'Chiusura delle iscrizioni tra {time}',
		'common.strings.startsIn': '[X] - Inizio tra {time}',
		'common.strings.endsIn': '[X] - Fine tra {time}',
		'common.strings.days': 'g',
		'common.strings.hours': 'h',
		'common.strings.minutes': 'm',
		'common.strings.seconds': 's',
		'common.strings.changeCaptain': 'Cambia il capitano',
		'common.strings.chooseCaptain': 'Scegli il capitano',
		'common.strings.backToHub': 'Torna al Portale del Torneo',
		'common.strings.missingCaptainLeader':
			'La squadra non ha un capitano. Devi sceglierne uno per poter gareggiare.',
		'common.strings.missingCaptain':
			'La squadra non ha un capitano. Chiedi al capo del clan di sceglierne uno.',
		'common.strings.captainRoleMismatchPersonal':
			"Sei il capitano della squadra, ma poiché non sei né un co-capo né il capo, chiedi a quest'ultimo di promuoverti o di scegliere un altro capitano.",
		'common.strings.captainRoleMismatchLeader':
			'Il capitano non è né il capo né un co-capo del clan. Scegli un nuovo capitano o promuovi quello attuale a capo o co-capo.',
		'common.strings.captainRoleMismatch':
			'Il capitano non è né il capo né un co-capo. Chiedi al capo del clan di promuovere il capitano a capo o co-capo, o di scegliere un nuovo capitano.',
		'common.strings.rosterIncompleteLeader':
			'Hai invitato giocatori che non si sono ancora iscritti. Chiedi ai membri della squadra di iscriversi.',
		'common.strings.rosterIncomplete':
			'Uno o più membri della squadra non si sono ancora iscritti. Chiedi a tutti di farlo il prima possibile.',
		'common.strings.rosterReady':
			'La squadra è pronta a gareggiare, ma prima il capitano deve registrarsi. Buona fortuna!',
		'common.button.next': 'Pross.',
		'common.strings.leader': 'Capo',
		'common.strings.coLeader': 'Co-capo',
		'common.strings.elder': 'Anziano',
		'common.strings.member': 'Membro',
		'common.errors.critical': "Si è verificato un errore critico. Riavvia l'applicazione.",
		'common.button.startWar': 'AVVIA GUERRA',
		'common.strings.statusRegRosterCaptain':
			'Le iscrizioni chiuderanno in data {DATETIME}.<BR/> Una volta che tutti i membri si saranno iscritti, conferma la squadra premendo il pulsante apposito! Una volta che la squadra è confermata, non è possibile lasciare temporaneamente il clan.',
		'common.strings.statusRegRosterMember':
			'Ti hanno scelto per rappresentare la squadra! Le iscrizioni chiuderanno in data {DATETIME}. Completa l\'iscrizione e accedi alla scheda "La mia squadra" per seguirne lo stato.',
		'common.strings.statusRegClosedNotMember':
			'La selezione della squadra che rappresenterà il clan è stata completata e le iscrizioni chiuderanno in data {DATETIME}. Segui il percorso del clan dalla scheda "Competizione"!',
		'common.strings.opponentTeamCheckInOpen':
			'L\'avversario non ha ancora premuto "AVVIA GUERRA".',
		'common.strings.opponentTeamCheckedIn': 'L\'avversario è pronto a premere "AVVIA GUERRA".',
		'common.strings.currentTeamCheckInOpen': 'La squadra non ha ancora premuto "AVVIA GUERRA".',
		'common.strings.currentTeamCheckedIn': 'La squadra è pronta a premere "AVVIA GUERRA".',
		'common.strings.opponentTeamMissedCheckedIn':
			"L'avversario non si è registrato allo scontro nel periodo indicato.",
		'common.strings.currentTeamMissedCheckIn':
			'La squadra non si è registrata allo scontro nel periodo indicato.',
		'common.button.tournamentCheckin': 'Registrazione al torneo',
		'common.strings.tooltipAttackOrder':
			"Entrambe le squadre devono rispettare l'ordine d'attacco corretto, <strong>secondo quanto illustrato nel paragrafo 3.2.3 del regolamento ufficiale</strong><br/><br/>.",
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			"Se la squadra avversaria non sta rispettando l'ordine, apri un ticket e segnala lo scontro su Discord.",
		'common.strings.dayTwoAttackOrder5v5':
			"<u>Questo scontro prevede un ordine d'attacco preciso.</u><br/><strong>{HOMETEAM} sferrerà attacchi</strong> a 37 minuti, 29 minuti, 21 minuti, 13 minuti e 5 minuti dalla fine della guerra.<br/><strong>{AWAYTEAM} sferrerà attacchi</strong> a 33 minuti, 25 minuti, 17 minuti, 9 minuti e un minuto dalla fine della guerra.",
		'common.button.lockRoster': 'Conferma la squadra',
		'common.strings.tooltip.notPartOfClan':
			'Questo membro della squadra al momento non è nel clan.',
		'common.strings.locked': 'La squadra è confermata',
		'common.strings.notLocked': 'La squadra non è confermata',
		'common.homeMessage.getReady':
			"Preparati all'inizio del Torneo mondiale di Clash of Clans del 2026!",
		'common.homeMessage.registerAndSelectATeam':
			'Iscriviti e scegli {rosterMinSize} membri del clan che lo rappresentino nella tua squadra del Torneo mondiale di Clash of Clans.',
		'common.homeMessage.leaderHasntRegisteredYet':
			'Il capo del clan non si è ancora iscritto al Torneo mondiale di Clash of Clans.',
		'common.homeMessage.thNotHighEnough':
			'Per partecipare, il municipio deve essere di livello 18.',
		'common.homeMessage.clanRequired':
			'Devi far parte di un clan per partecipare al Torneo mondiale di Clash of Clans.',
		'common.homeMessage.rosterNotComplete.leader':
			'La squadra può essere confermata solo se i suoi membri FANNO PARTE DEL CLAN, SONO STATI SELEZIONATI e SI SONO ISCRITTI. I membri della squadra che lasciano il clan prima che la squadra sia stata confermata dovranno essere selezionati nuovamente dal capo del clan per farne parte. Una volta che la squadra è stata confermata, i suoi membri possono lasciare il clan e rientrarci senza dover essere selezionati nuovamente.',
		'common.homeMessage.rosterNotComplete.captain':
			'La squadra può essere confermata solo se tutti i suoi membri FANNO PARTE DEL CLAN, SONO STATI SELEZIONATI e SI SONO ISCRITTI. I membri della squadra che lasciano il clan prima che la squadra sia stata confermata dovranno essere selezionati nuovamente dal capo del clan per farne parte. Una volta che la squadra è stata confermata, i suoi membri possono lasciare il clan e rientrarci senza dover essere selezionati nuovamente.',
		'common.homeMessage.rosterNotComplete.member':
			"Ti hanno scelto per rappresentare la squadra! Ricorda che se lasci il clan prima che la squadra venga confermata, il capo del clan dovrà selezionarti nuovamente per farti partecipare all'evento. Una volta che la squadra è stata confermata, puoi lasciare il clan e rientrarci senza il bisogno di farti selezionare nuovamente.",
		'common.homeMessage.rosterNotComplete.fallback':
			'La selezione della squadra che rappresenterà il clan non è stata ancora completata.',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			"Almeno {rosterMinSize} membri della tua squadra hanno completato l'iscrizione. Il capitano della squadra deve confermarla affinché i suoi membri possano partecipare agli scontri. Una volta completata quest'operazione, la formazione della squadra non potrà più essere modificata.",
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			"Almeno {rosterMinSize} membri della tua squadra hanno completato l'iscrizione. Devi confermare la squadra per poter disputare scontri classificati. Una volta completata quest'operazione, la formazione della squadra non potrà più essere modificata.",
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			"Il capitano della squadra deve confermarla, affinché i suoi membri possano disputare scontri classificati. Una volta completata quest'operazione, la formazione della squadra non potrà più essere modificata.",
		'common.homeMessage.rosterLocked':
			'Almeno {rosterMinSize} membri della squadra hanno completato l\'iscrizione e la squadra è stata confermata! Una volta che la competizione avrà inizio, il capitano potrà far partecipare la squadra agli scontri selezionando "Trova scontro". Ricorda che in uno scontro del Torneo mondiale tutti i membri devono FAR PARTE DEL CLAN e il clan NON PUÒ disputare una guerra di altro tipo in quel momento. I giocatori possono partecipare alle normali guerre tra clan e alle battaglie della lega della guerra con altri clan, ma NON POSSONO partecipare a una guerra amichevole durante uno scontro del Torneo mondiale.',
		'common.homeMessage.rosterLocked.captain':
			'Almeno {rosterMinSize} membri della squadra hanno completato l\'iscrizione e la squadra è stata confermata! Una volta che la competizione avrà inizio, potrai far partecipare la squadra agli scontri selezionando "Trova scontro". Ricorda che in uno scontro del Torneo mondiale tutti i membri devono FAR PARTE DEL CLAN e il clan NON PUÒ disputare una guerra di altro tipo in quel momento. I giocatori possono partecipare alle normali guerre tra clan e alle battaglie della lega della guerra con altri clan, ma NON POSSONO partecipare a una guerra amichevole durante uno scontro del Torneo mondiale.',
		'common.homeMessage.ladderInProgress':
			'La competizione è iniziata! Il capitano della squadra può trovare uno scontro classificato premendo il pulsante "Trova scontro". Ricorda che l\'abbinamento sarà possibile solo se tutti i membri FANNO PARTE DEL CLAN e non stanno disputando una guerra amichevole o una attiva in quel momento.',
		'common.homeMessage.ladderInProgress.captain':
			'La competizione è iniziata! Puoi trovare uno scontro classificato premendo il pulsante "Trova scontro". Ricorda che l\'abbinamento sarà possibile solo se tutti i membri FANNO PARTE DEL CLAN e non stanno disputando una guerra amichevole o una attiva in quel momento. Assicurati che tutti i membri siano pronti a giocare prima di cercare uno scontro.',
		'common.homeMessage.followTeam':
			'Puoi seguire i progressi della squadra dalla scheda "Competizione"!',
		'common.homeMessage.finishedTop90.captain':
			"Se il tuo piazzamento negli scontri classificati rientra tra le prime 170 posizioni, visita Discord per leggere un annuncio importante. Le squadre che occuperanno i primi 128 posti in classifica avanzeranno alla Qualificazione mensile. I membri della squadra DEVONO tornare nel clan prima dell'inizio delle registrazioni agli scontri.",
		'common.homeMessage.finishedTop90.member':
			'Se il tuo piazzamento negli scontri classificati rientra tra le prime 170 posizioni, visita Discord per leggere un annuncio importante. Le squadre che occuperanno i primi 128 posti in classifica avanzeranno alla Qualificazione mensile. Il capitano della squadra è responsabile della registrazione agli scontri.',
		'common.homeMessage.preSegment.postLadder.captain':
			"Le squadre che si sono qualificate per la tappa successiva della competizione dovranno completare la registrazione agli scontri. Ricorda che i membri della squadra DEVONO tornare nel clan prima dell'inizio delle registrazioni agli scontri. Sei responsabile della registrazione allo scontro. Il periodo per le registrazioni agli scontri è di cinque minuti.",
		'common.homeMessage.preSegment.postLadder.member':
			"Le squadre che si sono qualificate per la tappa successiva della competizione dovranno completare la registrazione agli scontri. Ricorda che i membri della squadra DEVONO tornare nel clan prima dell'inizio delle registrazioni agli scontri. Il capitano della squadra è responsabile della registrazione agli scontri. Il periodo per le registrazioni agli scontri è di cinque minuti.",
		'common.homeMessage.tournamentInProgress.captain':
			'Il torneo è in corso. Premi il pulsante "Registrazione" nei cinque minuti antecedenti all\'inizio di ogni turno. Unisciti al server Discord "Clash of Clans Esports" per ricevere tutte le informazioni salienti sul torneo!',
		'common.homeMessage.tournamentInProgress.member':
			'Il torneo è in corso. Il capitano della squadra deve premere il pulsante "Registrazione" nei cinque minuti antecedenti all\'inizio di ogni turno. Unisciti al server Discord "Clash of Clans Esports" per ricevere tutte le informazioni salienti sul torneo!',
		'common.homeMessage.phase1InProgress':
			'Il Torneo mondiale del 2026 è in corso. Puoi seguire il resto degli scontri dalla scheda "COMPETIZIONE" o seguendo il canale (in inglese) <a href="https://twitter.com/CoCEsports">@CoCEsports</a>!',
		'common.strings.goodLuckMessage':
			'Congratulazioni e buona fortuna con il resto delle Finali del Torneo mondiale!',
		'common.strings.phaseOneComplete':
			'Per questo mese, le competizioni del Torneo sono terminate. Segui il canale <a href="https://twitter.com/CoCEsports">@CoCEsports</a> per maggiori informazioni al riguardo!',
		'common.strings.ladderEndsIn': 'Gli scontri classificati terminano tra',
		'common.strings.matchCheckinStartsIn': 'Le registrazioni agli scontri iniziano tra',
		'common.strings.matchCheckinEndsIn': 'Le registrazioni agli scontri terminano tra',
		'common.homeMessage.teamIncomplete':
			'Le iscrizioni per la competizione sono chiuse e, poiché la tua squadra non si è iscritta in tempo, non potrà partecipare alla competizione di questo mese.',
		'common.homeMessage.preSegment.ladder.captain':
			"Se il tuo piazzamento negli scontri classificati rientra tra le prime 170 posizioni, visita Discord per leggere un annuncio importante. Le squadre che occuperanno i primi 128 posti in classifica avanzeranno alla Qualificazione mensile. I membri della squadra DEVONO tornare nel clan prima dell'inizio delle registrazioni agli scontri.",
		'common.homeMessage.preSegment.ladder.member':
			'Se il tuo piazzamento negli scontri classificati rientra tra le prime 170 posizioni, visita Discord per leggere un annuncio importante. Le squadre che occuperanno i primi 128 posti in classifica avanzeranno alla Qualificazione mensile. Il capitano della squadra è responsabile della registrazione agli scontri.',
		'common.button.leaveQueue': 'Abbandona la coda',
		'common.button.findMatch': 'Trova scontro',
		'common.strings.phase': '{#}ª FASE',
		'common.strings.lowerBracket': 'Gruppo dei perdenti',
		'common.strings.upperBracket': 'Gruppo dei vincitori',
		'common.strings.noMatches': 'Nessuno scontro',
		'common.strings.noData': 'Nessun dato',
		'common.button.manageRoster': 'Gestisci Squadra',
		'common.button.withdraw': 'Ritirati',
		'common.strings.readyToPlay': "L'iscrizione è andata a buon fine e sei pronto/a a giocare!",
		'common.strings.registration.opens': 'APERTURA DELLE ISCRIZIONI:',
		'common.strings.registration.closes': 'CHIUSURA DELLE ISCRIZIONI:',
		'common.strings.worldChampionshipFinals': 'Finali del Torneo mondiale',
		'common.strings.lastChanceQualifier': 'Ultime qualificazioni',
		'common.strings.starts': 'Inizio',
		'common.strings.ends': 'Fine',
		'common.strings.eliminationType': 'Formato:',
		'common.strings.group': 'Gruppo',
		'common.strings.notPicked5': 'Scegli almeno {rosterMinSize} membri del clan',
		'common.strings.notPickedLeader': 'Devi scegliere almeno un capo o co-capo del clan.',
		'common.button.accept': 'Accetta',
		'common.button.decline': 'Rifiuta',
		'common.strings.gamesPlayed': 'G',
		'common.strings.wars': 'Guerre',
		'common.strings.worldFinalsFinalists': 'Finalistes du Mondial',
		'common.strings.followNow': 'Segui Qui!',
		'common.strings.worldFinalsWinner':
			'Congratulazioni a <TEAM> per aver vinto il titolo di campione del mondo del 2026!<br/><br/>Ci vediamo al Torneo del 2026!',
		'common.starts': 'Inizio',
		'common.ends': 'Fine',
		'common.eliminationType': 'Formato:',
		'common.eliminationType.doubleElim': 'Formato: doppia eliminazione',
		'common.eliminationType.swiss': 'Formato: svizzero',
		'common.eliminationType.ladder': 'Formato: scontri classificati',
		'common.strings.maxLimitMatchesHeader': 'Limite di scontri raggiunto!',
		'common.strings.maxLimitMatchesPerDay':
			'Hai già partecipato a sei scontri nelle ultime 24 ore. Riprova più tardi.',
		'common.strings.homeTeam': 'Ospitanti',
		'common.strings.awayTeam': 'Ospiti',
		'common.strings.wfDay1': 'Finali del Torneo mondiale: prima giornata',
		'common.strings.wfDay2': 'Finali del Torneo mondiale: seconda giornata',
		'common.strings.wfDay3': 'Finali del Torneo mondiale: terza giornata',
		'common.strings.wfHeroText':
			'Le otto squadre migliori al mondo di Clash of Clans disputeranno le Finali mondiali del Torneo mondiale ad Atlanta, in Georgia, per vincere una fetta del montepremi da 700.000 $ e ottenere il titolo di campione del mondo del 2026!<br /><br>\n\nAssisti all\'evento dal 31 ottobre al 2 novembre sulla <a href="[EVENT LINK]" target=""_blank"">piattaforma degli eventi</a> e guadagna premi da ritirare direttamente in gioco!',
		'common.strings.wfCongrats':
			'Congratulazioni a [TEAM] per aver vinto il titolo di campione del mondo del 2026! Il Torneo mondiale di Clash of Clans tornerà nel 2026, non mancare! Nel frattempo, segui i nostri canali di Esports, X e Instagram (in inglese) per non perderti nessuna novità!',
		'common.strings.seeYouNextYear':
			'Congratulazioni a [TEAM], la squadra campione del mondo! Il Torneo mondiale di Clash of Clans tornerà nel 2026, non mancare! Nel frattempo, rimani al corrente di tutte le novità sui nostri eventi Esports per il 2026 visitando i canali dedicati su <a href="https://twitter.com/CoCEsports">Twitter</a> e <a href="https://www.instagram.com/esportscoc">Instagram</a> (in inglese)!\n',
		'common.strings.wfFinalists': 'I FINALISTI DEL TORNEO MONDIALE DEL 2026',
		'common.strings.wfHowToWatch':
			'Le otto squadre migliori si batteranno per il titolo di campioni del Torneo mondiale di Clash of Clans del 2026 e la fetta più grande del montepremi da 700.000 $!<br /><br />Il 14 e il 15 novembre, va\' sul <a href="https://event.supercell.com/clashofclans/it">sito dell\'evento</a> e vinci ricompense in gioco mentre assisti allo spettacolo!',
		'common.strings.wfSchedule':
			'Le partecipanti si affrontano in un gruppo a doppia eliminazione per decidere quale sarà la squadra campione del mondo di Clash of Clans per il 2026!<br><br>\n\nIL PRIMO GIORNO INIZIA IL 31 OTTOBRE ALLE [LOCAL TIME DAY 1].<br>\n\n- Si disputeranno gli scontri dal 1º al 6º.<br><br>\n\nIL SECONDO GIORNO INIZIA IL 1º NOVEMBRE ALLE [LOCAL TIME DAY 2].<br>\n\n- Si disputeranno gli scontri dal 7º al 12º.<br><br>\n\nIL TERZO GIORNO INIZIA IL 2 NOVEMBRE ALLE [LOCAL TIME DAY 3].<br>\n\n- Si disputeranno gli scontri dall\'13º al 15º.<br><br>\n\nGuarda lo spettacolo su <a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/it</a> e vinci ricompense in gioco!',
		'common.strings.mfPrizes': 'MONTEPREMI DELLE FINALI MENSILI',
		'common.strings.championshipPrizes': 'MONTEPREMI DELLE FINALI DEL TORNEO',
		'common.message.selectFivePlayersForWar':
			'Seleziona i {rosterMinSize} giocatori che parteciperanno alla guerra.',
		'common.strings.selectFivePlayersForMq':
			"Conferma i {rosterMinSize} giocatori che parteciperanno alla Qualificazione mensile e alla Finale mensile e che saranno gli unici a rimanere nella rosa, dopo il completamento dell'operazione.",
		'common.strings.lcqWinner': 'Vincitore delle UQ',
		'common.strings.chinaQualifier': 'Qualificazione per la Cina',
		'common.strings.chinaWinner': 'Vincitore per la Cina',
		'common.strings.communityTournament': 'Torneo della community',
		'common.strings.chinaRegionalQualifier': 'Qualificazione per la regione della Cina',
		'common.strings.townHall': 'Municipio',
		'common.strings.townHallLevel': 'Livello del municipio',
		'common.button.waitMatchFinish': 'In attesa della fine dello scontro...',
		'common.strings.checkInMonthlyQualifier':
			'Registra la squadra alle Qualificazioni mensili.',
		'common.strings.checkedin': 'Registrazione effettuata',
		'common.strings.leaderboard': 'Classifica',
		'common.strings.noResults': 'Nessun risultato',
		'common.thcup.worldChampionship': 'Coppa del municipio',
		'common.thcup.homeMessage.phase1InProgress':
			'La Coppa del municipio del 2026 è attualmente in corso. Puoi seguire il resto degli scontri dalla scheda "Competizione" o seguendo il canale (in inglese) <a href="https://twitter.com/CoCEsports">@CoCEsports</a>!',
		'common.thcup.homeMessage.getReady':
			"Preparati all'inizio della Coppa del municipio di Clash of Clans!",
		'common.thcup.homeMessage.thNotHighEnough':
			'Per partecipare, il municipio deve essere al livello 9, 12 o 15.',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'Il capo del clan non si è ancora iscritto alla Coppa del municipio.',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'Iscriviti e scegli almeno {rosterMinSize} membri del clan che lo rappresentino nella squadra della Coppa del municipio di Clash of Clans.',
		'common.thcup.homeMessage.clanRequired':
			'Devi far parte di un clan per partecipare alla Coppa del municipio di Clash of Clans.',
		'common.thcup.homeMessage.rosterLocked':
			'Almeno {rosterMinSize} membri della squadra hanno completato l\'iscrizione e la squadra è stata confermata! Una volta che la competizione avrà inizio, il capitano potrà far partecipare la squadra agli scontri toccando "Trova scontro". Ricorda che, durante uno scontro di una Coppa del municipio, tutti i giocatori devono FAR PARTE DEL LORO CLAN e il clan NON PUÒ combattere in una guerra di nessun altro tipo in quel momento. Inoltre, i giocatori possono partecipare alle normali guerre tra clan e alle battaglie della lega della guerra in altri clan, ma NON POSSONO lottare in una guerra amichevole durante uno scontro di una Coppa del municipio.',
		'common.thcup.homeMessage.rosterLocked.captain':
			'Almeno {rosterMinSize} membri della squadra hanno completato l\'iscrizione e la squadra è stata confermata! Una volta che la competizione avrà inizio, potrai far partecipare la squadra agli scontri toccando "Trova scontro". Ricorda che, durante uno scontro di una Coppa del municipio, tutti i giocatori devono FAR PARTE DEL LORO CLAN e il clan NON PUÒ combattere in una guerra di nessun altro tipo in quel momento. Inoltre, i giocatori possono partecipare alle normali guerre tra clan e alle battaglie della lega della guerra in altri clan, ma NON POSSONO lottare in una guerra amichevole durante uno scontro di una Coppa del municipio.',
		'common.thcup.homeMessage.preSegment.ladder.captain':
			"Se il tuo piazzamento negli Scontri classificati rientra tra le prime otto posizioni, visita Discord per leggere un annuncio importante. Le otto squadre migliori avanzeranno alle Finali e ricorda che i loro membri DOVRANNO tornare nel clan prima dell'inizio delle registrazioni agli scontri.",
		'common.thcup.homeMessage.preSegment.ladder.member':
			'Se il tuo piazzamento negli Scontri classificati rientra tra le prime otto posizioni, visita Discord per leggere un annuncio importante. Le otto squadre migliori avanzeranno alle Finali e i loro capitani saranno responsabili della registrazione agli scontri.',
		'common.thcup.homeMessage.finishedTop90.captain':
			"Se il tuo piazzamento negli Scontri classificati rientra tra le prime otto posizioni, visita Discord per leggere un annuncio importante. Le otto squadre migliori avanzeranno alle Finali e ricorda che i loro membri DOVRANNO tornare nel clan prima dell'inizio delle registrazioni agli scontri.",
		'common.thcup.homeMessage.finishedTop90.member':
			'Se il tuo piazzamento negli Scontri classificati rientra tra le prime otto posizioni, visita Discord per leggere un annuncio importante. Le otto squadre migliori avanzeranno alle Finali e i loro capitani saranno responsabili della registrazione agli scontri.',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			"Le squadre che si sono qualificate alla tappa successiva della competizione dovranno completare la registrazione agli scontri. Ricorda che i membri della squadra DEVONO tornare nel clan prima dell'inizio delle registrazioni agli scontri. Sei responsabile della registrazione allo scontro. Il periodo per le registrazioni è di cinque minuti.",
		'common.thcup.homeMessage.preSegment.postLadder.member':
			"Le squadre che si sono qualificate alla tappa successiva della competizione dovranno completare la registrazione agli scontri. Ricorda che i membri della squadra DEVONO tornare nel clan prima dell'inizio delle registrazioni agli scontri. Il capitano della squadra è responsabile della registrazione agli scontri. Il periodo per le registrazioni è di cinque minuti.",
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'Il torneo è in corso. Tocca il pulsante "Registrazione" nei cinque minuti precedenti all\'inizio di ogni turno. Unisciti al server Discord "Clash of Clans Esports" per ricevere tutte le informazioni salienti sul torneo!',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'Il torneo è in corso. Il capitano della squadra deve toccare il pulsante "Registrazione" nei cinque minuti precedenti all\'inizio di ogni turno. Unisciti al server Discord "Clash of Clans Esports" per ricevere tutte le informazioni salienti sul torneo!',
		'common.thcup.strings.stage1': 'Scontri classificati',
		'common.thcup.strings.stage2': 'Qualificazione mensile',
		'common.thcup.strings.mfPrizes': 'MONTEPREMI DELLE FINALI',
		'common.worldChampionship': 'Torneo mondiale di Clash of Clans del 2026',
		'common.strings.dayTwoAttackOrder3v3':
			"<u>Questo scontro prevede un ordine d'attacco preciso.</u><br/><strong>{HOMETEAM} sferrerà attacchi</strong> a 21 minuti, 13 minuti e 5 minuti dalla fine della guerra.<br/><strong>{AWAYTEAM} sferrerà attacchi</strong> a 17 minuti, 9 minuti e un minuto dalla fine della guerra.",
		'common.strings.dayTwoAttackOrder2v2':
			"<u>Questo scontro prevede un ordine d'attacco preciso.</u><br/><strong>{HOMETEAM} sferrerà attacchi</strong> a 13 minuti e 5 minuti dalla fine della guerra.<br/><strong>{AWAYTEAM} sferrerà attacchi</strong> a 9 minuti e un minuto dalla fine della guerra.",
	},
	de: {
		'common.strings.home': 'STARTSEITE',
		'common.strings.schedule': 'ZEITPLAN',
		'common.strings.stage1': 'Offener Qualifier',
		'common.strings.stage2': 'Monatlicher Qualifier',
		'common.strings.stage3': 'Monatliches Final',
		'common.strings.stage4': 'Phase 4:',
		'common.strings.stage5': 'Phase 5',
		'common.strings.championshipFinals': 'Championship Finals',
		'common.strings.prizes': 'PREISPOOL',
		'common.strings.goldenTicketWinners': 'GEWINNER EINES GOLDENEN TICKETS',
		'common.strings.silverTicketWinners': 'GEWINNER EINES SILBERNEN TICKETS',
		'common.strings.roster': 'TEILNEHMERLISTE',
		'common.strings.captain': 'Kapitän',
		'common.strings.upcomingMatches': 'KOMMENDES MATCH',
		'common.strings.pastMatches': 'GESPIELTE MATCHES',
		'common.strings.ladderLeaderboard': 'BESTENLISTE',
		'common.strings.points': 'Punkte',
		'common.strings.record': 'Bilanz',
		'common.strings.rank': 'Rang',
		'common.strings.wins': 'Siege',
		'common.strings.losses': 'Niederlagen',
		'common.strings.gdpr': 'DSGVO',
		'common.strings.participantList': 'TEILNEHMERLISTE',
		'common.strings.round': 'RUNDE {roundNumber}',
		'common.strings.qualified': 'QUALIFIZIERT',
		'common.strings.eliminated': 'SCHEIDET AUS',
		'common.strings.checkin': 'Check-in',
		'common.button.confirm': 'Bestätigen',
		'common.button.submit': 'Abschicken',
		'common.button.cancel': 'Abbrechen',
		'common.button.viewEvent': 'Event ansehen',
		'common.button.viewAll': 'Alle anzeigen',
		'common.button.backToEvent': 'Zurück zum Event',
		'common.button.goBack': 'Zurück',
		'common.button.inviteMembers': 'Team wählen',
		'common.button.ready': 'Ich bin bereit!',
		'common.button.skip': 'Vorerst überspringen',
		'common.button.save': 'Speichern',
		'common.button.saveChanges': 'Änderungen speichern',
		'common.button.back': 'Zurück',
		'common.button.register': 'Registrieren',
		'common.button.pickTeam': 'Team wählen',
		'common.button.leaveTeam': 'Team verlassen',
		'common.button.createTeam': 'Team erstellen',
		'common.strings.ready': 'Bereit',
		'common.strings.notReady': 'Nicht bereit',
		'common.button.done': 'Fertig',
		'common.strings.january': 'Januar',
		'common.strings.february': 'Februar',
		'common.strings.march': 'März',
		'common.strings.april': 'April',
		'common.strings.may': 'Mai',
		'common.strings.june': 'Juni',
		'common.strings.july': 'Juli',
		'common.strings.august': 'August',
		'common.strings.september': 'September',
		'common.strings.october': 'Oktober',
		'common.strings.november': 'November',
		'common.strings.december': 'Dezember',
		'common.strings.contactSupport': 'Support kontaktieren',
		'common.strings.error.required': 'Pflichtfeld',
		'common.strings.success': 'Geschafft!',
		'common.strings.ohNo': 'Oh nein!',
		'common.strings.wait': 'Hey, warte mal!',
		'common.strings.tooltip.discord':
			'Du kannst den offiziellen Discord-Server für die Clash of Clans World Championship nutzen, um dich mit deinen Mitspielern auszutauschen.',
		'common.strings.forfeitWin': 'S. D. AUFG.',
		'common.strings.forfeitLoss': 'N. D. AUFG.',
		'common.strings.bye': 'FREILOS',
		'common.strings.teamInvite': 'Mitglieder einladen',
		'common.button.join': 'Beitreten',
		'common.strings.discordConnected': 'Discord-Konto verbunden.',
		'common.strings.selectedAsCaptain':
			'Du wurdest ausgewählt, deinen Clan in den World Championships als Teamkapitän zu vertreten. Bitte registriere dich bis {DATETIME} unten.',
		'common.strings.pending': 'Registrierung notwendig',
		'common.strings.today': 'Heute',
		'common.strings.registrationClosesIn': 'Registrierung schließt in {time}',
		'common.strings.startsIn': '[X] beginnt in {time}',
		'common.strings.endsIn': '[X] endet in {time}',
		'common.strings.days': 'T.',
		'common.strings.hours': 'Std.',
		'common.strings.minutes': 'Min.',
		'common.strings.seconds': 'Sek.',
		'common.strings.changeCaptain': 'Kapitän wechseln',
		'common.strings.chooseCaptain': 'Kapitän wählen',
		'common.strings.backToHub': 'Zurück zum Turnier-Hub',
		'common.strings.missingCaptainLeader':
			'Dein Team hat keinen Kapitän. Du musst einen Kapitän auswählen, bevor du teilnehmen kannst.',
		'common.strings.missingCaptain':
			'Dein Team hat keinen Kapitän. Bitte deinen Clananführer darum, einen Kapitän auszuwählen.',
		'common.strings.captainRoleMismatchPersonal':
			'Du bist der Teamkapitän aber kein Vize-Anführer oder Anführer. Bitte deinen Clananführer darum, dich zu befördern oder wählt einen neuen Kapitän.',
		'common.strings.captainRoleMismatchLeader':
			'Dein Kapitän ist kein Clananführer oder Vize-Anführer. Wähle entweder einen neuen Kapitän oder befördere den aktuellen Kapitän zum Anführer oder Vize-Anführer.',
		'common.strings.captainRoleMismatch':
			'Dein Kapitän ist kein Vize-Anführer oder Anführer. Bitte deinen Clananführer, den Kapitän zum Anführer oder Vize-Anführer zu befördern, oder wähle einen neuen Kapitän.',
		'common.strings.rosterIncompleteLeader':
			'Du hast Spieler eingeladen, die sich noch nicht registriert haben. Bitte deine Teammitglieder, sich zu registrieren.',
		'common.strings.rosterIncomplete':
			'Mindestens ein Teammitglied hat sich noch nicht registriert. Bitte deine Teammitglieder, sich so schnell wie möglich zu registrieren.',
		'common.strings.rosterReady':
			'Dein Team ist bereit. Der Teamkapitän muss einchecken. Viel Glück!',
		'common.button.next': 'Weiter',
		'common.strings.leader': 'Anführer',
		'common.strings.coLeader': 'Vize-Anführer',
		'common.strings.elder': 'Ältester',
		'common.strings.member': 'Mitglied',
		'common.errors.critical': 'Kritischer Fehler. Bitte starte die Anwendung neu.',
		'common.button.startWar': 'KRIEG STARTEN',
		'common.strings.statusRegRosterCaptain':
			'Registrierungsschluss ist am {DATETIME}.<BR/> Sobald alle Mitglieder die Registrierung abgeschlossen haben, finalisiere bitte dein Team durch Tippen auf die „Team finalisieren“-Schaltfläche!',
		'common.strings.statusRegRosterMember':
			'Du wurdest ausgewählt, das Team zu vertreten! Registrierung schließt um {DATETIME}. Bitte schließe die Registrierung ab und gehe zum „Mein Team“-Reiter, um den Status deines Teams zu verfolgen.',
		'common.strings.statusRegClosedNotMember':
			'Das Team, das deinen Clan repräsentieren soll, wurde ausgewählt. Registrierung schließt am {DATETIME}. Folge deinem Clan im Reiter „Wettbewerb“!',
		'common.strings.opponentTeamCheckInOpen': 'Dein Gegner hat den Krieg noch nicht gestartet.',
		'common.strings.opponentTeamCheckedIn': 'Dein Gegner ist bereit, den Krieg zu starten.',
		'common.strings.currentTeamCheckInOpen': 'Dein Team hat den Krieg noch nicht gestartet.',
		'common.strings.currentTeamCheckedIn': 'Dein Team ist bereit, den Krieg zu starten.',
		'common.strings.opponentTeamMissedCheckedIn':
			'Dein Gegner hat das Zeitfenster zum Einchecken verpasst.',
		'common.strings.currentTeamMissedCheckIn':
			'Dein Team hat das Zeitfenster zum Einchecken verpasst.',
		'common.button.tournamentCheckin': 'Check-in zum Turnier',
		'common.strings.tooltipAttackOrder':
			'Beide Teams müssen die korrekte Angriffsreihenfolge einhalten <strong>(Regel 3.2.3 im offiziellen Regelwerk).</strong><br/><br/>',
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			'Falls dein Gegner nicht die korrekte Angriffsreihenfolge einhält, erstelle bitte ein Ticket und melde dein Match auf Discord.',
		'common.strings.dayTwoAttackOrder5v5':
			'<u>Bei diesem Match gibt es festgelegte Angriffsreihenfolgen.</u><br/><strong>{HOMETEAM} Greift an</strong>, wenn noch 37 Min., 29 Min., 21 Min., 13 Min., 5 Min. vom Krieg übrig sind.<br/><strong>{AWAYTEAM} Greift an</strong>, wenn noch 33 Min., 25 Min., 17 Min., 9 Min., 1 Min. vom Krieg übrig sind.',
		'common.button.lockRoster': 'Team finalisieren',
		'common.strings.tooltip.notPartOfClan':
			'Dieses Teammitglied ist momentan nicht Teil des Clans.',
		'common.strings.locked': 'Team wurde finalisiert',
		'common.strings.notLocked': 'Team wurde nicht finalisiert',
		'common.homeMessage.getReady':
			'Mach dich bereit für die Clash of Clans World Championship 2026!',
		'common.homeMessage.registerAndSelectATeam':
			'Registriere dich und wähle {rosterMinSize} Clanmitglieder aus, die deinen Clan in der Clash of Clans World Championship vertreten sollen.',
		'common.homeMessage.leaderHasntRegisteredYet':
			'Dein Clananführer hat sich noch nicht für die Clash of Clans World Championship registriert.',
		'common.homeMessage.thNotHighEnough':
			'Du musst auf Rathaus-Level 18 sein, um teilzunehmen.',
		'common.homeMessage.clanRequired':
			'Du musst in einem Clan sein, um an der Clash of Clans World Championship teilzunehmen.',
		'common.homeMessage.rosterNotComplete.leader':
			'Deine Teammitglieder müssen IM CLAN, AUSGEWÄHLT und REGISTRIERT sein, damit du dein Team finalisieren kannst. Falls ein Teammitglied den Clan verlässt, bevor das Team finalisiert ist, muss es vom Clananführer erneut ausgewählt werden. Sobald dein Team finalisiert wurde, können Teammitglieder den Clan verlassen und ihm wieder beitreten, ohne erneut ausgewählt werden zu müssen.',
		'common.homeMessage.rosterNotComplete.captain':
			'Alle Teammitglieder müssen IM CLAN, AUSGEWÄHLT und REGISTRIERT sein, damit du dein Team finalisieren kannst. Falls ein Teammitglied den Clan verlässt, bevor das Team finalisiert ist, muss es vom Clananführer erneut ausgewählt werden. Sobald dein Team finalisiert wurde, können Teammitglieder den Clan verlassen und ihm wieder beitreten, ohne erneut ausgewählt werden zu müssen.',
		'common.homeMessage.rosterNotComplete.member':
			'Du wurdest ausgewählt, das Team zu vertreten. Wenn du den Clan verlässt, bevor dein Team finalisiert wurde, muss der Clananführer dich erneut auswählen, damit du teilnehmen kannst. Sobald dein Team finalisiert wurde, kannst du den Clan verlassen und ihm wieder beitreten, ohne erneut ausgewählt werden zu müssen.',
		'common.homeMessage.rosterNotComplete.fallback':
			'Das Team, das deinen Clan repräsentieren soll, wurde noch nicht ausgewählt.',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			'Mindestens {rosterMinSize} Spieler in deinem Team haben sich erfolgreich registriert. Der Teamkapitän muss das Team finalisieren, bevor Matches gespielt werden können. Sobald das Team finalisiert wurde, können keine Änderungen mehr an der Aufstellung vorgenommen werden.',
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			'Mindestens {rosterMinSize} Spieler in deinem Team haben sich erfolgreich registriert. Du musst dein Team finalisieren, um Ranglistenmatches spielen zu können. Sobald das Team finalisiert wurde, können keine Änderungen mehr an der Aufstellung vorgenommen werden.',
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			'Um Ranglistenmatches spielen zu können, muss der Teamkapitän dein Team finalisieren. Sobald das Team finalisiert wurde, können keine Änderungen mehr an der Aufstellung vorgenommen werden.',
		'common.homeMessage.rosterLocked':
			'Mindestens {rosterMinSize} Spieler in deinem Team haben sich erfolgreich registriert und das Team wurde finalisiert! Sobald die Rangliste beginnt, kann der Teamkapitän durch Tippen auf „Match suchen” beginnen, Matches zu spielen. Vergiss nicht: Alle Spieler müssen IM CLAN SEIN und der Clan DARF NICHT während eines World-Championship-Matches in einem anderen Krieg sein. Spieler können normale Clankriege und die Clankriegsliga in anderen Clans spielen. Sie können jedoch während eines World-Championship-Matches KEINEN Freundschaftskrieg spielen.',
		'common.homeMessage.rosterLocked.captain':
			'Mindestens {rosterMinSize} Spieler in deinem Team haben sich erfolgreich registriert und das Team wurde finalisiert! Sobald die Rangliste beginnt, kannst du durch Tippen auf „Match suchen” beginnen, Matches zu spielen. Vergiss nicht: Alle Spieler müssen IM CLAN SEIN und der Clan DARF NICHT während eines World-Championship-Matches in einem anderen Krieg sein. Spieler können normale Clankriege und die Clankriegsliga in anderen Clans spielen. Sie können jedoch während eines World-Championship-Matches KEINEN Freundschaftskrieg spielen.',
		'common.homeMessage.ladderInProgress':
			'Die Rangliste hat begonnen! Der Teamkapitän kann durch Tippen auf „Match suchen“ ein Match finden. Denk dran, dass, um ein Match zu finden, alle Mitglieder IM CLAN sein müssen und nicht in einem Krieg oder Freundschaftskrieg sein dürfen.',
		'common.homeMessage.ladderInProgress.captain':
			'Die Rangliste hat begonnen! Du kannst ein Match finden, indem du auf die Schaltfläche „Match suchen“ tippst. Denk dran, dass, um ein Match zu finden, alle Mitglieder IM CLAN sein müssen und nicht in einem Krieg oder Freundschaftskrieg sein dürfen. Bitte stelle sicher, dass alle Mitglieder spielbereit sein, bevor du ein Match suchst.',
		'common.homeMessage.followTeam':
			'Du kannst den Fortschritt deines Teams im Reiter „Wettbewerb“ verfolgen!',
		'common.homeMessage.finishedTop90.captain':
			'Wenn deine Ranglistenplatzierung Platz 170 oder besser war, schau bitte in Discord nach einer wichtigen Mitteilung. Die 128 besten Teams schaffen es in den Monatlichen Qualifier. Teammitglieder MÜSSEN vor dem Match-Check-in wieder im Clan sein.',
		'common.homeMessage.finishedTop90.member':
			'Wenn deine Ranglistenplatzierung Platz 170 oder besser war, schau bitte in Discord nach einer wichtigen Mitteilung. Die 128 besten Teams schaffen es in den Monatlichen Qualifier. Der Teamkapitän ist für den Match-Check-in verantwortlich.',
		'common.homeMessage.preSegment.postLadder.captain':
			'Teams, die in die nächste Phase des Wettkampfs fortgeschritten sind, müssen den Match-Check-in abschließen. Denk dran, dass alle Teammitglieder vor dem Match-Check-in wieder im Clan sein MÜSSEN. Du bist für den Match-Check-in verantwortlich. Das Zeitfenster für den Match-Check-in beträgt 5 Minuten.',
		'common.homeMessage.preSegment.postLadder.member':
			'Teams, die in die nächste Phase des Wettkampfs fortgeschritten sind, müssen den Match-Check-in abschließen. Denk dran, dass alle Teammitglieder vor dem Match-Check-in wieder im Clan sein MÜSSEN. Der Teamkapitän ist für den Match-Check-in verantwortlich. Das Zeitfenster für den Match-Check-in beträgt 5 Minuten.',
		'common.homeMessage.tournamentInProgress.captain':
			'Das Turnier hat begonnen. Tippe innerhalb von 5 Minuten jeder Rundenstartzeit auf „Check-in“. Wichtige Informationen zum Turnier findest du auf dem „Clash of Clans Esports“-Discord!',
		'common.homeMessage.tournamentInProgress.member':
			'Das Turnier hat begonnen. Der Teamkapitän muss innerhalb von 5 Minuten jeder Rundenstartzeit auf „Check-in“ tippen. Wichtige Informationen zum Turnier findest du auf dem „Clash of Clans Esports“-Discord!',
		'common.homeMessage.phase1InProgress':
			'Die World Championship 2026 ist im Gange. Du kannst den Rest des Turniers über den Reiter „Wettbewerb“ verfolgen oder indem du <a href="https://twitter.com/CoCEsports">@CoCEsports</a> folgst!',
		'common.strings.goodLuckMessage':
			'Herzlichen Glückwunsch! Viel Glück auf dem Rest deiner World Championship Finals-Reise!',
		'common.strings.phaseOneComplete':
			'Der diesmonatige Wettbewerb ist abgeschlossen. Folge <a href="https://twitter.com/CoCEsports">@CoCEsports</a>, um mehr zu erfahren!',
		'common.strings.ladderEndsIn': 'Rangliste endet in',
		'common.strings.matchCheckinStartsIn': 'Match-Check-in beginnt in',
		'common.strings.matchCheckinEndsIn': 'Match-Check-in endet in',
		'common.homeMessage.teamIncomplete':
			'Die Registrierungsphase für den Wettbewerb ist vorbei. Da dein Team die Registrierung nicht rechtzeitig abgeschlossen hat, kann es nicht am diesmonatigen Wettbewerb teilnehmen.',
		'common.homeMessage.preSegment.ladder.captain':
			'Wenn deine Ranglistenplatzierung Platz 170 oder besser war, schau bitte in Discord nach einer wichtigen Mitteilung. Die 128 besten Teams schaffen es in den Monatlichen Qualifier. Teammitglieder MÜSSEN vor dem Match-Check-in wieder im Clan sein.',
		'common.homeMessage.preSegment.ladder.member':
			'Wenn deine Ranglistenplatzierung Platz 170 oder besser war, schau bitte in Discord nach einer wichtigen Mitteilung. Die 128 besten Teams schaffen es in den Monatlichen Qualifier. Der Teamkapitän ist für den Match-Check-in verantwortlich.',
		'common.button.leaveQueue': 'Warteschlange verlassen',
		'common.button.findMatch': 'Match suchen',
		'common.strings.phase': 'PHASE {#}',
		'common.strings.lowerBracket': 'Unteres Bracket',
		'common.strings.upperBracket': 'Oberes Bracket',
		'common.strings.noMatches': 'Keine Matches',
		'common.strings.noData': 'Keine Daten',
		'common.button.manageRoster': 'Team verwalten',
		'common.button.withdraw': 'Aufgeben',
		'common.strings.readyToPlay': 'Registrierung erfolgreich! Du kannst jetzt spielen!',
		'common.strings.registration.opens': 'REGISTRIERUNG ÖFFNET:',
		'common.strings.registration.closes': 'REGISTRIERUNGSSCHLUSS:',
		'common.strings.worldChampionshipFinals': 'World Championship Finals',
		'common.strings.lastChanceQualifier': 'Last Chance Qualifier',
		'common.strings.starts': 'Beginnt',
		'common.strings.ends': 'Endet',
		'common.strings.eliminationType': 'Eliminierungsart:',
		'common.strings.group': 'Gruppe',
		'common.strings.notPicked5': 'Bitte wähle mindestens {rosterMinSize} Clanmitglieder aus.',
		'common.strings.notPickedLeader':
			'Du musst mindestens 1 Clananführer oder Vize-Anführer auswählen.',
		'common.button.accept': 'Annehmen',
		'common.button.decline': 'Ablehnen',
		'common.strings.gamesPlayed': 'GSP. SP.',
		'common.strings.wars': 'Kriege',
		'common.strings.worldFinalsFinalists': 'Finalisti del Torneo mondiale',
		'common.strings.followNow': 'Folgen Sie hier!',
		'common.strings.worldFinalsWinner':
			'<TEAM> wurde zum World Champion 2026 gekrönt! Herzlichen Glückwunsch!<br/><br/>Wir hoffen, alle Spieler 2026 wiederzusehen.',
		'common.starts': 'Beginnt',
		'common.ends': 'Endet',
		'common.eliminationType': 'Eliminierungsart:',
		'common.eliminationType.doubleElim': 'Eliminierungsart: Doppelausscheidung',
		'common.eliminationType.swiss': 'Eliminierungsart: Swiss',
		'common.eliminationType.ladder': 'Eliminierungsart: Rangliste',
		'common.strings.maxLimitMatchesHeader': 'Match-Limit erreicht',
		'common.strings.maxLimitMatchesPerDay':
			'Du hast schon in den letzten 24 Stunden 6 Matches gespielt. Bitte versuche es später erneut.',
		'common.strings.homeTeam': 'Heimteam',
		'common.strings.awayTeam': 'Auswärtsteam',
		'common.strings.wfDay1': 'World Championship Finals – Tag 1',
		'common.strings.wfDay2': 'World Championship Finals – Tag 2',
		'common.strings.wfDay3': 'World Championship Finals – Tag 3',
		'common.strings.wfHeroText':
			'Die acht besten Teams der Welt werden bei den Clash of Clans World Championship Finals in Atlanta, Georgia, um einen Teil des Preisgeldes in Höhe von 700.000 US-Dollar sowie den Titel des World Champions 2026 kämpfen.<br /><br>\n\nSchalte die Action vom 31. Oktober bis 2. November auf der <a href="[EVENT LINK]" target=""_blank"">Eventplattform</a> ein und verdiene Belohnungen im Spiel!',
		'common.strings.wfCongrats':
			'„Wir gratulieren [TEAM], die sich den Titel des World Champions 2026 sichern konnten! Die Clash of Clans World Championship kehrt 2026 zurück. Hoffentlich bist du auch dann wieder dabei! Folge unseren E-Sports-Kanälen auf X und Instagram, um auf dem Laufenden zu bleiben.“',
		'common.strings.seeYouNextYear':
			'[TEAM] wurde zum World Champion gekrönt! Herzlichen Glückwunsch! Die Clash of Clans World Championship kehrt 2026 zurück. Hoffentlich bist du auch dann wieder dabei! Folge uns auf <a href="https://x.com/CoCEsports">X</a> und <a href="https://www.instagram.com/esportscoc">Instagram</a> für E-Sports, damit du keine News zu unseren Plänen für 2026 verpasst!\n',
		'common.strings.wfFinalists': 'FINALISTEN DER WORLD CHAMPIONSHIP 2026',
		'common.strings.wfHowToWatch':
			'Die acht besten Teams der Welt werden um den Titel des Clash of Clans World Champion 2026 und den größten Anteil am 700.000 US-Dollar großen Preispool kämpfen!<br /><br />Schalte den Stream vom 14. bis 15. November <a href="https://event.supercell.com/clashofclans/en">auf der Eventseite</a> ein und verdiene dabei Belohnungen im Spiel!',
		'common.strings.wfSchedule':
			'Die Teams treffen in einem Doppelausscheidungs-Bracket aufeinander, um den Clash of Clans World Champion 2026 krönen.<br><br>\n\nBEGINN VON TAG 1: 31. Okt. um [LOCAL TIME DAY 1]<br>\n\n– Matches 1–6<br><br>\n\nBEGINN VON TAG 2: 1. Nov. um [LOCAL TIME DAY 2]<br>\n\n– Matches 7–12<br><br>\n\nBEGINN VON TAG 3: 2. Nov. um [LOCAL TIME DAY 3]<br>\n\n– Matches 13–15<br><br>\n\nSieh dir den Stream auf <a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/de</a> an und verdiene Belohnungen im Spiel!',
		'common.strings.mfPrizes': 'PREISPOOL DER MONATLICHEN FINALS',
		'common.strings.championshipPrizes': 'PREISPOOL DER CHAMPIONSHIP FINALS',
		'common.message.selectFivePlayersForWar':
			'Bitte wähle diejenigen {rosterMinSize} Spieler aus, die am Krieg teilnehmen sollen.',
		'common.strings.selectFivePlayersForMq':
			'Bitte bestätige die {rosterMinSize} Spieler, die am Monatlichen Qualifier und Monatlichen Final teilnehmen werden. Nur die {rosterMinSize} ausgewählten Spieler verbleiben in der Teilnehmerliste.',
		'common.strings.lcqWinner': 'LCQ-Sieger',
		'common.strings.chinaQualifier': 'China-Qualifier',
		'common.strings.chinaWinner': 'China-Sieger',
		'common.strings.communityTournament': 'Community-Turnier',
		'common.strings.chinaRegionalQualifier': 'Chinesischer regionaler Qualifier',
		'common.strings.townHall': 'Rathaus',
		'common.strings.townHallLevel': 'Rathaus-Level',
		'common.button.waitMatchFinish': 'Auf Ende des Matches warten',
		'common.strings.checkInMonthlyQualifier':
			'Checke dein Team für den Monatlichen Qualifier ein.',
		'common.strings.checkedin': 'Eingecheckt',
		'common.strings.leaderboard': 'Rangliste',
		'common.strings.noResults': 'Keine Ergebnisse',
		'common.thcup.worldChampionship': 'Rathaus-Cup',
		'common.thcup.homeMessage.phase1InProgress':
			'Der Rathaus-Cup 2026 wird aktuell ausgefochten. Du kannst den Rest des Turniers über den Reiter „Wettbewerb“ verfolgen oder indem du <a href="https://twitter.com/CoCEsports">@CoCEsports</a> folgst!',
		'common.thcup.homeMessage.getReady':
			'Mach dich bereit für den Beginn des Clash of Clans Rathaus-Cups!',
		'common.thcup.homeMessage.thNotHighEnough':
			'Du musst auf Rathaus-Level 9, 12 oder 15 sein, um teilzunehmen.',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'Dein Clananführer hat sich noch nicht für den Clash of Clans Rathaus-Cup registriert.',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'Registriere dich und wähle mindestens {rosterMinSize} Clanmitglieder aus, die deinen Clan im Clash of Clans Rathaus-Cup vertreten sollen.',
		'common.thcup.homeMessage.clanRequired':
			'Du musst in einem Clan sein, um am Clash of Clans Rathaus-Cup teilzunehmen.',
		'common.thcup.homeMessage.rosterLocked':
			'Mindestens {rosterMinSize} Spieler in deinem Team haben sich erfolgreich registriert und das Team wurde finalisiert! Sobald die Rangliste beginnt, kann der Teamkapitän durch Tippen auf „Match suchen” beginnen, Matches zu spielen. Denk dran: Alle Spieler müssen IM CLAN SEIN und der Clan darf NICHT während eines Rathaus-Cup-Matches in einem anderen Krieg sein. Spieler können normale Clankriege und die Clankriegsliga in anderen Clans spielen. Sie können jedoch während eines Rathaus-Cup-Matches KEINEN Freundschaftskrieg spielen.',
		'common.thcup.homeMessage.rosterLocked.captain':
			'Mindestens {rosterMinSize} Spieler in deinem Team haben sich erfolgreich registriert und das Team wurde finalisiert! Sobald die Rangliste beginnt, kannst du durch Tippen auf „Match suchen” beginnen, Matches zu spielen. Denk dran: Alle Spieler müssen IM CLAN SEIN und der Clan darf NICHT während eines Rathaus-Cup-Matches in einem anderen Krieg sein. Spieler können normale Clankriege und die Clankriegsliga in anderen Clans spielen. Sie können jedoch während eines Rathaus-Cup-Matches KEINEN Freundschaftskrieg spielen.',
		'common.thcup.homeMessage.preSegment.ladder.captain':
			'Wenn deine Ranglistenplatzierung Platz 8 oder besser war, schau bitte im Discord-Kanal nach einer wichtigen Mitteilung. Die besten 8 Teams rücken in die Finals vor. Teammitglieder MÜSSEN vor dem Match-Check-in wieder im Clan sein.',
		'common.thcup.homeMessage.preSegment.ladder.member':
			'Wenn deine Ranglistenplatzierung Platz 8 oder besser war, schau bitte im Discord-Kanal nach einer wichtigen Mitteilung. Die besten 8 Teams rücken in die Finals vor. Der Teamkapitän ist für den Match-Check-in verantwortlich.',
		'common.thcup.homeMessage.finishedTop90.captain':
			'Wenn deine Ranglistenplatzierung Platz 8 oder besser war, schau bitte im Discord-Kanal nach einer wichtigen Mitteilung. Die besten 8 Teams rücken in die Finals vor. Teammitglieder MÜSSEN vor dem Match-Check-in wieder im Clan sein.',
		'common.thcup.homeMessage.finishedTop90.member':
			'Wenn deine Ranglistenplatzierung Platz 8 oder besser war, schau bitte im Discord-Kanal nach einer wichtigen Mitteilung. Die besten 8 Teams rücken in die Finals vor. Der Teamkapitän ist für den Match-Check-in verantwortlich.',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			'Teams, die in die nächste Phase des Wettkampfs fortgeschritten sind, müssen den Match-Check-in abschließen. Denk dran, dass alle Teammitglieder vor dem Match-Check-in wieder im Clan sein MÜSSEN. Du bist für den Match-Check-in verantwortlich. Das Zeitfenster für den Match-Check-in beträgt 5 Minuten.',
		'common.thcup.homeMessage.preSegment.postLadder.member':
			'Teams, die in die nächste Phase des Wettkampfs fortgeschritten sind, müssen den Match-Check-in abschließen. Denk dran, dass alle Teammitglieder vor dem Match-Check-in wieder im Clan sein MÜSSEN. Der Teamkapitän ist für den Match-Check-in verantwortlich. Das Zeitfenster für den Match-Check-in beträgt 5 Minuten.',
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'Das Turnier läuft gerade! Tippe innerhalb von 5 Minuten jeder Rundenstartzeit auf „Check-in“. Schaue für wichtige Informationen zum Turnier auf dem „Clash of Clans Esports“-Discord vorbei!',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'Das Turnier läuft gerade! Der Teamkapitän muss innerhalb von 5 Minuten jeder Rundenstartzeit auf „Check-in“ tippen. Schaue für wichtige Informationen zum Turnier auf dem „Clash of Clans Esports“-Discord vorbei!',
		'common.thcup.strings.stage1': 'Rangliste/Ladder',
		'common.thcup.strings.stage2': 'Monatlicher Qualifier',
		'common.thcup.strings.mfPrizes': 'PREISPOOL DER FINALS',
		'common.worldChampionship': 'Clash of Clans World Championship 2026',
		'common.strings.dayTwoAttackOrder3v3':
			'<u>Bei diesem Match gibt es festgelegte Angriffsreihenfolgen.</u><br/><strong>{HOMETEAM} Greift an</strong>, wenn noch 21 Min., 13 Min., 5 Min. vom Krieg übrig sind.<br/><strong>{AWAYTEAM} Greift an</strong>, wenn noch 17 Min., 9 Min., 1 Min. vom Krieg übrig sind.',
		'common.strings.dayTwoAttackOrder2v2':
			'<u>Bei diesem Match gibt es festgelegte Angriffsreihenfolgen.</u><br/><strong>{HOMETEAM} Greift an</strong>, wenn noch 13 Min., 5 Min. vom Krieg übrig sind.<br/><strong>{AWAYTEAM} Greift an</strong>, wenn noch 9 Min., 1 Min. vom Krieg übrig sind.',
	},
	es: {
		'common.strings.home': 'INICIO',
		'common.strings.schedule': 'PROGRAMA',
		'common.strings.stage1': 'Clasificatoria abierta',
		'common.strings.stage2': 'Clasificatoria mensual',
		'common.strings.stage3': 'Finales mensuales',
		'common.strings.stage4': 'Fase 4',
		'common.strings.stage5': 'Fase 5',
		'common.strings.championshipFinals': 'Finales del campeonato',
		'common.strings.prizes': 'BOLSA DE PREMIOS',
		'common.strings.goldenTicketWinners': 'GANADORES DE LOS TIQUES DE ORO',
		'common.strings.silverTicketWinners': 'GANADORES DEL TIQUE DE PLATA',
		'common.strings.roster': 'PLANTILLA',
		'common.strings.captain': 'Capitán',
		'common.strings.upcomingMatches': 'PRÓXIMO PARTIDO',
		'common.strings.pastMatches': 'PARTIDOS COMPLETADOS',
		'common.strings.ladderLeaderboard': 'CLASIFICACIÓN COMPETITIVA',
		'common.strings.points': 'Puntos',
		'common.strings.record': 'Récord',
		'common.strings.rank': 'Puesto',
		'common.strings.wins': 'Victorias',
		'common.strings.losses': 'Derrotas',
		'common.strings.gdpr': 'RGPD',
		'common.strings.participantList': 'LISTA DE PARTICIPANTES',
		'common.strings.round': 'RONDA {roundNumber}',
		'common.strings.qualified': 'CLASIFICADO',
		'common.strings.eliminated': 'ELIMINADO',
		'common.strings.checkin': 'Registro',
		'common.button.confirm': 'Confirmar',
		'common.button.submit': 'Enviar',
		'common.button.cancel': 'Cancelar',
		'common.button.viewEvent': 'Ver evento',
		'common.button.viewAll': 'Ver todo',
		'common.button.backToEvent': 'Volver al evento',
		'common.button.goBack': 'Volver',
		'common.button.inviteMembers': 'Elegir equipo',
		'common.button.ready': '¡Todo listo!',
		'common.button.skip': 'Omitir',
		'common.button.save': 'Guardar',
		'common.button.saveChanges': 'Guardar cambios',
		'common.button.back': 'Atrás',
		'common.button.register': 'Registrarse',
		'common.button.pickTeam': 'Elegir equipo',
		'common.button.leaveTeam': 'Abandonar equipo',
		'common.button.createTeam': 'Crear equipo',
		'common.strings.ready': 'Listo',
		'common.strings.notReady': 'No listo',
		'common.button.done': 'Listo',
		'common.strings.january': 'enero',
		'common.strings.february': 'febrero',
		'common.strings.march': 'marzo',
		'common.strings.april': 'abril',
		'common.strings.may': 'mayo',
		'common.strings.june': 'junio',
		'common.strings.july': 'julio',
		'common.strings.august': 'agosto',
		'common.strings.september': 'septiembre',
		'common.strings.october': 'octubre',
		'common.strings.november': 'noviembre',
		'common.strings.december': 'diciembre',
		'common.strings.contactSupport': 'Contacta con el equipo de asistencia',
		'common.strings.error.required': 'Este campo es obligatorio.',
		'common.strings.success': '¡Genial!',
		'common.strings.ohNo': '¡Oh, no!',
		'common.strings.wait': '¡Eh, espera!',
		'common.strings.tooltip.discord':
			'Puedes usar el servidor oficial de Discord del campeonato mundial de Clash of Clans para conectar con tus aliados.',
		'common.strings.forfeitWin': 'VPA',
		'common.strings.forfeitLoss': 'DPA',
		'common.strings.bye': 'EXENCIÓN',
		'common.strings.teamInvite': 'Invitar a miembros',
		'common.button.join': 'Unirse',
		'common.strings.discordConnected': 'Cuenta de Discord conectada',
		'common.strings.selectedAsCaptain':
			'Se te ha elegido para representar a tu clan en el campeonato mundial y se te ha designado como capitán del equipo. Regístrate más abajo antes de {DATETIME}.',
		'common.strings.pending': 'Registro necesario',
		'common.strings.today': 'Hoy',
		'common.strings.registrationClosesIn': 'El registro se cierra en {time}',
		'common.strings.startsIn': '[X] empieza en {time}',
		'common.strings.endsIn': '[X] termina en {time}',
		'common.strings.days': 'd',
		'common.strings.hours': 'h',
		'common.strings.minutes': 'min',
		'common.strings.seconds': 's',
		'common.strings.changeCaptain': 'Cambiar de capitán',
		'common.strings.chooseCaptain': 'Elegir capitán',
		'common.strings.backToHub': 'Volver al portal del torneo',
		'common.strings.missingCaptainLeader':
			'Al equipo le falta un capitán. Designa a uno antes de terminarlo.',
		'common.strings.missingCaptain':
			'Al equipo le falta un capitán. Pide al líder del clan que designe a uno.',
		'common.strings.captainRoleMismatchPersonal':
			'Eres capitán del equipo, pero no eres líder ni colíder. Pide al líder del clan que te ascienda o que designe a un capitán nuevo.',
		'common.strings.captainRoleMismatchLeader':
			'Tu capitán no es líder ni colíder del clan. Elige un nuevo capitán o asciende al capitán actual a líder o colíder.',
		'common.strings.captainRoleMismatch':
			'Tu capitán no es líder ni colíder del clan. Pide al líder de tu clan que ascienda al capitán a líder o colíder o que elija un nuevo capitán.',
		'common.strings.rosterIncompleteLeader':
			'Has invitado a jugadores que aún no se han registrado. Pide a los miembros del equipo que se registren.',
		'common.strings.rosterIncomplete':
			'Al menos un miembro del equipo no ha completado aún el registro. Pídeles a los miembros del equipo que se registren lo antes posible.',
		'common.strings.rosterReady':
			'Tu equipo está listo para jugar. El capitán del equipo tiene que registrarse. ¡Buena suerte!',
		'common.button.next': 'Siguiente',
		'common.strings.leader': 'Líder',
		'common.strings.coLeader': 'Colíder',
		'common.strings.elder': 'Veterano',
		'common.strings.member': 'Miembro',
		'common.errors.critical': 'Ha ocurrido un error crítico. Reinicia la aplicación.',
		'common.button.startWar': 'INICIAR GUERRA',
		'common.strings.statusRegRosterCaptain':
			'Cierre del registro: {DATETIME}.<BR/> Cuando todos los miembros se hayan registrado, confirma el equipo tocando el botón «Confirmar equipo». Cuando se confirme el equipo, no podrá haber cambios en él.',
		'common.strings.statusRegRosterMember':
			'¡Se te ha elegido para representar al equipo! El registro se cierra a las {DATETIME}. Regístrate y ve a la pestaña «Mi equipo» para ver el estado del equipo.',
		'common.strings.statusRegClosedNotMember':
			'Se ha seleccionado el equipo que representará al clan. El registro se cierra el {DATETIME}. Puedes seguir la competición del clan en la pestaña «Competición».',
		'common.strings.opponentTeamCheckInOpen':
			'Tu rival no ha seleccionado todavía «INICIAR GUERRA».',
		'common.strings.opponentTeamCheckedIn': 'Tu rival tiene todo listo para INICIAR LA GUERRA.',
		'common.strings.currentTeamCheckInOpen':
			'Tu equipo no ha seleccionado todavía «INICIAR GUERRA».',
		'common.strings.currentTeamCheckedIn': 'Tu equipo tiene todo listo para INICIAR LA GUERRA.',
		'common.strings.opponentTeamMissedCheckedIn':
			'Tu rival no se ha registrado en el partido a tiempo.',
		'common.strings.currentTeamMissedCheckIn':
			'Tu equipo no se ha registrado en el partido a tiempo.',
		'common.button.tournamentCheckin': 'Registro en el torneo',
		'common.strings.tooltipAttackOrder':
			'Ambos equipos deben seguir el orden de ataque correcto <strong>(punto 3.2.3 del manual de reglas oficial).</strong><br/><br/>',
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			'Si tu rival no está siguiendo el orden de ataque correctamente, abre una consulta o denuncia el partido en Discord.',
		'common.strings.dayTwoAttackOrder5v5':
			'<u>Este partido tiene órdenes de ataque establecidas.</u><br/><strong>{HOMETEAM} ataca</strong> cuando a la guerra le queden 37 min, 29 min, 21 min, 13 min y 5 min.<br/><strong>{AWAYTEAM} ataca</strong> cuando a la guerra le queden 33 min, 25 min, 17 min, 9 min y 1 min.',
		'common.button.lockRoster': 'Confirmar equipo',
		'common.strings.tooltip.notPartOfClan':
			'Este miembro del equipo no está actualmente en el clan.',
		'common.strings.locked': 'El equipo está confirmado',
		'common.strings.notLocked': 'El equipo no está confirmado',
		'common.homeMessage.getReady':
			'¡Prepárate para el comienzo del campeonato mundial de Clash of Clans de 2026!',
		'common.homeMessage.registerAndSelectATeam':
			'Regístrate y elige a {rosterMinSize} miembros de tu clan para formar el equipo del campeonato mundial de Clash of Clans.',
		'common.homeMessage.leaderHasntRegisteredYet':
			'El líder de tu clan aún no lo ha registrado para el campeonato mundial de Clash of Clans.',
		'common.homeMessage.thNotHighEnough':
			'Para participar, se necesita un ayuntamiento de nivel 18.',
		'common.homeMessage.clanRequired':
			'Tienes que formar parte de un clan para participar en el campeonato mundial de Clash of Clans.',
		'common.homeMessage.rosterNotComplete.leader':
			'Los miembros del equipo deben formar parte del clan seleccionado y registrado para poder confirmar el equipo. Si un miembro del equipo lo abandona antes de confirmarse, el líder del clan tendrá que volver a seleccionarlo. Cuando se confirma el equipo, sus miembros pueden abandonarlo y volver al clan sin necesidad de volver a seleccionarlos.',
		'common.homeMessage.rosterNotComplete.captain':
			'Todos los miembros de tu equipo deben formar parte del clan seleccionado y registrado para poder confirmar el equipo. Si un miembro del equipo lo abandona antes de confirmarse, el líder del clan tendrá que volver a seleccionarlo. Cuando se confirma el equipo, sus miembros pueden abandonarlo y volver al clan sin necesidad de volver a seleccionarlos.',
		'common.homeMessage.rosterNotComplete.member':
			'Se te ha elegido para representar al equipo. Si abandonas el clan antes de que se confirme el equipo, el líder del clan tendrá que volver a seleccionarte para participar. Cuando se confirma el equipo, puedes abandonarlo y volver al clan sin necesidad de que vuelvan a seleccionarte.',
		'common.homeMessage.rosterNotComplete.fallback':
			'Aún no se ha seleccionado el equipo que representará al clan.',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			'Al menos {rosterMinSize} jugadores del equipo se han registrado. El capitán del equipo debe confirmar el equipo para empezar a jugar partidos. Cuando se confirme el equipo, no se podrán hacer cambios en él.',
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			'Al menos {rosterMinSize} jugadores del equipo se han registrado. Tienes que confirmar el equipo para poder jugar partidos competitivos. Cuando se confirme el equipo, no se podrán hacer cambios en él.',
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			'El capitán del equipo debe confirmar el equipo para empezar a jugar partidos competitivos. Cuando se confirme el equipo, no se podrán hacer cambios en él.',
		'common.homeMessage.rosterLocked':
			'Al menos {rosterMinSize} jugadores del equipo se han registrado ¡y el equipo está confirmado! Cuando comience la competición, el capitán del equipo podrá empezar a jugar partidos tocando «Encontrar partido». Recuerda que todos los jugadores deben formar parte del clan y que el clan no puede participar en ninguna otra guerra mientras se celebre un partido del campeonato mundial. Los jugadores pueden participar en las guerras de clanes convencionales y en la liga de guerras de clanes con otros clanes, pero no pueden participar en ninguna guerra amistosa mientras se celebre un partido del campeonato mundial.',
		'common.homeMessage.rosterLocked.captain':
			'Al menos {rosterMinSize} jugadores del equipo se han registrado ¡y el equipo está confirmado! Cuando comience la competición, podrás empezar a jugar partidos tocando «Encontrar partido». Recuerda que todos los jugadores deben formar parte del clan y que el clan no puede participar en ninguna otra guerra mientras se celebre un partido del campeonato mundial. Los jugadores pueden participar en las guerras de clanes convencionales y en la liga de guerras de clanes con otros clanes, pero no pueden participar en ninguna guerra amistosa mientras se celebre un partido del campeonato mundial.',
		'common.homeMessage.ladderInProgress':
			'¡Ha empezado la competición! El capitán del equipo puede buscar un partido tocando «Encontrar partido». Recuerda que todos los miembros deben formar parte del clan y no luchar en una guerra amistosa o activa para poder encontrar un partido.',
		'common.homeMessage.ladderInProgress.captain':
			'¡Ha empezado la competición! Puedes buscar un partido tocando el botón «Encontrar partido». Recuerda que todos los miembros deben formar parte del clan y no luchar en una guerra amistosa o activa para poder encontrar un partido. Asegúrate de que todos los miembros estén listos para jugar antes de buscar un partido.',
		'common.homeMessage.followTeam':
			'Puedes seguir la competición de los equipos en la pestaña «Competición».',
		'common.homeMessage.finishedTop90.captain':
			'Si tu puesto en la clasificación es el 170.º o superior, busca un anuncio importante en Discord. Los 128 mejores equipos avanzarán a la clasificatoria mensual. Los miembros del clan deben volver al clan antes del registro para los partidos.',
		'common.homeMessage.finishedTop90.member':
			'Si tu puesto en la clasificación es el 170.º o superior, busca un anuncio importante en Discord. Los 128 mejores equipos avanzarán a la clasificatoria mensual. El capitán del equipo es la persona responsable de registrarlo para el partido.',
		'common.homeMessage.preSegment.postLadder.captain':
			'Los equipos que avancen a la siguiente fase de la competición tendrán que completar el registro en el partido. Ten en cuenta que todos los miembros del clan deben volver al clan antes del registro para los partidos. Tú serás responsable de registrarlo para el partido. El periodo para registrarse en el partido es de 5 minutos.',
		'common.homeMessage.preSegment.postLadder.member':
			'Los equipos que avancen a la siguiente fase de la competición tendrán que completar el registro en el partido. Ten en cuenta que todos los miembros del clan deben volver al clan antes del registro para los partidos. El capitán del equipo es la persona responsable de registrarlo para el partido. El periodo para registrarse en el partido es de 5 minutos.',
		'common.homeMessage.tournamentInProgress.captain':
			'¡El torneo está en curso! Desde la hora de inicio de cada ronda, tienes 5 minutos para tocar «Registrarse». Consulta «Clash of Clans Esports» en Discord para ver información esencial sobre el torneo.',
		'common.homeMessage.tournamentInProgress.member':
			'¡El torneo está en curso! Desde la hora de inicio de cada ronda, el capitán del equipo tiene 5 minutos para tocar «Registrarse». Consulta «Clash of Clans Esports» en Discord para ver información esencial sobre el torneo.',
		'common.homeMessage.phase1InProgress':
			'El campeonato mundial de 2026 está en curso. Puedes seguir el resto del torneo a través de la pestaña "Competición" o siguiendo a <a href="https://twitter.com/CoCEsports">@CoCEsports</a>.',
		'common.strings.goodLuckMessage':
			'¡Enhorabuena! Buena suerte al resto en su viaje rumbo a las finales mundiales del campeonato.',
		'common.strings.phaseOneComplete':
			'Se ha terminado la competición mensual. ¡Sigue a <a href="https://twitter.com/CoCEsports">@CoCEsports</a> para ver más noticias!',
		'common.strings.ladderEndsIn': 'La clasificación termina en',
		'common.strings.matchCheckinStartsIn': 'El registro en el partido se abre en',
		'common.strings.matchCheckinEndsIn': 'El registro en el partido se cierra en',
		'common.homeMessage.teamIncomplete':
			'El periodo para registrarse en la competición se ha cerrado. Como tu equipo no se ha registrado a tiempo, no podrá competir en la competición de este mes.',
		'common.homeMessage.preSegment.ladder.captain':
			'Si tu puesto en la clasificación es el 170.º o superior, busca un anuncio importante en Discord. Los 128 mejores equipos avanzarán a la clasificatoria mensual. Los miembros del clan deben volver al clan antes del registro para los partidos.',
		'common.homeMessage.preSegment.ladder.member':
			'Si tu puesto en la clasificación es el 170.º o superior, busca un anuncio importante en Discord. Los 128 mejores equipos avanzarán a la clasificatoria mensual. El capitán del equipo es la persona responsable de registrarlo para el partido.',
		'common.button.leaveQueue': 'Abandonar cola',
		'common.button.findMatch': 'Encontrar partido',
		'common.strings.phase': 'FASE {#}',
		'common.strings.lowerBracket': 'Bracket inferior',
		'common.strings.upperBracket': 'Bracket superior',
		'common.strings.noMatches': 'Ningún partido',
		'common.strings.noData': 'Sin datos',
		'common.button.manageRoster': 'Gestionar equipo',
		'common.button.withdraw': 'Retirarse',
		'common.strings.readyToPlay': '¡Registro realizado con éxito! ¡Ya puedes jugar!',
		'common.strings.registration.opens': 'Inicio del registro:',
		'common.strings.registration.closes': 'Cierre del registro:',
		'common.strings.worldChampionshipFinals': 'Finales del campeonato mundial',
		'common.strings.lastChanceQualifier': 'Clasificatoria de última oportunidad',
		'common.strings.starts': 'Inicio',
		'common.strings.ends': 'Fin',
		'common.strings.eliminationType': 'Formato:',
		'common.strings.group': 'Grupo',
		'common.strings.notPicked5': 'Elige al menos a {rosterMinSize} miembros del clan.',
		'common.strings.notPickedLeader': 'Tienes que seleccionar al menos a 1 líder o colíder.',
		'common.button.accept': 'Aceptar',
		'common.button.decline': 'Rechazar',
		'common.strings.gamesPlayed': 'PJ',
		'common.strings.wars': 'Guerras',
		'common.strings.worldFinalsFinalists': 'World Championship Finalisten',
		'common.strings.followNow': '¡Siga aquí!',
		'common.strings.worldFinalsWinner':
			'¡Felicidades a <TEAM> por coronarse como campeones del mundo de 2026!<br/><br/>Esperamos volver a verlos en 2026.',
		'common.starts': 'Inicio',
		'common.ends': 'Fin',
		'common.eliminationType': 'Formato:',
		'common.eliminationType.doubleElim': 'Formato: doble eliminación',
		'common.eliminationType.swiss': 'Formato: sistema suizo',
		'common.eliminationType.ladder': 'Formato: clasificación',
		'common.strings.maxLimitMatchesHeader': 'Se ha alcanzado el límite de partidos.',
		'common.strings.maxLimitMatchesPerDay':
			'Ya has jugado 6 partidos en las últimas 24 horas. Inténtalo de nuevo más tarde.',
		'common.strings.homeTeam': 'Inicio',
		'common.strings.awayTeam': 'Visitante',
		'common.strings.wfDay1': 'Día 1 de las finales del campeonato mundial',
		'common.strings.wfDay2': 'Día 2 de las finales del campeonato mundial',
		'common.strings.wfDay3': 'Día 3 de las finales del campeonato mundial',
		'common.strings.wfHeroText':
			'Los 8 mejores equipos del mundo se enfrentarán en las finales del campeonato mundial de Clash of Clans en Atlanta, Georgia, por una bolsa de premios de 700 000 dólares estadounidenses y el título de campeones del mundo de 2026.<br /><br>\n\nDel 31 de octubre al 2 de noviembre, accede a <a href="[EVENT LINK]" target=""_blank"">la página de eventos</a> y gana recompensas en el juego.',
		'common.strings.wfCongrats':
			'¡Felicidades a [TEAM] por coronarse como campeones del mundo de 2026! El campeonato mundial de Clash of Clans volverá en 2026, ¡esperamos verte allí! Sigue nuestras cuentas de eSports de Twitter e Instagram para estar al día de todas las novedades.',
		'common.strings.seeYouNextYear':
			'¡Felicidades a [TEAM] por coronarse como campeones del mundo! El campeonato mundial de Clash of Clans volverá en 2026, ¡esperamos verte allí! Sigue nuestras cuentas de eSports de <a href="https://twitter.com/CoCEsports">Twitter</a> e <a href="https://www.instagram.com/esportscoc">Instagram</a> para estar al día de todas las novedades que llegarán en 2026.\n',
		'common.strings.wfFinalists': 'FINALISTAS DEL CAMPEONATO MUNDIAL DE 2026',
		'common.strings.wfHowToWatch':
			'Los ocho mejores equipos del mundo se disputarán el título de campeones mundiales de Clash of Clans de 2026 y la mayor parte de la bolsa de premios de 700 000 dólares estadounidenses.<br /><br />Entra en la <a href="https://event.supercell.com/clashofclans/es">página del evento</a> los días 14 y 15 de noviembre para obtener recompensas en el juego mientras disfrutas del espectáculo.',
		'common.strings.wfSchedule':
			'Los equipos competirán en un bracket de eliminación doble que decidirá quién se corona como campeón del mundo de Clash of Clans de 2026.<br><br>\n\nDÍA 1: comienza el 31 de octubre a las [LOCAL TIME DAY 1].<br>\n\n— Partidos 1-6<br><br>\n\nDÍA 2: comienza el 1 de noviembre a las [LOCAL TIME DAY 2].<br>\n\n— Partidos 7-12<br><br>\n\nDÍA 3: comienza el 2 de noviembre a las [LOCAL TIME DAY 3].<br>\n\n— Partidos 13-15<br><br>\n\n¡Mira la retransmisión en <a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/es</a> y consigue recompensas en el juego!',
		'common.strings.mfPrizes': 'BOLSA DE PREMIOS DE LAS FINALES MENSUALES',
		'common.strings.championshipPrizes': 'BOLSA DE PREMIOS DE LAS FINALES DEL CAMPEONATO',
		'common.message.selectFivePlayersForWar':
			'Elige a los {rosterMinSize} jugadores que participarán en la guerra.',
		'common.strings.selectFivePlayersForMq':
			'Confirma los {rosterMinSize} jugadores que participarán en la clasificatoria mensual y en la final mensual. Únicamente los {rosterMinSize} jugadores seleccionados permanecerán en la plantilla.',
		'common.strings.lcqWinner': 'Ganador de la CUO',
		'common.strings.chinaQualifier': 'Clasificatoria de China',
		'common.strings.chinaWinner': 'Ganador de China',
		'common.strings.communityTournament': 'Torneo comunitario',
		'common.strings.chinaRegionalQualifier': 'Clasificatoria regional china',
		'common.strings.townHall': 'Ayuntamiento',
		'common.strings.townHallLevel': 'Nivel del ayuntamiento',
		'common.button.waitMatchFinish': 'Esperando a que termine el partido...',
		'common.strings.checkInMonthlyQualifier':
			'Completa el registro de tu equipo para las clasificatorias mensuales.',
		'common.strings.checkedin': 'Registro realizado',
		'common.strings.leaderboard': 'Clasificación',
		'common.strings.noResults': 'Sin resultados',
		'common.thcup.worldChampionship': 'Copa de ayuntamientos',
		'common.thcup.homeMessage.phase1InProgress':
			'La copa de ayuntamientos de 2026 está en curso. Puedes seguir el resto del torneo a través de la pestaña «Competición» o siguiendo a <a href="https://twitter.com/CoCEsports">@CoCEsports</a>.',
		'common.thcup.homeMessage.getReady':
			'¡Prepárate para el comienzo de la copa de ayuntamientos de Clash of Clans!',
		'common.thcup.homeMessage.thNotHighEnough':
			'Para participar, se necesita un ayuntamiento de nivel 9, 12 o 15.',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'El líder de tu clan aún no lo ha registrado para la copa de ayuntamientos de Clash of Clans.',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'Regístrate y elige a un mínimo de {rosterMinSize} miembros de tu clan para formar el equipo de la copa de ayuntamientos de Clash of Clans.',
		'common.thcup.homeMessage.clanRequired':
			'Tienes que formar parte de un clan para participar en la copa de ayuntamientos de Clash of Clans.',
		'common.thcup.homeMessage.rosterLocked':
			'Al menos {rosterMinSize} jugadores del equipo se han registrado ¡y el equipo está confirmado! Cuando comience la competición, el capitán del equipo podrá empezar a jugar partidos tocando «Encontrar partido». Recuerda que todos los jugadores deben formar parte del clan y el clan no puede participar en ninguna otra guerra mientras se celebre un partido de la copa de ayuntamientos. Los jugadores pueden participar en las guerras de clanes convencionales y en la liga de guerras de clanes con otros clanes, pero no pueden participar en ninguna guerra amistosa mientras se celebre un partido de la copa de ayuntamientos.',
		'common.thcup.homeMessage.rosterLocked.captain':
			'Al menos {rosterMinSize} jugadores del equipo se han registrado ¡y el equipo está confirmado! Cuando comience la competición, podrás empezar a jugar partidos tocando «Encontrar partido». Recuerda que todos los jugadores deben formar parte del clan y el clan no puede participar en ninguna otra guerra mientras se celebre un partido de la copa de ayuntamientos. Los jugadores pueden participar en las guerras de clanes convencionales y en la liga de guerras de clanes con otros clanes, pero no pueden participar en ninguna guerra amistosa mientras se celebre un partido de la copa de ayuntamientos.',
		'common.thcup.homeMessage.preSegment.ladder.captain':
			'Si tu puesto en la clasificación es el 8.º o superior, busca un anuncio importante en Discord. Los 8 mejores equipos avanzan a las finales. Los miembros del clan deben volver al clan antes del registro para los partidos.',
		'common.thcup.homeMessage.preSegment.ladder.member':
			'Si tu puesto en la clasificación es el 8.º o superior, busca un anuncio importante en Discord. Los 8 mejores equipos avanzan a las finales. El capitán del equipo es la persona responsable de registrarlo para el partido.',
		'common.thcup.homeMessage.finishedTop90.captain':
			'Si tu puesto en la clasificación es el 8.º o superior, busca un anuncio importante en Discord. Los 8 mejores equipos avanzan a las finales. Los miembros del clan deben volver al clan antes del registro para los partidos.',
		'common.thcup.homeMessage.finishedTop90.member':
			'Si tu puesto en la clasificación es el 8.º o superior, busca un anuncio importante en Discord. Los 8 mejores equipos avanzan a las finales. El capitán del equipo es la persona responsable de registrarlo para el partido.',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			'Los equipos que avancen a la siguiente fase de la competición tendrán que completar el registro en el partido. Ten en cuenta que todos los miembros del clan deben volver al clan antes del registro para los partidos. Tú serás responsable de registrarlo para el partido. El periodo para registrarse en el partido es de 5 minutos.',
		'common.thcup.homeMessage.preSegment.postLadder.member':
			'Los equipos que avancen a la siguiente fase de la competición tendrán que completar el registro en el partido. Ten en cuenta que todos los miembros del clan deben volver al clan antes del registro para los partidos. El capitán del equipo es la persona responsable de registrarlo para el partido. El periodo para registrarse en el partido es de 5 minutos.',
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'¡El torneo está en curso! Desde la hora de inicio de cada ronda, tienes 5 minutos para tocar «Registro». Consulta "Clash of Clans Esports" en Discord para ver información esencial sobre el torneo.',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'¡El torneo está en curso! El capitán del equipo tiene 5 minutos para tocar «Registro» desde la hora de inicio de cada ronda. Consulta «Clash of Clans Esports» en Discord para ver información esencial sobre el torneo.',
		'common.thcup.strings.stage1': 'Clasificación',
		'common.thcup.strings.stage2': 'Clasificatoria mensual',
		'common.thcup.strings.mfPrizes': 'BOLSA DE PREMIOS DE LAS FINALES',
		'common.worldChampionship': 'Campeonato mundial de Clash of Clans de 2026',
		'common.strings.dayTwoAttackOrder3v3':
			'<u>Este partido tiene órdenes de ataque establecidas.</u><br/><strong>{HOMETEAM} ataca</strong> cuando a la guerra le queden 21 min, 13 min y 5 min.<br/><strong>{AWAYTEAM} ataca</strong> cuando a la guerra le queden 17 min, 9 min y 1 min.',
		'common.strings.dayTwoAttackOrder2v2':
			'<u>Este partido tiene órdenes de ataque establecidas.</u><br/><strong>{HOMETEAM} ataca</strong> cuando a la guerra le queden 13 min y 5 min.<br/><strong>{AWAYTEAM} ataca</strong> cuando a la guerra le queden 9 min y 1 min.',
	},
	pt: {
		'common.strings.home': 'INÍCIO',
		'common.strings.schedule': 'CRONOGRAMA',
		'common.strings.stage1': 'Classificatória aberta',
		'common.strings.stage2': 'Classificatória mensal',
		'common.strings.stage3': 'Finais mensais',
		'common.strings.stage4': 'Fase 4',
		'common.strings.stage5': 'Fase 5',
		'common.strings.championshipFinals': 'Final mundial',
		'common.strings.prizes': 'PREMIAÇÃO TOTAL',
		'common.strings.goldenTicketWinners': 'DETENTORES DO INGRESSO DOURADO',
		'common.strings.silverTicketWinners': 'VENCEDORES DO INGRESSO PRATEADO',
		'common.strings.roster': 'ESCALAÇÃO',
		'common.strings.captain': 'Capitão',
		'common.strings.upcomingMatches': 'PRÓXIMA DISPUTA',
		'common.strings.pastMatches': 'DISPUTAS CONCLUÍDAS',
		'common.strings.ladderLeaderboard': 'CLASSIFICAÇÃO COMPETITIVA',
		'common.strings.points': 'Pontos',
		'common.strings.record': 'Recorde',
		'common.strings.rank': 'Posição',
		'common.strings.wins': 'Vitórias',
		'common.strings.losses': 'Derrotas',
		'common.strings.gdpr': 'GDRP',
		'common.strings.participantList': 'LISTA DE PARTICIPANTES',
		'common.strings.round': 'RODADA {roundNumber}',
		'common.strings.qualified': 'CLASSIFICADO',
		'common.strings.eliminated': 'ELIMINADO',
		'common.strings.checkin': 'Check-in',
		'common.button.confirm': 'Confirmar',
		'common.button.submit': 'Enviar',
		'common.button.cancel': 'Cancelar',
		'common.button.viewEvent': 'Ver evento',
		'common.button.viewAll': 'Ver todos',
		'common.button.backToEvent': 'Voltar ao evento',
		'common.button.goBack': 'Voltar',
		'common.button.inviteMembers': 'Escolher equipe',
		'common.button.ready': 'Tudo pronto!',
		'common.button.skip': 'Pular por ora',
		'common.button.save': 'Salvar',
		'common.button.saveChanges': 'Salvar alterações',
		'common.button.back': 'Voltar',
		'common.button.register': 'Inscrever-se',
		'common.button.pickTeam': 'Escolher equipe',
		'common.button.leaveTeam': 'Sair da equipe',
		'common.button.createTeam': 'Criar equipe',
		'common.strings.ready': 'Pronto',
		'common.strings.notReady': 'Preparando',
		'common.button.done': 'Concluído',
		'common.strings.january': 'janeiro',
		'common.strings.february': 'fevereiro',
		'common.strings.march': 'março',
		'common.strings.april': 'abril',
		'common.strings.may': 'maio',
		'common.strings.june': 'junho',
		'common.strings.july': 'julho',
		'common.strings.august': 'agosto',
		'common.strings.september': 'setembro',
		'common.strings.october': 'outubro',
		'common.strings.november': 'novembro',
		'common.strings.december': 'dezembro',
		'common.strings.contactSupport': 'Fale com o suporte',
		'common.strings.error.required': 'O campo é obrigatório',
		'common.strings.success': 'Sucesso!',
		'common.strings.ohNo': 'Oh, não!',
		'common.strings.wait': 'Só um momento!',
		'common.strings.tooltip.discord':
			'Você pode usar o servidor oficial do Discord no Campeonato Mundial de Clash of Clans para se conectar aos seus colegas.',
		'common.strings.forfeitWin': 'Vitória por WO',
		'common.strings.forfeitLoss': 'Derrota por WO',
		'common.strings.bye': 'TCHAU',
		'common.strings.teamInvite': 'Convidar membros',
		'common.button.join': 'Entrar',
		'common.strings.discordConnected': 'Conta do Discord conectada',
		'common.strings.selectedAsCaptain':
			'Você foi escolhido para representar o seu clã no campeonato mundial e foi designado como capitão da equipe. Inscreva-se abaixo até {DATETIME}.',
		'common.strings.pending': 'Precisa se cadastrar',
		'common.strings.today': 'Hoje',
		'common.strings.registrationClosesIn': 'O cadastro se encerra em {time}',
		'common.strings.startsIn': '[X] começa em {time}',
		'common.strings.endsIn': '[X] termina em {time}',
		'common.strings.days': 'd',
		'common.strings.hours': 'h',
		'common.strings.minutes': 'm',
		'common.strings.seconds': 's',
		'common.strings.changeCaptain': 'Trocar capitão',
		'common.strings.chooseCaptain': 'Escolher capitão',
		'common.strings.backToHub': 'Voltar à plataforma do torneio',
		'common.strings.missingCaptainLeader':
			'A sua equipe está sem capitão. É preciso escolher um capitão antes de competir.',
		'common.strings.missingCaptain':
			'A sua equipe está sem capitão. Peça para o líder do clã escolher um capitão.',
		'common.strings.captainRoleMismatchPersonal':
			'Você é o capitão da equipe, mas não é líder nem colíder do clã. Peça para um líder promover você ou escolha outro capitão.',
		'common.strings.captainRoleMismatchLeader':
			'O capitão da equipe não é líder nem colíder do clã. Escolha um novo capitão ou promova o atual ao cargo de líder ou colíder.',
		'common.strings.captainRoleMismatch':
			'Seu capitão não é líder nem colíder. Peça ao líder do seu clã para promovê-lo a líder ou colíder, ou escolha outro capitão.',
		'common.strings.rosterIncompleteLeader':
			'Você convidou jogadores que ainda não se inscreveram. Peça que os integrantes da equipe se registrem.',
		'common.strings.rosterIncomplete':
			'Pelo menos um integrante da equipe não concluiu o cadastro. Peça que os integrantes da equipe se registrem o mais rápido possível.',
		'common.strings.rosterReady':
			'Sua equipe está pronta para jogar. O capitão da equipe precisa fazer o check-in. Boa sorte!',
		'common.button.next': 'Avançar',
		'common.strings.leader': 'Líder',
		'common.strings.coLeader': 'Colíder',
		'common.strings.elder': 'Ancião',
		'common.strings.member': 'Membro',
		'common.errors.critical': 'Ocorreu um erro. Por favor, reinicie sua inscrição.',
		'common.button.startWar': 'INICIAR GUERRA',
		'common.strings.statusRegRosterCaptain':
			'O cadastro se encerra em {DATETIME}.<BR/> Quando todos os integrantes terminarem a inscrição, toque no botão "Confirmar equipe" para que ela seja confirmada! Depois que a equipe estiver confirmada, não é possível alternar clãs.',
		'common.strings.statusRegRosterMember':
			'Você foi escolhido como representante da equipe! O cadastro se encerra em {DATETIME}. Conclua o cadastro e acesse a aba "Minha equipe" para acompanhar a situação da sua equipe.',
		'common.strings.statusRegClosedNotMember':
			'A equipe que representará seu clã foi selecionada. O cadastro se encerra em {DATETIME}. Siga a jornada do seu clã na aba Competição!',
		'common.strings.opponentTeamCheckInOpen':
			'O adversário ainda não selecionou a opção INICIAR GUERRA.',
		'common.strings.opponentTeamCheckedIn': 'O adversário está pronto para INICIAR GUERRA.',
		'common.strings.currentTeamCheckInOpen':
			'A sua equipe ainda não selecionou a opção INICIAR GUERRA.',
		'common.strings.currentTeamCheckedIn': 'A sua equipe está pronta para INICIAR GUERRA.',
		'common.strings.opponentTeamMissedCheckedIn':
			'O adversário não fez o check-in na disputa dentro do tempo estipulado.',
		'common.strings.currentTeamMissedCheckIn':
			'A sua equipe não fez o check-in na disputa dentro do tempo estipulado.',
		'common.button.tournamentCheckin': 'Check-in no torneio',
		'common.strings.tooltipAttackOrder':
			'As duas equipes devem seguir a ordem correta de ataque <strong>(segundo a seção 3.2.3 do regulamento)</strong>. <br/><br/>',
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			'Caso o adversário não siga a ordem de ataque, crie um tíquete e denuncie a sua partida no Discord.',
		'common.strings.dayTwoAttackOrder5v5':
			'<u>Esta disputa tem uma ordem de ataque definida.</u><br/><strong>{HOMETEAM} ataca</strong> quando faltam 37, 29, 21, 13 e 5 minutos na guerra.<br/><strong>{AWAYTEAM} ataca</strong> quando faltam 33, 25, 17, 9 e 1 minuto na guerra.',
		'common.button.lockRoster': 'Confirmar equipe',
		'common.strings.tooltip.notPartOfClan':
			'Este integrante da equipe não está no clã no momento.',
		'common.strings.locked': 'Equipe confirmada',
		'common.strings.notLocked': 'Equipe não confirmada',
		'common.homeMessage.getReady':
			'Prepare-se para o Campeonato Mundial de Clash of Clans 2026!',
		'common.homeMessage.registerAndSelectATeam':
			'Cadastre-se e selecione {rosterMinSize} integrantes para representar o seu clã na equipe do Campeonato Mundial de Clash of Clans.',
		'common.homeMessage.leaderHasntRegisteredYet':
			'O líder do seu clã ainda não se registrou no Campeonato Mundial de Clash of Clans.',
		'common.homeMessage.thNotHighEnough':
			'É preciso ter centro da vila de nível 18 para participar.',
		'common.homeMessage.clanRequired':
			'É preciso estar num clã para participar do Campeonato Mundial de Clash of Clans.',
		'common.homeMessage.rosterNotComplete.leader':
			'Os integrantes da equipe devem estar NO CLÃ, SELECIONADOS E REGISTRADOS para que você possa confirmar a equipe. Caso um integrante saia antes que a equipe seja confirmada, ele precisará ser selecionado novamente pelo líder do clã. Quando a equipe estiver confirmada, os integrantes podem sair e entrar de volta no clã sem precisarem ser selecionados de novo.',
		'common.homeMessage.rosterNotComplete.captain':
			'Todos os integrantes da equipe devem estar NO CLÃ, SELECIONADOS E REGISTRADOS para que você possa confirmar a equipe. Caso um integrante saia antes que a equipe seja confirmada, ele precisará ser selecionado novamente pelo líder do clã. Quando a equipe estiver confirmada, os integrantes podem sair e entrar de volta no clã sem precisarem ser selecionados de novo.',
		'common.homeMessage.rosterNotComplete.member':
			'Você foi escolhido como representante da equipe. Se você sair do clã antes que sua equipe seja confirmada, o líder do clã precisará selecionar você novamente para confirmar a sua participação. Quando a equipe estiver confirmada, você pode sair e entrar de volta no clã sem precisar ser selecionado de novo.',
		'common.homeMessage.rosterNotComplete.fallback':
			'A equipe que representará seu clã ainda não foi selecionada.',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			'Pelo menos {rosterMinSize} jogadores da equipe devem ter concluído o registro. O capitão da equipe deve confirmar a equipe para começar a jogar. Depois de confirmada, não poderá haver ajustes na escalação da equipe.',
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			'Pelo menos {rosterMinSize} jogadores da equipe devem ter concluído o registro. É preciso confirmar a equipe para jogar disputas no modo competitivo. Depois de confirmada, não poderá haver ajustes na escalação da equipe.',
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			'O capitão da equipe deve confirmar a equipe para começar a jogar no modo competitivo. Depois de confirmada, não poderá haver ajustes na escalação da equipe.',
		'common.homeMessage.rosterLocked':
			'Pelo menos {rosterMinSize} jogadores da equipe devem ter concluído o cadastro, e a equipe deve estar confirmada. Quando o modo competitivo começar, o capitão da equipe pode usar a opção "Encontrar disputa" para começar a jogar. Ressaltamos que todos os jogadores devem estar NO CLÃ e que o clã NÃO PODE estar em outra guerra durante uma disputa do Mundial. Os jogadores podem jogar em Guerras de Clãs normais e na Liga das Guerras de Clãs em outros clãs, mas NÃO PODEM jogar uma guerra amistosa durante uma disputa do Mundial.',
		'common.homeMessage.rosterLocked.captain':
			'Pelo menos {rosterMinSize} jogadores da equipe devem ter concluído o cadastro, e a equipe deve estar confirmada. Quando o modo competitivo começar, você pode usar a opção "Encontrar disputa" para começar a jogar. Ressaltamos que todos os jogadores devem estar NO CLÃ e que o clã NÃO PODE estar em outra guerra durante uma disputa do Mundial. Os jogadores podem jogar em Guerras de Clãs normais e na Liga das Guerras de Clãs em outros clãs, mas NÃO PODEM jogar uma guerra amistosa durante uma disputa do Mundial.',
		'common.homeMessage.ladderInProgress':
			'O modo competitivo começou! O capitão da equipe pode usar a opção "Encontrar disputa" para iniciar uma disputa. Ressaltamos que todos os integrantes devem estar NO CLÃ e não podem estar participando de nenhuma guerra, mesmo amistosa, para que uma disputa seja encontrada.',
		'common.homeMessage.ladderInProgress.captain':
			'O modo competitivo começou! Você pode usar a opção "Encontrar disputa" para iniciar uma disputa. Ressaltamos que todos os integrantes devem estar NO CLÃ e não podem estar participando de nenhuma guerra, mesmo amistosa, para que uma disputa seja encontrada. Todos os integrantes devem estar prontos para jogar antes de tentar encontrar uma disputa.',
		'common.homeMessage.followTeam': 'Acompanhe a jornada das suas equipes na aba Competição!',
		'common.homeMessage.finishedTop90.captain':
			'Caso você tenha terminado o modo competitivo na posição 170 ou superior, confira o Discord para ver um anúncio importante. As 128 melhores equipes avançarão para a classificatória mensal. Integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa.',
		'common.homeMessage.finishedTop90.member':
			'Caso você tenha terminado o modo competitivo na posição 170 ou superior, confira o Discord para ver um anúncio importante. As 128 melhores equipes avançarão para a classificatória mensal. O capitão da equipe é o responsável pelo check-in na disputa.',
		'common.homeMessage.preSegment.postLadder.captain':
			'Equipes que avançaram para a próxima fase da competição devem fazer o check-in na disputa. Não se esqueça de que todos os integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa. Você é o responsável pelo check-in da disputa. O período de check-in na disputa é de 5 minutos.',
		'common.homeMessage.preSegment.postLadder.member':
			'Equipes que avançaram para a próxima fase da competição devem fazer o check-in na disputa. Não se esqueça de que todos os integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa. O capitão da equipe é o responsável pelo check-in na disputa. O período de check-in na disputa é de 5 minutos.',
		'common.homeMessage.tournamentInProgress.captain':
			'Torneio em andamento! Toque em "check-in" dentro de 5 minutos do início de cada rodada. Confira "Clash of Clans Esports" no Discord para obter informações cruciais sobre o torneio!',
		'common.homeMessage.tournamentInProgress.member':
			'Torneio em andamento! O capitão da equipe deve tocar em "check-in" dentro de 5 minutos do início de cada rodada. Confira "Clash of Clans Esports" no Discord para obter informações cruciais sobre o torneio!',
		'common.homeMessage.phase1InProgress':
			'O Campeonato Mundial de 2026 já começou. Você pode acompanhar o resto do torneio na aba Competição ou seguindo <a href="https://twitter.com/CoCEsports">@CoCEsports</a>!',
		'common.strings.goodLuckMessage':
			'Parabéns! Boa sorte no resto de sua jornada rumo à final mundial!',
		'common.strings.phaseOneComplete':
			'A competição deste mês foi concluída. Siga <a href="https://twitter.com/CoCEsports">@CoCEsports</a> para saber mais!',
		'common.strings.ladderEndsIn': 'O modo competitivo se encerra em',
		'common.strings.matchCheckinStartsIn': 'O check-in da disputa abre em',
		'common.strings.matchCheckinEndsIn': 'O check-in do torneio encerra em',
		'common.homeMessage.teamIncomplete':
			'O período de inscrições para a competição terminou. Como a sua equipe não se registrou a tempo, não poderá participar da competição deste mês.',
		'common.homeMessage.preSegment.ladder.captain':
			'Caso você tenha terminado o modo competitivo na posição 170 ou superior, confira o Discord para ver um anúncio importante. As 128 melhores equipes avançarão para a classificatória mensal. Integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa.',
		'common.homeMessage.preSegment.ladder.member':
			'Caso você tenha terminado o modo competitivo na posição 170 ou superior, confira o Discord para ver um anúncio importante. As 128 melhores equipes avançarão para a classificatória mensal. O capitão da equipe é o responsável pelo check-in na disputa.',
		'common.button.leaveQueue': 'Sair da fila',
		'common.button.findMatch': 'Encontrar disputa',
		'common.strings.phase': 'FASE {#}',
		'common.strings.lowerBracket': 'Grupo dos perdedores',
		'common.strings.upperBracket': 'Grupo dos vencedores',
		'common.strings.noMatches': 'Sem disputas',
		'common.strings.noData': 'Sem dados',
		'common.button.manageRoster': 'Gerenciar escalação',
		'common.button.withdraw': 'Desistir',
		'common.strings.readyToPlay':
			'Sua inscrição foi realizada com sucesso. Você já pode jogar!',
		'common.strings.registration.opens': 'INÍCIO DO CADASTRO:',
		'common.strings.registration.closes': 'ENCERRAMENTO DO CADASTRO:',
		'common.strings.worldChampionshipFinals': 'Final mundial',
		'common.strings.lastChanceQualifier': 'Classificatória final',
		'common.strings.starts': 'Começa',
		'common.strings.ends': 'Termina',
		'common.strings.eliminationType': 'Tipo de tabela:',
		'common.strings.group': 'Grupo',
		'common.strings.notPicked5': 'Escolha pelo menos {rosterMinSize} membros do clã.',
		'common.strings.notPickedLeader':
			'Você precisa escolher pelo menos 1 líder ou colíder do clã',
		'common.button.accept': 'Aceitar',
		'common.button.decline': 'Recusar',
		'common.strings.gamesPlayed': 'PJ',
		'common.strings.wars': 'Guerras',
		'common.strings.worldFinalsFinalists': 'Finalistas del Campeonato Mundial',
		'common.strings.followNow': 'Siga aqui!',
		'common.strings.worldFinalsWinner':
			'Parabéns pelo título mundial de 2026, <TEAM>!<br/><br/>Esperamos ver vocês de novo em 2026.',
		'common.starts': 'Começa',
		'common.ends': 'Termina',
		'common.eliminationType': 'Tipo de tabela:',
		'common.eliminationType.doubleElim': 'Tipo de tabela: eliminação dupla',
		'common.eliminationType.swiss': 'Tipo de tabela: formato suíço',
		'common.eliminationType.ladder': 'Tipo de tabela: partidas classificadas',
		'common.strings.maxLimitMatchesHeader': 'Limite de disputas alcançado',
		'common.strings.maxLimitMatchesPerDay':
			'Você já lutou em 6 disputas nas últimas 24 horas. Tente de novo mais tarde.',
		'common.strings.homeTeam': 'Início',
		'common.strings.awayTeam': 'Desafiante',
		'common.strings.wfDay1': 'Final do campeonato mundial - Dia 1',
		'common.strings.wfDay2': 'Final do campeonato mundial - Dia 2',
		'common.strings.wfDay3': 'Final do campeonato mundial - Dia 3',
		'common.strings.wfHeroText':
			'As oito melhores equipes do mundo vão competir na final do Campeonato Mundial de Clash of Clans em Atlanta, Geórgia, por uma parte da premiação de US$ 700 mil e pelo título mundial de 2026.<br /><br>\n\nAcesse a <a href="[EVENT LINK]" target=""_blank"">plataforma de eventos</a> de 31 de outubro a 2 de novembro para assistir às partidas e ganhar recompensas no jogo!',
		'common.strings.wfCongrats':
			'Parabéns por ganhar o título mundial de 2026, [TEAM]! O Campeonato Mundial de Clash of Clans voltará em 2026, e esperamos ver vocês lá! Acompanhe os nossos perfis de e-sports no X e no Instagram para saber as últimas notícias.',
		'common.strings.seeYouNextYear':
			'Parabéns pelo título mundial, [TEAM]! O Campeonato Mundial de Clash of Clans voltará em 2026, e esperamos ver vocês lá! Acompanhe os nossos perfis de e-sports no <a href="https://twitter.com/CoCEsports">X</a> e no <a href="https://www.instagram.com/esportscoc">Instagram</a> para saber as últimas notícias do que está por vir em 2026!\n',
		'common.strings.wfFinalists': 'FINALISTAS MUNDIAIS DE 2026',
		'common.strings.wfHowToWatch':
			'As oito melhores equipes do mundo disputarão o título de campeã mundial do Clash of Clans em 2026 e a maior parte da premiação de US$ 700.000!<br /><br />Acesse o <a href="https://event.supercell.com/clashofclans/pt">site do evento</a> nos dias 14 e 15 de novembro e ganhe recompensas no jogo enquanto assiste!',
		'common.strings.wfSchedule':
			'As equipes se enfrentarão em uma chave de eliminação dupla para definir quem vai vencer o Campeonato Mundial de Clash of Clans 2026.<br><br>\n\nINÍCIO DO DIA 1: 31 de outubro, às [LOCAL TIME DAY 1]<br>\n\n- Disputas 1 a 6<br><br>\n\nINÍCIO DO DIA 2: 1º de novembro, às [LOCAL TIME DAY 2]<br>\n\n- Disputas 7 a 12<br><br>\n\nINÍCIO DO DIA 3: 2 de novembro, às [LOCAL TIME DAY 3]<br>\n\n- Disputas 13 a 15<br><br>\n\nAcesse <a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/pt</a> para assistir às partidas e ganhar recompensas no jogo!',
		'common.strings.mfPrizes': 'PREMIAÇÃO DA FINAL MENSAL',
		'common.strings.championshipPrizes': 'PREMIAÇÃO DA FINAL DO CAMPEONATO',
		'common.message.selectFivePlayersForWar':
			'Selecione {rosterMinSize} jogadores que participarão da guerra.',
		'common.strings.selectFivePlayersForMq':
			'Confirme os {rosterMinSize} jogadores que participarão da classificatória mensal e da final mensal. Somente os {rosterMinSize} jogadores selecionados permanecerão na escalação.',
		'common.strings.lcqWinner': 'Vencedor da classificatória final',
		'common.strings.chinaQualifier': 'Classificatória da China',
		'common.strings.chinaWinner': 'Vencedor da classificatória da China',
		'common.strings.communityTournament': 'Torneio comunitário',
		'common.strings.chinaRegionalQualifier': 'Classificatória regional da China',
		'common.strings.townHall': 'Centro da vila',
		'common.strings.townHallLevel': 'Nível do centro da vila',
		'common.button.waitMatchFinish': 'Aguardando a disputa terminar.',
		'common.strings.checkInMonthlyQualifier':
			'Faça o check-in da sua equipe na classificatória mensal',
		'common.strings.checkedin': 'Check-in feito',
		'common.strings.leaderboard': 'Classificação',
		'common.strings.noResults': 'Sem resultados',
		'common.thcup.worldChampionship': 'Copa do Centro da Vila',
		'common.thcup.homeMessage.phase1InProgress':
			'A Copa do Centro da Vila 2026 está em andamento. Você pode acompanhar o resto do torneio na aba Competição ou seguindo o perfil <a href="https://twitter.com/CoCEsports">@CoCEsports</a>!',
		'common.thcup.homeMessage.getReady':
			'Prepare-se, pois a Copa do Centro da Vila do Clash of Clans vai começar!',
		'common.thcup.homeMessage.thNotHighEnough':
			'É preciso ter centro da vila de nível 9, 12 ou 15 para participar.',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'O líder do seu clã ainda não fez o cadastro na Copa do Centro da Vila do Clash of Clans.',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'Cadastre-se e selecione pelo menos {rosterMinSize} membros para representar o seu clã na equipe da Copa do Centro da Vila do Clash of Clans.',
		'common.thcup.homeMessage.clanRequired':
			'É preciso estar num clã para participar da Copa do Centro da Vila do Clash of Clans.',
		'common.thcup.homeMessage.rosterLocked':
			'Pelo menos {rosterMinSize} jogadores da equipe devem ter concluído o cadastro, e a equipe deve estar confirmada. Quando o modo competitivo começar, o capitão da equipe pode usar a opção "Encontrar disputa" para começar a jogar. Ressaltamos que todos os jogadores devem estar NO CLÃ, e o clã NÃO PODE estar em outra guerra durante uma disputa da Copa do Centro da Vila. Os jogadores podem jogar em Guerras de Clãs normais e na Liga das Guerras de Clãs em outros clãs, mas NÃO PODEM jogar uma guerra amistosa durante uma disputa da Copa do Centro da Vila.',
		'common.thcup.homeMessage.rosterLocked.captain':
			'Pelo menos {rosterMinSize} jogadores da equipe devem ter concluído o cadastro, e a equipe deve estar confirmada. Quando o modo competitivo começar, você pode usar a opção "Encontrar disputa" para começar a jogar. Ressaltamos que todos os jogadores devem estar NO CLÃ, e o clã NÃO PODE estar em outra guerra durante uma disputa da Copa do Centro da Vila. Os jogadores podem jogar em Guerras de Clãs normais e na Liga das Guerras de Clãs em outros clãs, mas NÃO PODEM jogar uma guerra amistosa durante uma disputa da Copa do Centro da Vila.',
		'common.thcup.homeMessage.preSegment.ladder.captain':
			'Caso você tenha terminado o modo competitivo na posição 8 ou superior, confira o Discord para ver um anúncio importante. As 8 melhores equipes avançarão para a final. Integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa.',
		'common.thcup.homeMessage.preSegment.ladder.member':
			'Caso você tenha terminado o modo competitivo na posição 8 ou superior, confira o Discord para ver um anúncio importante. As 8 melhores equipes avançarão para a final. O capitão da equipe é o responsável pelo check-in na disputa.',
		'common.thcup.homeMessage.finishedTop90.captain':
			'Caso você tenha terminado o modo competitivo na posição 8 ou superior, confira o Discord para ver um anúncio importante. As 8 melhores equipes avançarão para a final. Integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa.',
		'common.thcup.homeMessage.finishedTop90.member':
			'Caso você tenha terminado o modo competitivo na posição 8 ou superior, confira o Discord para ver um anúncio importante. As 8 melhores equipes avançarão para a final. O capitão da equipe é o responsável pelo check-in na disputa.',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			'Equipes que avançaram para a próxima fase da competição devem fazer o check-in na disputa. Não se esqueça de que todos os integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa. Você é o responsável pelo check-in da disputa. O período de check-in na disputa é de 5 minutos.',
		'common.thcup.homeMessage.preSegment.postLadder.member':
			'Equipes que avançaram para a próxima fase da competição devem fazer o check-in na disputa. Não se esqueça de que todos os integrantes da equipe DEVEM voltar ao clã antes do check-in da disputa. O capitão da equipe é o responsável pelo check-in na disputa. O período de check-in na disputa é de 5 minutos.',
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'Torneio em andamento! Toque em "Check-in" dentro de 5 minutos do início de cada rodada. Confira "Clash of Clans Esports" no Discord para obter informações cruciais sobre o torneio!',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'Torneio em andamento! O capitão da equipe deve tocar em "Check-in" dentro de 5 minutos do início de cada rodada. Confira "Clash of Clans Esports" no Discord para obter informações cruciais sobre o torneio!',
		'common.thcup.strings.stage1': 'Partida classificada',
		'common.thcup.strings.stage2': 'Classificatória mensal',
		'common.thcup.strings.mfPrizes': 'PREMIAÇÃO TOTAL DA FINAL',
		'common.worldChampionship': 'Campeonato Mundial de Clash of Clans 2026',
		'common.strings.dayTwoAttackOrder3v3':
			'<u>Esta disputa tem uma ordem de ataque definida.</u><br/><strong>{HOMETEAM} ataca</strong> quando faltam 21, 13 e 5 minutos na guerra.<br/><strong>{AWAYTEAM} ataca</strong> quando faltam 17, 9 e 1 minuto na guerra.',
		'common.strings.dayTwoAttackOrder2v2':
			'<u>Esta disputa tem uma ordem de ataque definida.</u><br/><strong>{HOMETEAM} ataca</strong> quando faltam 13 e 5 minutos na guerra.<br/><strong>{AWAYTEAM} ataca</strong> quando faltam 9 e 1 minuto na guerra.',
	},
	jp: {
		'common.strings.home': 'ホーム',
		'common.strings.schedule': 'スケジュール',
		'common.strings.stage1': 'オープン予選',
		'common.strings.stage2': 'マンスリー予選',
		'common.strings.stage3': 'マンスリー決勝戦',
		'common.strings.stage4': 'ステージ4',
		'common.strings.stage5': 'ステージ5',
		'common.strings.championshipFinals': '世界一決定戦',
		'common.strings.prizes': '賞金総額',
		'common.strings.goldenTicketWinners': 'ゴールドチケット獲得者',
		'common.strings.silverTicketWinners': 'シルバーチケット獲得チーム',
		'common.strings.roster': '登録プレイヤー',
		'common.strings.captain': 'キャプテン',
		'common.strings.upcomingMatches': '次のマッチ',
		'common.strings.pastMatches': '終了したマッチ',
		'common.strings.ladderLeaderboard': 'ランク戦順位',
		'common.strings.points': 'ポイント',
		'common.strings.record': '記録',
		'common.strings.rank': '順位',
		'common.strings.wins': '勝利',
		'common.strings.losses': '敗北',
		'common.strings.gdpr': '一般データ保護規則（GDRP）',
		'common.strings.participantList': '参加者リスト',
		'common.strings.round': 'ラウンド{roundNumber}',
		'common.strings.qualified': '通過',
		'common.strings.eliminated': '敗退',
		'common.strings.checkin': 'チェックイン',
		'common.button.confirm': '確定',
		'common.button.submit': '送信',
		'common.button.cancel': 'キャンセル',
		'common.button.viewEvent': 'イベントを見る',
		'common.button.viewAll': 'すべて表示',
		'common.button.backToEvent': 'イベントに戻る',
		'common.button.goBack': '戻る',
		'common.button.inviteMembers': 'チームを選択',
		'common.button.ready': '準備完了！',
		'common.button.skip': '今はしない',
		'common.button.save': '保存',
		'common.button.saveChanges': '変更を保存',
		'common.button.back': '戻る',
		'common.button.register': '登録',
		'common.button.pickTeam': 'チームを選ぶ',
		'common.button.leaveTeam': 'チームを脱退',
		'common.button.createTeam': 'チームを作成',
		'common.strings.ready': '準備完了',
		'common.strings.notReady': '準備中',
		'common.button.done': '完了',
		'common.strings.january': '1月',
		'common.strings.february': '2月',
		'common.strings.march': '3月',
		'common.strings.april': '4月',
		'common.strings.may': '5月',
		'common.strings.june': '6月',
		'common.strings.july': '7月',
		'common.strings.august': '8月',
		'common.strings.september': '9月',
		'common.strings.october': '10月',
		'common.strings.november': '11月',
		'common.strings.december': '12月',
		'common.strings.contactSupport': 'サポートチームに連絡',
		'common.strings.error.required': 'この欄は記入が必須です',
		'common.strings.success': '完了！',
		'common.strings.ohNo': 'おっと！',
		'common.strings.wait': 'お待ちください！',
		'common.strings.tooltip.discord':
			'クラッシュ・オブ・クラン世界選手権の公式Discordサーバーを使えば、チームメイトと繋がることができます。',
		'common.strings.forfeitWin': '不戦勝',
		'common.strings.forfeitLoss': '不戦敗',
		'common.strings.bye': '不戦勝',
		'common.strings.teamInvite': 'メンバーを招待',
		'common.button.join': '参加',
		'common.strings.discordConnected': 'Discordアカウントへの接続完了',
		'common.strings.selectedAsCaptain':
			'あなたは、世界選手権において所属するクランの代表メンバーに選ばれ、チームキャプテンとなりました。{DATETIME}までに以下から登録してください。',
		'common.strings.pending': '登録が必要です',
		'common.strings.today': '今日',
		'common.strings.registrationClosesIn': '登録締め切りまで：{time}',
		'common.strings.startsIn': '[X]開始まで：{time}',
		'common.strings.endsIn': '[X]終了まで：{time}',
		'common.strings.days': '日',
		'common.strings.hours': '時',
		'common.strings.minutes': '分',
		'common.strings.seconds': '秒',
		'common.strings.changeCaptain': 'キャプテンを変更',
		'common.strings.chooseCaptain': 'キャプテンを選択',
		'common.strings.backToHub': '大会ハブに戻る',
		'common.strings.missingCaptainLeader':
			'チームにキャプテンがいません。大会に参加するには、キャプテンを選択する必要があります。',
		'common.strings.missingCaptain':
			'チームにキャプテンがいません。キャプテンを選ぶよう、クランリーダーに連絡してください。',
		'common.strings.captainRoleMismatchPersonal':
			'あなたはチームキャプテンですが、リーダーやサブリーダーではありません。自分を昇格させるか新たなキャプテンを指名するよう、クランリーダーに連絡してください。',
		'common.strings.captainRoleMismatchLeader':
			'キャプテンが、リーダーまたはサブリーダーではありません。新たなキャプテンを選択するか、現在のキャプテンをリーダーまたはサブリーダーに昇格してください。',
		'common.strings.captainRoleMismatch':
			'キャプテンが、リーダーまたはサブリーダーではありません。現在のキャプテンを昇格させるか新たなキャプテンを指名するよう、クランリーダーに連絡してください。',
		'common.strings.rosterIncompleteLeader':
			'まだ参加登録されていないプレイヤーを招待しました。チームメンバーに登録を行うよう伝えてください。',
		'common.strings.rosterIncomplete':
			'登録を完了していないチームメンバーがいます。すみやかに登録するよう伝えてください。',
		'common.strings.rosterReady':
			'チームはプレイする準備ができています。キャプテンはチェックインしてください。健闘を祈ります！',
		'common.button.next': '次',
		'common.strings.leader': 'リーダー',
		'common.strings.coLeader': 'サブリーダー',
		'common.strings.elder': '長老',
		'common.strings.member': 'メンバー',
		'common.errors.critical': '深刻なエラーが発生しました。アプリを再起動してください。',
		'common.button.startWar': '対戦開始',
		'common.strings.statusRegRosterCaptain':
			'登録は{DATETIME}に締め切りとなります。<BR/>すべてのメンバーの登録が完了したら、「チームを確定」ボタンを押してメンバーを確定しましょう！メンバーが確定されると、クランの移籍はできなくなります。',
		'common.strings.statusRegRosterMember':
			'チームの代表に選ばれました！登録は{DATETIME}に締め切られます。登録を完了し、「マイチーム」タブからチームのステータスを確認しましょう。',
		'common.strings.statusRegClosedNotMember':
			'クランを代表するチームを結成しました。登録は{DATETIME}に締め切られます。「大会」タブからクランの状況を確認しましょう！',
		'common.strings.opponentTeamCheckInOpen':
			'対戦チームがまだ「対戦開始」をタップしていません。',
		'common.strings.opponentTeamCheckedIn': '対戦チームが「対戦開始」をタップしました。',
		'common.strings.currentTeamCheckInOpen':
			'あなたのチームはまだ「対戦開始」をタップしていません。',
		'common.strings.currentTeamCheckedIn': 'あなたのチームは「対戦開始」をタップしました。',
		'common.strings.opponentTeamMissedCheckedIn':
			'対戦チームが時間内にマッチのチェックインを完了しませんでした。',
		'common.strings.currentTeamMissedCheckIn':
			'あなたのチームは時間内にマッチのチェックインを完了しませんでした。',
		'common.button.tournamentCheckin': '大会チェックイン',
		'common.strings.tooltipAttackOrder':
			'両チームは指定された攻撃順<strong>（公式ルールブックのセクション3.2.3を参照）</strong>に従ってください。<br/><br/>',
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			'対戦チームが指定の攻撃順に従っていない場合は、Discordにて運営チームに報告してください。',
		'common.strings.dayTwoAttackOrder5v5':
			'<u>このマッチでは攻撃順があらかじめ決められています。</u><br/><strong>{HOMETEAM}の攻撃：</strong>残り対戦時間37分、29分、21分、13分、5分の時点<br/><strong>{AWAYTEAM}の攻撃：</strong>残り対戦時間33分、25分、17分、9分、1分の時点',
		'common.button.lockRoster': 'チームを確定',
		'common.strings.tooltip.notPartOfClan':
			'このチームメンバーは、現在クランに所属していません。',
		'common.strings.locked': 'チームは確定しています',
		'common.strings.notLocked': 'チームは確定していません',
		'common.homeMessage.getReady':
			'クラッシュ・オブ・クラン世界選手権2026がいよいよ開幕します！',
		'common.homeMessage.registerAndSelectATeam':
			'登録を行い、クランを代表するメンバーを{rosterMinSize}人選んで出場チームを編成しましょう！',
		'common.homeMessage.leaderHasntRegisteredYet':
			'所属クランのリーダーがクラッシュ・オブ・クラン世界選手権への参加登録をしていません。',
		'common.homeMessage.thNotHighEnough':
			'参加するにはタウンホールレベル18に達している必要があります。',
		'common.homeMessage.clanRequired':
			'クラッシュ・オブ・クラン世界選手権に参加するにはクランに所属していなければなりません。',
		'common.homeMessage.rosterNotComplete.leader':
			'チームを確定するには、チームメンバーがクランに参加しており、メンバーとして選択され、登録を終えた状態でなければなりません。チームの確定前にメンバーがクランを脱退すると、クランに戻った際に、クランリーダーが再度参加メンバーとして選択する必要があります。チームメンバーが確定した後であれば、クランを一度脱退して再加入したとしても、再度選出してもらう必要はありません。',
		'common.homeMessage.rosterNotComplete.captain':
			'チームを確定するには、すべてのチームメンバーがクランに参加しており、メンバーとして選択され、登録を終えた状態でなければなりません。チームの確定前にメンバーがクランを脱退すると、クランに戻った際に、クランリーダーが再度参加メンバーとして選択する必要があります。チームメンバーが確定した後であれば、クランを一度脱退して再加入したとしても、再度選出してもらう必要はありません。',
		'common.homeMessage.rosterNotComplete.member':
			'チームの代表に選ばれました。チームの確定前にクランを脱退した場合、クランリーダーにもう一度チームに選出してもらわない限り、大会に出場することができません。チームメンバーが確定した後であれば、クランを一度脱退して再加入したとしても、再度選出してもらう必要はありません。',
		'common.homeMessage.rosterNotComplete.fallback':
			'クランを代表するチームがまだ結成されていません。',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			'{rosterMinSize}名以上のチームメンバーが正常に参加登録を完了しました。マッチをプレイするには、チームキャプテンがチームを確定する必要があります。チームが確定したら、メンバーを変更することはできなくなります。',
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			'{rosterMinSize}名以上のチームメンバーが正常に参加登録を完了しました。ランク戦をプレイするには、チームを確定する必要があります。チームが確定したら、メンバーを変更することはできなくなります。',
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			'ランク戦をプレイするには、チームキャプテンはチームを確定しなければなりません。チームを確定したら、メンバーを変更することはできなくなります。',
		'common.homeMessage.rosterLocked':
			'{rosterMinSize}名以上のチームメンバーが正常に参加登録を完了し、チームが確定されました！オープン予選が始まると、チームキャプテンは「対戦相手を探す」をタップしてプレイを開始できます。 世界選手権のマッチ中は、全メンバーが自チームのクランに所属している必要があります。また、他のクラン対戦をプレイすることはできません。別のクランに移動すれば、通常のクラン対戦またはクラン対戦リーグをプレイできますが、世界選手権のマッチ中はフレンド対戦が禁止されています。',
		'common.homeMessage.rosterLocked.captain':
			'{rosterMinSize}名以上のチームメンバーが正常に参加登録を完了し、チームが確定されました！ランク戦が始まると、「対戦相手を探す」をタップしてプレイを開始できます。 世界選手権のマッチ中は、全メンバーが自チームのクランに所属している必要があります。また、他のクラン対戦をプレイすることはできません。別のクランに移動すれば、通常のクラン対戦またはクラン対戦リーグをプレイできますが、世界選手権のマッチ中はフレンド対戦が禁止されています。',
		'common.homeMessage.ladderInProgress':
			'ランク戦が始まりました！チームキャプテンが「対戦相手を探す」をタップするとマッチが組まれます。対戦相手を探すには、メンバー全員がクランに所属しており、フレンド対戦や進行中の対戦に参加していない状態でなければなりません。',
		'common.homeMessage.ladderInProgress.captain':
			'ランク戦が始まりました！「対戦相手を探す」をタップするとマッチが組まれます。対戦相手を探すには、メンバー全員がクランに所属しており、フレンド対戦や進行中の対戦に参加していない状態でなければなりません。対戦相手を探す前に、メンバー全員がプレイの準備ができていることを確認してください。',
		'common.homeMessage.followTeam': '大会タブからチームの状況を見ることができます！',
		'common.homeMessage.finishedTop90.captain':
			'ランク戦で170位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。上位128チームがマンスリー予選に進出します。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。',
		'common.homeMessage.finishedTop90.member':
			'ランク戦で170位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。上位128チームがマンスリー予選に進出します。チームキャプテンは、責任を持ってマッチへのチェックインを行う必要があります。',
		'common.homeMessage.preSegment.postLadder.captain':
			'次のステージへの進出が決まったチームは、マッチへのチェックインを完了する必要があります。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。あなたがマッチへのチェックインを行う必要があります。マッチへのチェックインタイムは5分間です。',
		'common.homeMessage.preSegment.postLadder.member':
			'次のステージへの進出が決まったチームは、マッチへのチェックインを完了する必要があります。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。チームキャプテンは、責任を持ってマッチへのチェックインを行う必要があります。マッチへのチェックインタイムは5分間です。',
		'common.homeMessage.tournamentInProgress.captain':
			'大会が進行中です！各ラウンドの開始時間から5分以内に「チェックイン」をタップしてください。重要な大会情報は、Discordの「Clash of Clans Esports」チャンネルをご覧ください！',
		'common.homeMessage.tournamentInProgress.member':
			'大会が進行中です！チームキャプテンは、各ラウンドの開始時間から5分以内に「チェックイン」をタップしてください。重要な大会情報は、Discordの「Clash of Clans Esports」チャンネルをご覧ください！',
		'common.homeMessage.phase1InProgress':
			'世界選手権2026は現在開催中です。進行状況については、大会タブを確認するか<a href="https://twitter.com/CoCEsports">@CoCEsports</a>をフォローしてください！',
		'common.strings.goodLuckMessage':
			'おめでとうございます！世界一決定戦でのご活躍をお祈りしております！',
		'common.strings.phaseOneComplete':
			'今月の大会が終了しました。詳しくは<a href="https://twitter.com/CoCEsports">@CoCEsports</a>をフォローしてください！',
		'common.strings.ladderEndsIn': 'ランク戦終了まで：',
		'common.strings.matchCheckinStartsIn': 'マッチチェックイン開始まで：',
		'common.strings.matchCheckinEndsIn': 'マッチチェックイン終了まで：',
		'common.homeMessage.teamIncomplete':
			'大会への登録が締め切られました。あなたのチームは時間内に登録を行わなかったため、今月の大会には参加できません。',
		'common.homeMessage.preSegment.ladder.captain':
			'ランク戦で170位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。上位128チームがマンスリー予選に進出します。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。',
		'common.homeMessage.preSegment.ladder.member':
			'ランク戦で170位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。上位128チームがマンスリー予選に進出します。チームキャプテンは、責任を持ってマッチへのチェックインを行う必要があります。',
		'common.button.leaveQueue': 'キューを出る',
		'common.button.findMatch': '対戦相手を探す',
		'common.strings.phase': 'ステージ{#}',
		'common.strings.lowerBracket': '敗者ブラケット',
		'common.strings.upperBracket': '勝者ブラケット',
		'common.strings.noMatches': 'マッチ無し',
		'common.strings.noData': 'データなし',
		'common.button.manageRoster': 'チームを管理',
		'common.button.withdraw': '辞退する',
		'common.strings.readyToPlay': '登録が完了しました！これで、参加の準備は万全です！',
		'common.strings.registration.opens': '登録開始まで:',
		'common.strings.registration.closes': '登録締め切りまで:',
		'common.strings.worldChampionshipFinals': '世界一決定戦',
		'common.strings.lastChanceQualifier': 'ラストチャンス予選',
		'common.strings.starts': '開始',
		'common.strings.ends': '終了',
		'common.strings.eliminationType': '形式：',
		'common.strings.group': 'グループ',
		'common.strings.notPicked5': 'クランメンバーを最低{rosterMinSize}名選んでください',
		'common.strings.notPickedLeader':
			'クランリーダーまたはサブリーダーを１人以上選ぶ必要があります。',
		'common.button.accept': '承認',
		'common.button.decline': '拒否',
		'common.strings.gamesPlayed': 'プレイしたゲーム数',
		'common.strings.wars': '対戦',
		'common.strings.worldFinalsFinalists': 'Finalistas do Campeonato Mundial',
		'common.strings.followNow': '従う！',
		'common.strings.worldFinalsWinner':
			'2026年は<TEAM>が世界チャンピオンに輝きました！<br/><br/>来年の健闘をお祈りします！',
		'common.starts': '開始',
		'common.ends': '終了',
		'common.eliminationType': '形式：',
		'common.eliminationType.doubleElim': '形式：ダブルエリミネーション',
		'common.eliminationType.swiss': '形式：スイス',
		'common.eliminationType.ladder': '形式：ランク戦',
		'common.strings.maxLimitMatchesHeader': 'プレイ数が上限に達しました',
		'common.strings.maxLimitMatchesPerDay':
			'過去24時間にすでに6回マッチをプレイしています。また後ほどお試しください。',
		'common.strings.homeTeam': 'ホーム',
		'common.strings.awayTeam': 'アウェー',
		'common.strings.wfDay1': '世界一決定戦 1日目',
		'common.strings.wfDay2': '世界一決定戦 2日目',
		'common.strings.wfDay3': '世界一決定戦 3日目',
		'common.strings.wfHeroText':
			'世界屈指の8チームが、賞金総額70万ドルと2026年の世界チャンピオンの称号をかけて、ジョージア州・アトランタ開催のクラッシュ・オブ・クラン世界一決定戦で激突します！<br /><br>\n\n10月31日～11月2日は、<a href="[EVENT LINK]" target=""_blank"">イベントサイト</a>で大会を観戦して、ゲーム内報酬を手に入れましょう！',
		'common.strings.wfCongrats':
			'2026年世界チャンピオンに輝いた[TEAM]の皆さん、おめでとうございます！クラッシュ・オブ・クラン世界選手権2026で、またお会いしましょう！TwitterやInstagramの公式チャンネルをフォローして、最新のeスポーツニュースをお見逃しなく！',
		'common.strings.seeYouNextYear':
			'世界チャンピオンの座を獲得した[TEAM]の皆さんに大きな拍手を送りましょう！クラッシュ・オブ・クラン世界選手権2026で、またお会いしましょう！<a href="https://twitter.com/CoCEsports">Twitter</a>や<a href="https://www.instagram.com/esportscoc">Instagram</a>の公式チャンネルをフォローして、2026年のeスポーツニュースをお見逃しなく！\n',
		'common.strings.wfFinalists': '世界一決定戦2026 出場者',
		'common.strings.wfHowToWatch':
			'世界最強の8つのチームが、「2026年クラッシュ・オブ・クラン世界一チャンピオン」の称号と総額70万ドルの賞金をかけて戦います。<br /><br />11月14日～15日は、<a href="https://event.supercell.com/clashofclans/en">イベントウェブサイト</a>で大会を観戦して、視聴中にゲーム内報酬を手に入れましょう！',
		'common.strings.wfSchedule':
			'出場チームは2026年クラッシュ・オブ・クラン世界チャンピオンの称号をかけて、ダブルエリミネーション形式トーナメントで対戦します。<br><br>\n\n1日目の開始日時：10月31日[LOCAL TIME DAY 1]<br>\n\n- 第1～第6マッチ<br><br>\n\n2日目の開始日時：11月1日[LOCAL TIME DAY 2]<br>\n\n- 第7～第12マッチ<br><br>\n\n3日目の開始日時：11月2日[LOCAL TIME DAY 3]<br>\n\n- 第13～第15マッチ<br><br>\n\n<a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/jp</a>で大会を観戦して、ゲーム内報酬を手に入れましょう！',
		'common.strings.mfPrizes': 'マンスリー決勝戦の賞金総額',
		'common.strings.championshipPrizes': '世界一決定戦の賞金総額',
		'common.message.selectFivePlayersForWar':
			'対戦に参加する{rosterMinSize}名のプレイヤーを選択してください。',
		'common.strings.selectFivePlayersForMq':
			'マンスリー予選およびマンスリー決勝戦に参加する{rosterMinSize}人のプレイヤーを選択してください。選択された{rosterMinSize}人のプレイヤーのみが登録されます。',
		'common.strings.lcqWinner': 'ラストチャンス予選優勝',
		'common.strings.chinaQualifier': '中国予選',
		'common.strings.chinaWinner': '中国予選優勝',
		'common.strings.communityTournament': 'コミュニティ大会',
		'common.strings.chinaRegionalQualifier': '中国地域予選',
		'common.strings.townHall': 'タウンホール',
		'common.strings.townHallLevel': 'タウンホールレベル',
		'common.button.waitMatchFinish': 'マッチ終了まで待つ',
		'common.strings.checkInMonthlyQualifier':
			'チームをマンスリー予選にチェックインしてください',
		'common.strings.checkedin': 'チェックイン完了',
		'common.strings.leaderboard': 'ランキング',
		'common.strings.noResults': '結果なし',
		'common.thcup.worldChampionship': 'タウンホールカップ',
		'common.thcup.homeMessage.phase1InProgress':
			'タウンホールカップ2026は進行中です。進行状況については、大会タブを確認するか<a href="https://twitter.com/CoCEsports">@CoCEsports</a>をフォローしてください！',
		'common.thcup.homeMessage.getReady':
			'クラッシュ・オブ・クラン タウンホールカップがいよいよ開幕します！',
		'common.thcup.homeMessage.thNotHighEnough':
			'参加するにはタウンホールレベル9、12、15に達している必要があります。',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'所属クランのリーダーがタウンホールカップへの参加登録をしていません。',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'登録を行い、クランを代表するメンバーを{rosterMinSize}人以上選んで出場チームを編成しましょう！',
		'common.thcup.homeMessage.clanRequired':
			'タウンホールカップに参加するにはクランに所属していなければなりません。',
		'common.thcup.homeMessage.rosterLocked':
			'{rosterMinSize}名以上のチームメンバーが正常に参加登録を完了し、チームが確定されました！ランク戦が始まると、チームキャプテンは「対戦相手を探す」をタップしてプレイを開始できます。なお、タウンホールカップのマッチ中は、全メンバーが自チームのクランに所属している必要があります。また、他のクラン対戦をプレイすることはできません。別のクランに移動すれば、通常のクラン対戦またはクラン対戦リーグをプレイできますが、タウンホールカップのマッチ中はフレンド対戦が禁止されています。',
		'common.thcup.homeMessage.rosterLocked.captain':
			'{rosterMinSize}名以上のチームメンバーが正常に参加登録を完了し、チームが確定されました！ランク戦が始まると、「対戦相手を探す」をタップしてプレイを開始できます。なお、タウンホールカップのマッチ中は、全メンバーが自チームのクランに所属している必要があります。また、他のクラン対戦をプレイすることはできません。別のクランに移動すれば、通常のクラン対戦またはクラン対戦リーグをプレイできますが、タウンホールカップのマッチ中はフレンド対戦が禁止されています。',
		'common.thcup.homeMessage.preSegment.ladder.captain':
			'ランク戦で8位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。上位8チームが決勝戦に進出します。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。',
		'common.thcup.homeMessage.preSegment.ladder.member':
			'ランク戦で8位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。決勝戦に出場する上位8チームのキャプテンは、責任を持ってマッチへのチェックインを行う必要があります。',
		'common.thcup.homeMessage.finishedTop90.captain':
			'ランク戦で8位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。上位8チームが決勝戦に進出します。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。',
		'common.thcup.homeMessage.finishedTop90.member':
			'ランク戦で8位以内に入った参加者には、Discordで重要なお知らせがありますので、そちらをご確認ください。決勝戦に出場する上位8チームのキャプテンは、責任を持ってマッチへのチェックインを行う必要があります。',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			'次のステージへの進出が決まったチームは、マッチへのチェックインを完了する必要があります。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。あなたがマッチへのチェックインを行う必要があります。マッチへのチェックインタイムは5分間です。',
		'common.thcup.homeMessage.preSegment.postLadder.member':
			'次のステージへの進出が決まったチームは、マッチへのチェックインを完了する必要があります。チームメンバーは、マッチへのチェックインが始まる前に、クランに戻ってください。チームキャプテンは、責任を持ってマッチへのチェックインを行う必要があります。マッチへのチェックインタイムは5分間です。',
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'大会は進行中です！各ラウンドの開始時間から5分以内に「チェックイン」をタップしてください。重要な大会情報は、Discordの「Clash of Clans Esports」チャンネルをご覧ください！',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'大会は進行中です！チームキャプテンは、各ラウンドの開始時間から5分以内に「チェックイン」をタップしてください。重要な大会情報は、Discordの「Clash of Clans Esports」チャンネルをご覧ください！',
		'common.thcup.strings.stage1': 'ランク戦',
		'common.thcup.strings.stage2': 'マンスリー予選',
		'common.thcup.strings.mfPrizes': '決勝戦の賞金総額',
		'common.worldChampionship': 'クラッシュ・オブ・クラン世界選手権2026',
		'common.strings.dayTwoAttackOrder3v3':
			'<u>このマッチでは攻撃順があらかじめ決められています。</u><br/><strong>{HOMETEAM}の攻撃：</strong>残り対戦時間21分、13分、5分の時点<br/><strong>{AWAYTEAM}の攻撃：</strong>残り対戦時間17分、9分、1分の時点',
		'common.strings.dayTwoAttackOrder2v2':
			'<u>このマッチでは攻撃順があらかじめ決められています。</u><br/><strong>{HOMETEAM}の攻撃：</strong>残り対戦時間13分、5分の時点<br/><strong>{AWAYTEAM}の攻撃：</strong>残り対戦時間9分、1分の時点',
	},
	ko: {
		'common.strings.home': '홈',
		'common.strings.schedule': '일정',
		'common.strings.stage1': '공개 예선전',
		'common.strings.stage2': '월별 예선전',
		'common.strings.stage3': '월별 파이널',
		'common.strings.stage4': '스테이지 4',
		'common.strings.stage5': '스테이지 5',
		'common.strings.championshipFinals': '챔피언십 파이널',
		'common.strings.prizes': '총상금',
		'common.strings.goldenTicketWinners': '골드 티켓 획득 팀',
		'common.strings.silverTicketWinners': '실버 티켓 획득 팀',
		'common.strings.roster': '로스터',
		'common.strings.captain': '주장',
		'common.strings.upcomingMatches': '경기 일정',
		'common.strings.pastMatches': '완료된 매치',
		'common.strings.ladderLeaderboard': '래더 순위표',
		'common.strings.points': '포인트',
		'common.strings.record': '기록',
		'common.strings.rank': '순위',
		'common.strings.wins': '승리',
		'common.strings.losses': '패배',
		'common.strings.gdpr': 'GDRP',
		'common.strings.participantList': '참가자 명단',
		'common.strings.round': '라운드 {roundNumber}',
		'common.strings.qualified': '통과',
		'common.strings.eliminated': '탈락',
		'common.strings.checkin': '출석 확인',
		'common.button.confirm': '확인',
		'common.button.submit': '제출',
		'common.button.cancel': '취소',
		'common.button.viewEvent': '이벤트 보기',
		'common.button.viewAll': '전체 보기',
		'common.button.backToEvent': '이벤트로 돌아가기',
		'common.button.goBack': '돌아가기',
		'common.button.inviteMembers': '팀 선택',
		'common.button.ready': '준비 완료!',
		'common.button.skip': '나중에 다시 확인',
		'common.button.save': '저장',
		'common.button.saveChanges': '변경 사항 저장',
		'common.button.back': '뒤로',
		'common.button.register': '등록',
		'common.button.pickTeam': '팀 선택',
		'common.button.leaveTeam': '팀 탈퇴',
		'common.button.createTeam': '팀 생성',
		'common.strings.ready': '준비 완료',
		'common.strings.notReady': '준비 중',
		'common.button.done': '완료',
		'common.strings.january': '1월',
		'common.strings.february': '2월',
		'common.strings.march': '3월',
		'common.strings.april': '4월',
		'common.strings.may': '5월',
		'common.strings.june': '6월',
		'common.strings.july': '7월',
		'common.strings.august': '8월',
		'common.strings.september': '9월',
		'common.strings.october': '10월',
		'common.strings.november': '11월',
		'common.strings.december': '12월',
		'common.strings.contactSupport': '고객 지원 문의',
		'common.strings.error.required': '해당 필드는 필수 항목입니다.',
		'common.strings.success': '등록 완료!',
		'common.strings.ohNo': '이런!',
		'common.strings.wait': '잠깐!',
		'common.strings.tooltip.discord':
			'클래시 오브 클랜 월드 챔피언십의 공식 Discord 서버를 통해 팀원들과 소통할 수 있습니다.',
		'common.strings.forfeitWin': '몰수승',
		'common.strings.forfeitLoss': '몰수패',
		'common.strings.bye': '부전승',
		'common.strings.teamInvite': '멤버 초대',
		'common.button.join': '참가',
		'common.strings.discordConnected': 'Discord 계정 연동됨',
		'common.strings.selectedAsCaptain':
			'월드 챔피언십에서 클랜을 대표할 멤버로 선정되었으며 팀 주장으로 지명되었습니다. {DATETIME}까지 등록을 완료해 주세요.',
		'common.strings.pending': '등록이 필요합니다',
		'common.strings.today': '오늘',
		'common.strings.registrationClosesIn': '참가 등록 마감까지 {time}',
		'common.strings.startsIn': '[X]시작까지 {time}',
		'common.strings.endsIn': '[X]종료까지 {time}',
		'common.strings.days': '일',
		'common.strings.hours': '시간',
		'common.strings.minutes': '분',
		'common.strings.seconds': '초',
		'common.strings.changeCaptain': '주장 변경',
		'common.strings.chooseCaptain': '주장 선택',
		'common.strings.backToHub': '토너먼트 허브로 돌아가기',
		'common.strings.missingCaptainLeader':
			'팀에 주장이 없습니다. 대회 참가 전에 주장을 선택해야 합니다.',
		'common.strings.missingCaptain':
			'팀에 주장이 없습니다. 클랜 대표에게 주장을 선발하도록 요청하세요.',
		'common.strings.captainRoleMismatchPersonal':
			'팀 주장이지만 클랜 공동 대표 또는 대표가 아닙니다. 클랜 대표에게 승급을 요청하거나 새 주장을 뽑아달라고 하세요',
		'common.strings.captainRoleMismatchLeader':
			'주장이 클랜 대표 또는 공동 대표가 아닙니다. 새로운 주장을 선택하거나 현재의 주장을 클랜 대표 또는 공동 대표로 승급하세요.',
		'common.strings.captainRoleMismatch':
			'주장이 클랜 대표 또는 공동 대표가 아닙니다. 클랜 대표에게 주장을 클랜 대표 또는 공동 대표로 승급하라고 요청하거나 새로운 주장을 선택하세요.',
		'common.strings.rosterIncompleteLeader':
			'아직 등록되지 않은 초대 선수가 있습니다. 팀원들에게 등록 완료를 요청하세요.',
		'common.strings.rosterIncomplete':
			'최소 한 명 이상의 팀원이 등록을 완료하지 않았습니다. 팀원에게 최대한 빨리 등록하라고 요청하세요.',
		'common.strings.rosterReady':
			'팀이 플레이할 준비가 되었습니다. 팀 주장이 출석을 확인해야 합니다! 행운을 빕니다!',
		'common.button.next': '다음',
		'common.strings.leader': '대표',
		'common.strings.coLeader': '공동 대표',
		'common.strings.elder': '장로',
		'common.strings.member': '클랜원',
		'common.errors.critical': '심각한 오류가 발생했습니다. 앱을 다시 실행해 주세요.',
		'common.button.startWar': '전쟁 시작',
		'common.strings.statusRegRosterCaptain':
			'{DATETIME}에 등록이 마감됩니다.<BR/> 멤버 전원이 등록을 완료하면 팀 고정 버튼을 눌러 팀을 확정하세요! 팀이 확정되면 클랜 이동은 불가합니다.',
		'common.strings.statusRegRosterMember':
			"팀을 대표하도록 선택되었습니다! 참가 등록 마감: {DATETIME}. 참가 등록을 마감하고 '내 팀' 탭에서 내 팀의 상태를 확인해 보세요.",
		'common.strings.statusRegClosedNotMember':
			'내 클랜을 대표할 팀이 선택되었습니다. 참가 등록 마감: {DATETIME}. 대회 탭에서 내 클랜의 여정을 지켜보세요!',
		'common.strings.opponentTeamCheckInOpen': '상대 팀이 아직 전쟁을 시작하지 않았습니다.',
		'common.strings.opponentTeamCheckedIn': '상대 팀이 전쟁 시작 준비를 마쳤습니다.',
		'common.strings.currentTeamCheckInOpen': '우리 팀이 아직 전쟁을 시작하지 않았습니다.',
		'common.strings.currentTeamCheckedIn': '우리 팀이 전쟁 시작 준비를 마쳤습니다.',
		'common.strings.opponentTeamMissedCheckedIn':
			'상대 팀이 시간 내에 매치 출석 확인을 완료하지 않았습니다.',
		'common.strings.currentTeamMissedCheckIn':
			'내 팀이 시간 내에 매치 출석 확인을 완료하지 않았습니다.',
		'common.button.tournamentCheckin': '토너먼트 출석 확인',
		'common.strings.tooltipAttackOrder':
			'양 팀 모두 반드시 올바른 공격 순서<strong>(공식 규정집 3.2.3항)</strong>를 따라야 합니다.<br/><br/>',
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			'상대 팀이 올바른 공격 순서를 따르지 않는다면, 문의 티켓을 작성하고 Discord에서 토너먼트 운영진에게 신고하세요.',
		'common.strings.dayTwoAttackOrder5v5':
			'<u>이 매치에는 공격 순서가 정해져 있습니다.</u><br/><strong>{HOMETEAM} 전투에서 </strong>37분, 29분, 21분, 13분, 5분이 남았을 때에만 공격 가능합니다.<br/><strong>{AWAYTEAM} 전투에서 </strong> 33분, 25분, 17분, 9분, 1분이 남았을 때에만 공격 가능합니다.',
		'common.button.lockRoster': '팀 고정',
		'common.strings.tooltip.notPartOfClan':
			'해당 팀 멤버가 현재 클랜에 소속되어 있지 않습니다.',
		'common.strings.locked': '팀이 고정되었습니다.',
		'common.strings.notLocked': '팀이 고정되지 않았습니다.',
		'common.homeMessage.getReady':
			'클래시 오브 클랜 월드 챔피언십 2026 토너먼트가 곧 시작됩니다!',
		'common.homeMessage.registerAndSelectATeam':
			'클래시 오브 클랜 월드 챔피언십에 등록하고 클랜을 대표하여 출전할 클랜원 {rosterMinSize}명을 선택하세요.',
		'common.homeMessage.leaderHasntRegisteredYet':
			'내 클랜 대표가 아직 클래시 오브 클랜 월드 챔피언십에 등록하지 않았습니다.',
		'common.homeMessage.thNotHighEnough': '참가하려면 마을회관이 18레벨이어야 합니다.',
		'common.homeMessage.clanRequired':
			'클래시 오브 클랜 월드 챔피언십에 참가하려면 클랜에 가입해야 합니다.',
		'common.homeMessage.rosterNotComplete.leader':
			'팀원들이 클랜에 소속 중이며 선택 및 등록을 완료해야 팀을 고정할 수 있습니다. 팀을 고정하기 전에 팀원이 탈퇴한 경우 클랜 대표에 의해 다시 선발되어야 합니다. 팀이 고정되고 나면 팀원들은 다시 선발되지 않아도 클랜을 탈퇴했다가 다시 가입할 수 있습니다.',
		'common.homeMessage.rosterNotComplete.captain':
			'모든 팀원들이 클랜 소속이며 선택 및 등록을 완료해야 팀을 고정할 수 있습니다. 팀을 고정하기 전에 팀원이 탈퇴한 경우 클랜 대표에 의해 다시 선발되어야 합니다. 팀이 고정되고 나면 팀원들은 다시 선발되지 않아도 클랜을 탈퇴했다가 다시 가입할 수 있습니다.',
		'common.homeMessage.rosterNotComplete.member':
			'팀을 대표하도록 선택되었습니다. 지금부터 팀이 고정되기 전에 클랜을 탈퇴하면 클랜 대표가 참가를 위해 당신을 다시 선택해야 합니다. 팀이 고정되고 나면 탈퇴가 가능하며 선택되지 않고도 클랜에 복귀할 수 있습니다.',
		'common.homeMessage.rosterNotComplete.fallback':
			'내 클랜을 대표할 팀이 아직 선택되지 않았습니다.',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			'{rosterMinSize}명 이상의 팀원이 모두 성공적으로 등록되었습니다. 매치를 플레이하려면 팀 주장이 팀을 고정해야 합니다. 팀이 고정되면 팀 라인업을 수정할 수 없습니다.',
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			'{rosterMinSize}명 이상의 팀원이 모두 성공적으로 등록되었습니다. 래더 매치를 플레이하려면 팀을 고정해야 합니다. 팀이 고정되면 팀 라인업을 수정할 수 없습니다.',
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			'래더 매치를 플레이하려면 팀 주장이 팀을 고정해야 합니다. 팀이 고정되면 팀 라인업을 수정할 수 없습니다.',
		'common.homeMessage.rosterLocked':
			"{rosterMinSize}명 이상의 팀원이 모두 성공적으로 등록되었으며, 팀 고정이 완료되었습니다! 래더가 시작되면 팀 주장이 '매치 찾기'를 탭해서 매치 플레이를 시작할 수 있습니다. 월드 챔피언십 매치 중에는 모든 팀원이 클랜에 속해 있어야 하며, 클랜은 다른 전쟁에 참여할 수 없다는 점을 기억하세요. 선수가 다른 클랜에서 일반 클랜전이나 클랜전 리그를 플레이하는 것은 가능하지만, 월드 챔피언십 매치 중 친선전 참가는 제한됩니다.",
		'common.homeMessage.rosterLocked.captain':
			"{rosterMinSize}명 이상의 팀원이 모두 성공적으로 등록되었으며, 팀 고정이 완료되었습니다! 래더가 시작되면 '매치 찾기'를 탭해서 매치 플레이를 시작할 수 있습니다. 월드 챔피언십 매치 중에는 모든 팀원이 클랜에 속해 있어야 하며, 클랜은 다른 전쟁에 참여할 수 없다는 점을 기억하세요. 선수가 다른 클랜에서 일반 클랜전이나 클랜전 리그를 플레이하는 것은 가능하지만, 월드 챔피언십 매치 중 친선전 참가는 제한됩니다.",
		'common.homeMessage.ladderInProgress':
			"래더가 시작되었습니다! 팀 주장은 '매치 찾기'를 탭해서 매치를 찾을 수 있습니다. 매치를 찾기 위해서는 모든 팀원이 클랜에 소속되어 있어야 하며 친선전 또는 클랜전에 참여 중이지 않아야 합니다.",
		'common.homeMessage.ladderInProgress.captain':
			"래더가 시작되었습니다! '매치 찾기' 버튼을 탭해서 매치를 찾을 수 있습니다. 매치를 찾기 위해서는 모든 팀원이 클랜에 소속되어 있어야 하며 친선전 또는 클랜전에 참여 중이지 않아야 합니다. 매치를 찾기 전에 모든 팀원들이 준비되어 있는지 확인하세요.",
		'common.homeMessage.followTeam': '대회 탭에서 팀의 진행 상황을 확인할 수 있습니다!',
		'common.homeMessage.finishedTop90.captain':
			'래더 순위가 170위 이내라면 Discord에서 중요 발표를 확인해 주세요. 상위 128개 팀은 월별 예선전에 진출합니다. 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 합니다.',
		'common.homeMessage.finishedTop90.member':
			'래더 순위가 170위 이내라면 Discord에서 중요 발표를 확인해 주세요. 상위 128개 팀은 월별 예선전에 진출합니다. 팀 주장은 매치 출석 확인에 대한 책임을 갖습니다.',
		'common.homeMessage.preSegment.postLadder.captain':
			'대회의 다음 스테이지로 진출한 팀은 매치 출석 확인을 완료해야 합니다. 모든 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 한다는 점을 명심하세요. 플레이어님에게 매치 출석 확인에 대한 책임이 있습니다. 매치 출석 확인 시간은 5분이 주어집니다.',
		'common.homeMessage.preSegment.postLadder.member':
			'대회의 다음 스테이지로 진출한 팀은 매치 출석 확인을 완료해야 합니다. 모든 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 한다는 점을 명심하세요. 팀 주장은 매치 출석 확인에 대한 책임을 갖습니다. 매치 출석 확인 시간은 5분이 주어집니다.',
		'common.homeMessage.tournamentInProgress.captain':
			'토너먼트가 진행 중입니다! 매 라운드 시작 시간 5분 안에 "출석 확인"을 누르세요. 중요한 토너먼트 정보는 "Clash of Clans Esports" Discord 채널을 확인하세요!',
		'common.homeMessage.tournamentInProgress.member':
			'토너먼트가 진행 중입니다! 매 라운드 시작 시간 5분 안에 팀 주장이 "출석 확인"을 눌러야 합니다. 중요한 토너먼트 정보는 "Clash of Clans Esports" Discord 채널을 확인하세요!',
		'common.homeMessage.phase1InProgress':
			'2026 월드 챔피언십이 진행 중입니다. 대회 탭에 가거나 소셜 채널 <a href="https://twitter.com/CoCEsports">@CoCEsports</a>를 팔로우하여 토너먼트 진행 상황을 확인할 수 있습니다!',
		'common.strings.goodLuckMessage':
			'축하합니다! 나머지 월드 챔피언십 파이널에서도 행운을 빕니다!',
		'common.strings.phaseOneComplete':
			'이번 달의 대회가 종료되었습니다. 자세한 내용을 알아보려면 <a href="https://twitter.com/CoCEsports">@CoCEsports</a>를 팔로우하세요!',
		'common.strings.ladderEndsIn': '래더 종료까지',
		'common.strings.matchCheckinStartsIn': '매치 출석 확인 시작까지',
		'common.strings.matchCheckinEndsIn': '매치 출석 확인 종료까지',
		'common.homeMessage.teamIncomplete':
			'이제 대회 등록이 마감되었습니다. 팀이 제시간 내에 등록을 완료하지 못했으므로 이번 달 대회에 참가할 수 없습니다.',
		'common.homeMessage.preSegment.ladder.captain':
			'래더 순위가 170위 이내라면 Discord에서 중요 발표를 확인해 주세요. 상위 128개 팀은 월별 예선전에 진출합니다. 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 합니다.',
		'common.homeMessage.preSegment.ladder.member':
			'래더 순위가 170위 이내라면 Discord에서 중요 발표를 확인해 주세요. 상위 128개 팀은 월별 예선전에 진출합니다. 팀 주장은 매치 출석 확인에 대한 책임을 갖습니다.',
		'common.button.leaveQueue': '대기열 나가기',
		'common.button.findMatch': '매치 찾기',
		'common.strings.phase': '스테이지 {#}',
		'common.strings.lowerBracket': '하위 대진표',
		'common.strings.upperBracket': '상위 대진표',
		'common.strings.noMatches': '매치 없음',
		'common.strings.noData': '데이터 없음',
		'common.button.manageRoster': '팀 관리',
		'common.button.withdraw': '기권',
		'common.strings.readyToPlay':
			'등록이 성공적으로 완료되었습니다! 플레이할 준비가 끝났습니다!',
		'common.strings.registration.opens': '참가 등록 시작:',
		'common.strings.registration.closes': '참가 등록 마감:',
		'common.strings.worldChampionshipFinals': '월드 챔피언십 파이널',
		'common.strings.lastChanceQualifier': '와일드카드 결정전',
		'common.strings.starts': '시작',
		'common.strings.ends': '종료',
		'common.strings.eliminationType': '경기 형식:',
		'common.strings.group': '그룹',
		'common.strings.notPicked5': '최소 {rosterMinSize}명의 클랜원을 선택하세요.',
		'common.strings.notPickedLeader': '클랜 대표나 공동 대표를 최소 1명 선택해야 합니다.',
		'common.button.accept': '수락',
		'common.button.decline': '거절',
		'common.strings.gamesPlayed': 'GP',
		'common.strings.wars': '클랜전',
		'common.strings.worldFinalsFinalists': '世界選手権ファイナル出場選手',
		'common.strings.followNow': '지금 팔로우하세요!',
		'common.strings.worldFinalsWinner':
			'<TEAM> 팀! 2026년 월드 챔피언의 탄생을 축하합니다!<br/><br/>2026년에 다시 만날 수 있기를 바랍니다!',
		'common.starts': '시작',
		'common.ends': '종료',
		'common.eliminationType': '경기 형식:',
		'common.eliminationType.doubleElim': '경기 형식: 더블 엘리미네이션',
		'common.eliminationType.swiss': '경기 형식: 스위스',
		'common.eliminationType.ladder': '경기 형식: 래더',
		'common.strings.maxLimitMatchesHeader': '매치 플레이 수 제한 도달',
		'common.strings.maxLimitMatchesPerDay':
			'지난 24시간 동안 이미 6번의 매치를 플레이했습니다. 나중에 다시 시도해 주세요.',
		'common.strings.homeTeam': '홈',
		'common.strings.awayTeam': '원정',
		'common.strings.wfDay1': '월드 챔피언십 파이널 1일 차',
		'common.strings.wfDay2': '월드 챔피언십 파이널 2일 차',
		'common.strings.wfDay3': '월드 챔피언십 파이널 3일 차',
		'common.strings.wfHeroText':
			'세계 최고의 8개 팀이 70만 달러의 총상금과 2026년 월드 챔피언 타이틀을 두고 조지아주 애틀랜타에서 열리는 클래시 오브 클랜 월드 챔피언십 파이널에서 경쟁을 펼칩니다.<br /><br>\n\n10월 31일부터 11월 2일까지 <a href="[EVENT LINK]" target=""_blank"">이벤트 플랫폼</a>에서 매치를 시청하고 게임 내 보상을 획득하세요!',
		'common.strings.wfCongrats':
			'[TEAM], 2026년 월드 챔피언 타이틀 획득을 축하합니다! 클래시 오브 클랜 월드 챔피언십은 2026년에 다시 돌아옵니다. 그때 다시 만나길 기대하겠습니다! 저희의 e스포츠 X(Twitter)와 Instagram을 팔로우하고, 모든 최신 소식을 놓치지 마세요.',
		'common.strings.seeYouNextYear':
			'[TEAM]! 월드 챔피언의 탄생을 축하합니다! 클래시 오브 클랜 월드 챔피언십은 2026년에 다시 돌아옵니다. 그때 다시 만나길 기대하겠습니다! 저희의 e스포츠 <a href="https://twitter.com/CoCEsports">X(Twitter)</a>와 <a href="https://www.instagram.com/esportscoc">Instagram</a>을 팔로우하고 2026년에 예정된 모든 최신 소식을 놓치지 마세요!\n',
		'common.strings.wfFinalists': '2026 월드 챔피언십 파이널 진출팀',
		'common.strings.wfHowToWatch':
			'세계 최고의 8개 팀이 2026년 클래시 오브 클랜 월드 챔피언 타이틀과 총상금 70만 달러 중 가장 큰 몫을 두고 격돌합니다!<br /><br />11월 14일부터 15일까지 <a href="https://event.supercell.com/clashofclans/en">이벤트 사이트</a>에서 경기를 시청하고 게임 내 보상을 획득하세요!',
		'common.strings.wfSchedule':
			'각 팀은 더블 엘리미네이션 대진표에서 경쟁하며, 2026년 클래시 오브 클랜 월드 챔피언 타이틀을 두고 격돌합니다.<br><br>\n\n1일 차 시작: 10월 31일 [LOCAL TIME DAY 1]<br>\n\n- 매치 1~6<br><br>\n\n2일 차 시작: 11월 1일 [LOCAL TIME DAY 2]<br>\n\n- 매치 7~12<br><br>\n\n3일 차 시작: 11월 2일 [LOCAL TIME DAY 3]<br>\n\n- 매치 13~15<br><br>\n\n<a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/kr</a>에서 시청하고 게임 내 보상을 획득하세요!',
		'common.strings.mfPrizes': '월별 파이널 총상금',
		'common.strings.championshipPrizes': '챔피언십 파이널 총상금',
		'common.message.selectFivePlayersForWar':
			'전쟁에 참가할 선수 {rosterMinSize}명을 선택하세요.',
		'common.strings.selectFivePlayersForMq':
			'월별 예선전과 월별 파이널에 참가할 {rosterMinSize}명의 선수를 확정해 주세요. 팀 명단에는 선택한 {rosterMinSize}명의 선수만 남게 됩니다.',
		'common.strings.lcqWinner': '와일드카드 결정전 우승팀',
		'common.strings.chinaQualifier': '중국 예선전',
		'common.strings.chinaWinner': '중국 예선전 우승팀',
		'common.strings.communityTournament': '커뮤니티 토너먼트',
		'common.strings.chinaRegionalQualifier': '중국 지역 예선전',
		'common.strings.townHall': '마을회관',
		'common.strings.townHallLevel': '마을회관 레벨',
		'common.button.waitMatchFinish': '매치가 종료되기까지 기다리는 중입니다.',
		'common.strings.checkInMonthlyQualifier': '월별 예선전의 팀 출석 확인을 해주세요.',
		'common.strings.checkedin': '출석 확인 완료',
		'common.strings.leaderboard': '순위표',
		'common.strings.noResults': '결과 없음',
		'common.thcup.worldChampionship': '마을회관 컵',
		'common.thcup.homeMessage.phase1InProgress':
			'2026 마을회관 컵이 진행 중입니다. 대회 탭에 가거나 소셜 채널 <a href="https://twitter.com/CoCEsports">@CoCEsports</a>를 팔로우하여 토너먼트 진행 상황을 확인할 수 있습니다!',
		'common.thcup.homeMessage.getReady':
			'클래시 오브 클랜 마을회관 컵 토너먼트가 곧 시작됩니다!',
		'common.thcup.homeMessage.thNotHighEnough':
			'참가하려면 마을회관이 9레벨, 12레벨 또는 15레벨이어야 합니다.',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'내 클랜 대표가 아직 클래시 오브 클랜 마을회관 컵에 등록하지 않았습니다.',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'클래시 오브 클랜 마을회관 컵에 등록하고, 클랜을 대표하여 출전할 클랜원을 최소 {rosterMinSize}명 선택하세요.',
		'common.thcup.homeMessage.clanRequired':
			'클래시 오브 클랜 마을회관 컵에 참가하려면 클랜에 가입해야 합니다.',
		'common.thcup.homeMessage.rosterLocked':
			"{rosterMinSize}명 이상의 팀원이 모두 성공적으로 등록되었으며, 팀 고정이 완료되었습니다! 래더가 시작되면 팀 주장이 '매치 찾기'를 탭해서 매치 플레이를 시작할 수 있습니다. 마을회관 컵 매치 중에는 모든 팀원이 클랜에 속해 있어야 하며, 클랜은 다른 전쟁에 참여할 수 없다는 점을 명심하세요. 선수가 다른 클랜에서 일반 클랜전이나 클랜전 리그를 플레이하는 것은 가능하지만, 마을회관 컵 매치 중 친선전 참가는 제한됩니다.",
		'common.thcup.homeMessage.rosterLocked.captain':
			"{rosterMinSize}명 이상의 팀원이 모두 성공적으로 등록되었으며, 팀 고정이 완료되었습니다! 래더가 시작되면 '매치 찾기'를 탭해서 매치 플레이를 시작할 수 있습니다. 마을회관 컵 매치 중에는 모든 팀원이 클랜에 속해 있어야 하며, 클랜은 다른 전쟁에 참여할 수 없다는 점을 명심하세요. 선수가 다른 클랜에서 일반 클랜전이나 클랜전 리그를 플레이하는 것은 가능하지만, 마을회관 컵 매치 중 친선전 참가는 제한됩니다.",
		'common.thcup.homeMessage.preSegment.ladder.captain':
			'래더 순위가 8위 이내라면, Discord에서 중요 발표를 확인해 주세요. 상위 8개 팀은 파이널로 진출합니다. 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 합니다.',
		'common.thcup.homeMessage.preSegment.ladder.member':
			'래더 순위가 8위 이내라면, Discord에서 중요 발표를 확인해 주세요. 상위 8개 팀은 파이널로 진출하며, 팀 주장은 매치 출석 확인에 대한 책임을 갖습니다.',
		'common.thcup.homeMessage.finishedTop90.captain':
			'래더 순위가 8위 이내라면, Discord에서 중요 발표를 확인해 주세요. 상위 8개 팀은 파이널로 진출합니다. 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 합니다.',
		'common.thcup.homeMessage.finishedTop90.member':
			'래더 순위가 8위 이내라면, Discord에서 중요 발표를 확인해 주세요. 상위 8개 팀은 파이널로 진출하며, 팀 주장은 매치 출석 확인에 대한 책임을 갖습니다.',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			'대회의 다음 스테이지로 진출한 팀은 매치 출석 확인을 완료해야 합니다. 모든 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 한다는 점을 명심하세요. 플레이어님에게 매치 출석 확인에 대한 책임이 있습니다. 매치 출석 확인 시간은 5분이 주어집니다.',
		'common.thcup.homeMessage.preSegment.postLadder.member':
			'대회의 다음 스테이지로 진출한 팀은 매치 출석 확인을 완료해야 합니다. 모든 팀원은 반드시 매치 출석 확인이 시작되기 전에 클랜에 복귀해야 한다는 점을 명심하세요. 팀 주장은 매치 출석 확인에 대한 책임을 갖습니다. 매치 출석 확인 시간은 5분이 주어집니다.',
		'common.thcup.homeMessage.tournamentInProgress.captain':
			"토너먼트가 진행 중입니다! 라운드 시작 5분 안에 '출석 확인'을 탭하시기 바랍니다. 'Clash of Clans Esports' Discord에서 주요 토너먼트 정보를 확인하세요!",
		'common.thcup.homeMessage.tournamentInProgress.member':
			"토너먼트가 진행 중입니다! 팀 주장은 매 라운드 시작 5분 안에 '출석 확인'을 탭해야 합니다. 'Clash of Clans Esports' Discord에서 주요 토너먼트 정보를 확인하세요!",
		'common.thcup.strings.stage1': '래더',
		'common.thcup.strings.stage2': '월별 예선전',
		'common.thcup.strings.mfPrizes': '파이널 총상금',
		'common.worldChampionship': '클래시 오브 클랜 월드 챔피언십 2026',
		'common.strings.dayTwoAttackOrder3v3':
			'<u>이 매치에는 공격 순서가 정해져 있습니다.</u><br/><strong>{HOMETEAM} 전투에서 </strong>21분, 13분, 5분이 남았을 때에만 공격 가능합니다.<br/><strong>{AWAYTEAM} 전투에서 </strong> 17분, 9분, 1분이 남았을 때에만 공격 가능합니다.',
		'common.strings.dayTwoAttackOrder2v2':
			'<u>이 매치에는 공격 순서가 정해져 있습니다.</u><br/><strong>{HOMETEAM} 전투에서 </strong>13분, 5분이 남았을 때에만 공격 가능합니다.<br/><strong>{AWAYTEAM} 전투에서 </strong> 9분, 1분이 남았을 때에만 공격 가능합니다.',
	},
	zh_TW: {
		'common.strings.home': '首頁',
		'common.strings.schedule': '日程',
		'common.strings.stage1': '預選賽',
		'common.strings.stage2': '月度資格賽',
		'common.strings.stage3': '月度決賽',
		'common.strings.stage4': '第4階段',
		'common.strings.stage5': '第5階段',
		'common.strings.championshipFinals': '全球總決賽',
		'common.strings.prizes': '總獎金',
		'common.strings.goldenTicketWinners': '贏得黃金門票的選手',
		'common.strings.silverTicketWinners': '贏得白銀門票的隊伍',
		'common.strings.roster': '隊伍陣容',
		'common.strings.captain': '隊長',
		'common.strings.upcomingMatches': '即將到來的比賽',
		'common.strings.pastMatches': '已結束的比賽',
		'common.strings.ladderLeaderboard': '天梯排行榜',
		'common.strings.points': '積分',
		'common.strings.record': '戰績',
		'common.strings.rank': '名次',
		'common.strings.wins': '勝場',
		'common.strings.losses': '敗場',
		'common.strings.gdpr': 'GDPR',
		'common.strings.participantList': '參賽者名單',
		'common.strings.round': '第{roundNumber}輪',
		'common.strings.qualified': '晉級',
		'common.strings.eliminated': '淘汰',
		'common.strings.checkin': '報到',
		'common.button.confirm': '確認',
		'common.button.submit': '送出',
		'common.button.cancel': '取消',
		'common.button.viewEvent': '查看賽事',
		'common.button.viewAll': '查看全部',
		'common.button.backToEvent': '返回賽事',
		'common.button.goBack': '返回',
		'common.button.inviteMembers': '選擇隊伍',
		'common.button.ready': '準備就緒！',
		'common.button.skip': '暫時跳過',
		'common.button.save': '儲存',
		'common.button.saveChanges': '儲存變更',
		'common.button.back': '返回',
		'common.button.register': '報名',
		'common.button.pickTeam': '選擇隊伍',
		'common.button.leaveTeam': '離開隊伍',
		'common.button.createTeam': '創建隊伍',
		'common.strings.ready': '準備就緒',
		'common.strings.notReady': '尚未就緒',
		'common.button.done': '確定',
		'common.strings.january': '1月',
		'common.strings.february': '2月',
		'common.strings.march': '3月',
		'common.strings.april': '4月',
		'common.strings.may': '5月',
		'common.strings.june': '6月',
		'common.strings.july': '7月',
		'common.strings.august': '8月',
		'common.strings.september': '9月',
		'common.strings.october': '10月',
		'common.strings.november': '11月',
		'common.strings.december': '12月',
		'common.strings.contactSupport': '聯絡賽事支援',
		'common.strings.error.required': '必填欄位',
		'common.strings.success': '成功！',
		'common.strings.ohNo': '很抱歉！',
		'common.strings.wait': '等等！',
		'common.strings.tooltip.discord':
			'你可以透過部落衝突全球錦標賽官方Discord伺服器與你的隊伍成員聯絡。',
		'common.strings.forfeitWin': '自動判定為戰勝',
		'common.strings.forfeitLoss': '自動判定為戰敗',
		'common.strings.bye': '輪空',
		'common.strings.teamInvite': '邀請成員',
		'common.button.join': '加入',
		'common.strings.discordConnected': '已連結Discord帳號',
		'common.strings.selectedAsCaptain':
			'你被選擇代表你的部落參加全球錦標賽，且被任命為隊伍隊長。請於{DATETIME}前完成報名參賽的程序。',
		'common.strings.pending': '報名需求',
		'common.strings.today': '今天',
		'common.strings.registrationClosesIn': '離報名截止還有：{time}',
		'common.strings.startsIn': '離[X]開始還有{time}',
		'common.strings.endsIn': '離[X]結束還有{time}',
		'common.strings.days': '天',
		'common.strings.hours': '小時',
		'common.strings.minutes': '分鐘',
		'common.strings.seconds': '秒',
		'common.strings.changeCaptain': '更換隊長',
		'common.strings.chooseCaptain': '選擇隊長',
		'common.strings.backToHub': '返回賽事中心',
		'common.strings.missingCaptainLeader':
			'你的隊伍缺少1名隊長。在參賽前，你必須先選擇1名隊伍隊長。',
		'common.strings.missingCaptain':
			'你的隊伍缺少1名隊長。請聯絡你的部落首領，由其選擇1名隊伍隊長。',
		'common.strings.captainRoleMismatchPersonal':
			'你是隊伍隊長，但在部落內職務並非首領或副首領。請聯絡你的部落首領，為你提升職務。',
		'common.strings.captainRoleMismatchLeader':
			'你的隊伍隊長並非部落首領或副首領。請選出1名新的隊長，或將隊伍隊長晉升為首領或副首領。',
		'common.strings.captainRoleMismatch':
			'你的隊伍隊長並非部落首領或副首領。請告知你的部落首領將隊長晉升為部落首領或副首領，或選出1名新的隊長。',
		'common.strings.rosterIncompleteLeader':
			'你邀請了尚未完成報名的選手，請告知你的隊伍成員進行報名。',
		'common.strings.rosterIncomplete':
			'至少有1名隊伍成員尚未完成報名，請告知你的隊伍成員進行報名。',
		'common.strings.rosterReady':
			'你的隊伍已經做好參賽準備，隊伍隊長必須完成報到。祝你比賽順利！',
		'common.button.next': '下一步',
		'common.strings.leader': '首領',
		'common.strings.coLeader': '副首領',
		'common.strings.elder': '長老',
		'common.strings.member': '成員',
		'common.errors.critical': '出現了嚴重錯誤，請重新開啟遊戲。',
		'common.button.startWar': '開始對戰',
		'common.strings.statusRegRosterCaptain':
			'報名將在{DATETIME}<BR/>截止。所有成員都完成報名後，請點擊「鎖定隊伍陣容」按鈕，鎖定你的隊伍陣容。隊伍陣容鎖定後，成員便無法更換部落。',
		'common.strings.statusRegRosterMember':
			'你已被選擇代表隊伍！報名將在{DATETIME}截止。請完成報名，並前往「我的隊伍」頁面查看隊伍的最新動態。',
		'common.strings.statusRegClosedNotMember':
			'代表你的部落的隊伍已被選定。報名將在{DATETIME}截止。前往賽事頁面，查看你所在部落的征戰之旅！',
		'common.strings.opponentTeamCheckInOpen': '對方隊伍尚未點擊「開始對戰」按鈕。',
		'common.strings.opponentTeamCheckedIn': '對方隊伍已點擊「開始對戰」按鈕。',
		'common.strings.currentTeamCheckInOpen': '你的隊伍尚未點擊「開始對戰」按鈕。',
		'common.strings.currentTeamCheckedIn': '你的隊伍已點擊「開始對戰」按鈕。',
		'common.strings.opponentTeamMissedCheckedIn': '對方隊伍未在規定時間內進行本場比賽報到。',
		'common.strings.currentTeamMissedCheckIn': '你的隊伍未在規定時間內進行本場比賽報到。',
		'common.button.tournamentCheckin': '賽事報到',
		'common.strings.tooltipAttackOrder':
			'雙方隊伍都必須按照<strong>《賽事規則》第3.2.3條</strong><br/><br/>規定的進攻順序發動進攻。',
		'common.strings.tooltipAttackOrderContactAdminDiscord':
			'如對方隊伍未遵守進攻順序的指示，請透過Discord發送支援信件，將情況報告給賽事主辦方工作人員。',
		'common.strings.dayTwoAttackOrder5v5':
			'<u>在本賽事中，參賽隊伍需按照規定的進攻順序發動進攻。</u><br/><strong>{HOMETEAM}先攻方在離對戰結束還剩37分鐘、29分鐘、21分鐘、13分鐘、5分鐘時發動進攻</strong>。<br/><strong>{AWAYTEAM}後攻方在離對戰結束還剩33分鐘、25分鐘、17分鐘、9分鐘、1分鐘時發動進攻</strong>',
		'common.button.lockRoster': '隊伍陣容鎖定',
		'common.strings.tooltip.notPartOfClan': '該隊伍成員目前未在部落中。',
		'common.strings.locked': '隊伍陣容已鎖定',
		'common.strings.notLocked': '隊伍陣容未鎖定',
		'common.homeMessage.getReady': '準備迎接2026部落衝突全球錦標賽！',
		'common.homeMessage.registerAndSelectATeam':
			'請選擇{rosterMinSize}名部落成員加入部落並完成報名，代表你的部落參加部落衝突全球錦標賽。',
		'common.homeMessage.leaderHasntRegisteredYet':
			'你的部落首領並未報名參加部落衝突全球錦標賽。',
		'common.homeMessage.thNotHighEnough': '大本營等級必須達到18級才能參賽。',
		'common.homeMessage.clanRequired': '你必須加入一個部落才能參加部落衝突全球錦標賽。',
		'common.homeMessage.rosterNotComplete.leader':
			'要鎖定你的隊伍陣容，所有隊伍成員必須全部都在部落內，且必須先完成隊伍成員的選擇和報名。如果有隊伍成員在隊伍陣容鎖定之前離開隊伍，則需要由部落首領將其重新選入隊伍。隊伍陣容鎖定之後，隊伍成員可以退出或重新加入部落，無需首領重新選擇。',
		'common.homeMessage.rosterNotComplete.captain':
			'要鎖定你的隊伍陣容，所有隊伍成員必須全部都在部落內，且必須先完成隊伍成員的選擇和報名。如果有隊伍成員在隊伍陣容鎖定之前離開隊伍，則需要由部落首領將其重新選入隊伍。隊伍陣容鎖定之後，隊伍成員可以退出或重新加入部落，無需首領重新選擇。',
		'common.homeMessage.rosterNotComplete.member':
			'你已被選擇代表隊伍。請注意，如果你在隊伍陣容鎖定之前退出部落，再次回到部落參賽時，需要由部落首領重新將你選入隊伍。隊伍陣容鎖定之後，你就可以退出或重新加入部落，無需首領重新選擇。',
		'common.homeMessage.rosterNotComplete.fallback': '代表部落的參賽隊伍尚未組建完畢。',
		'common.homeMessage.rosterCompletePlayNotStarted.leader':
			'你隊伍裡的至少{rosterMinSize}位選手已成功報名。隊伍隊長必須先鎖定隊伍陣容才能開始比賽。隊伍陣容一旦鎖定便無法更改。',
		'common.homeMessage.rosterCompletePlayNotStarted.captain':
			'你隊伍裡的至少{rosterMinSize}位選手已成功報名。你必須先鎖定隊伍陣容才能參加天梯賽。隊伍陣容一旦鎖定便無法更改。',
		'common.homeMessage.rosterCompletePlayNotStarted.member':
			'要參加天梯賽，隊伍隊長必須鎖定隊伍陣容。隊伍陣容一旦鎖定便無法更改。',
		'common.homeMessage.rosterLocked':
			'你隊伍裡的至少{rosterMinSize}位選手已成功報名，隊伍陣容也已鎖定！天梯賽開始後，隊伍隊長點擊「尋找比賽」按鈕即可開始比賽。 請謹記，所有選手都必須在部落中，並且該部落在全球錦標賽對戰期間，不得參加任何其他對戰。在全球錦標賽對戰期間，選手可以在其他部落正常參加部落對戰和部落對戰聯盟賽，但不得參加部落友誼戰。',
		'common.homeMessage.rosterLocked.captain':
			'你隊伍裡的至少{rosterMinSize}位選手已成功報名，隊伍陣容也已鎖定！天梯賽開始後，請點擊「尋找比賽」按鈕以開始比賽。 請謹記，所有選手都必須在部落中，並且該部落在全球錦標賽對戰期間，不得參加任何其他對戰。在全球錦標賽對戰期間，選手可以在其他部落正常參加部落對戰和部落對戰聯盟賽，但不得參加部落友誼戰。',
		'common.homeMessage.ladderInProgress':
			'天梯賽正式開始！隊伍隊長點擊「尋找比賽」按鈕即可開始尋找對手部落。請注意，隊伍尋找比賽時，所有隊伍成員必須都在部落裡，並且不得參加任何部落對戰或部落友誼戰。',
		'common.homeMessage.ladderInProgress.captain':
			'天梯賽正式開始！請點擊「尋找比賽」按鈕以開始比賽。請注意，隊伍尋找比賽時，所有隊伍成員必須都在部落裡，並且不得參加任何部落對戰或部落友誼戰。在尋找比賽前，請確保所有部落成員已準備就緒。',
		'common.homeMessage.followTeam': '你可以透過「賽事」頁面查看隊伍的比賽賽程！',
		'common.homeMessage.finishedTop90.captain':
			'如果你所在隊伍的天梯賽排名為前170名，請前往Discord查看重要通知。排名前128的隊伍將直接晉級月度資格賽。隊伍成員必須在比賽場次報到開始前回到部落。',
		'common.homeMessage.finishedTop90.member':
			'如果你所在隊伍的天梯賽排名為前170名，請前往Discord查看重要通知。排名前128的隊伍將直接晉級月度資格賽。隊伍隊長負責完成比賽場次報到程序。',
		'common.homeMessage.preSegment.postLadder.captain':
			'晉級下一階段賽事的隊伍將需要完成比賽場次報到程序。請注意，所有隊伍成員必須在比賽場次報到開始前回到部落。你負責完成比賽場次報到程序。比賽場次報到時間為5分鐘。',
		'common.homeMessage.preSegment.postLadder.member':
			'晉級下一階段賽事的隊伍將需要完成比賽場次報到程序。請注意，所有隊伍成員必須在比賽場次報到開始前回到部落。隊伍隊長負責完成比賽場次報到程序。比賽場次報到時間為5分鐘。',
		'common.homeMessage.tournamentInProgress.captain':
			'賽事進行中！請在每輪比賽開始後的5分鐘內點擊「報到」按鈕。請進入「Clash of Clans Esports」Discord查看重要賽事資訊！',
		'common.homeMessage.tournamentInProgress.member':
			'賽事進行中！隊伍隊長必須在每輪比賽開始後的5分鐘內點擊「報到」按鈕。請進入「Clash of Clans Esports」Discord查看重要賽事資訊！',
		'common.homeMessage.phase1InProgress':
			'2026部落衝突全球錦標賽火熱進行中。你可以透過「賽事」頁面或追蹤<a href="https://twitter.com/CoCEsports">@CoCEsports</a>，即時了解接下來的賽事資訊！\n',
		'common.strings.goodLuckMessage': '恭喜！祝你的全球總決賽之旅一切順利！',
		'common.strings.phaseOneComplete':
			'本月賽事已結束，請追蹤<a href="https://twitter.com/CoCEsports">@CoCEsports</a>了解更多資訊！',
		'common.strings.ladderEndsIn': '離天梯賽結束還有',
		'common.strings.matchCheckinStartsIn': '離比賽場次報到開始還有',
		'common.strings.matchCheckinEndsIn': '離比賽場次報到結束還有',
		'common.homeMessage.teamIncomplete':
			'賽事報名已截止，而你的隊伍沒有在報名截止前完成報名。因此，你的隊伍將無法參加本月賽事。',
		'common.homeMessage.preSegment.ladder.captain':
			'如果你所在隊伍的天梯賽排名為前170名，請前往Discord查看重要通知。排名前128的隊伍將直接晉級月度資格賽。隊伍成員必須在比賽場次報到開始前回到部落。',
		'common.homeMessage.preSegment.ladder.member':
			'如果你所在隊伍的天梯賽排名為前170名，請前往Discord查看重要通知。排名前128的隊伍將直接晉級月度資格賽。隊伍隊長負責完成比賽場次報到程序。',
		'common.button.leaveQueue': '退出佇列',
		'common.button.findMatch': '尋找比賽',
		'common.strings.phase': '第{#}階段',
		'common.strings.lowerBracket': '敗者組',
		'common.strings.upperBracket': '勝者組',
		'common.strings.noMatches': '沒有比賽',
		'common.strings.noData': '沒有資料',
		'common.button.manageRoster': '管理隊伍陣容',
		'common.button.withdraw': '退出',
		'common.strings.readyToPlay': '報名成功！準備好參加比賽吧！',
		'common.strings.registration.opens': '報名開始：',
		'common.strings.registration.closes': '報名截止:',
		'common.strings.worldChampionshipFinals': '全球總決賽',
		'common.strings.lastChanceQualifier': '最終席位資格賽',
		'common.strings.starts': '開始時間',
		'common.strings.ends': '結束時間',
		'common.strings.eliminationType': '採用賽制：',
		'common.strings.group': '小組',
		'common.strings.notPicked5': '請選擇至少{rosterMinSize}名部落成員',
		'common.strings.notPickedLeader': '必須至少選擇1名部落首領或副首領',
		'common.button.accept': '接受',
		'common.button.decline': '拒絕',
		'common.strings.gamesPlayed': '比賽局數',
		'common.strings.wars': '對戰',
		'common.strings.worldFinalsFinalists': '월드 챔피언십 진출자',
		'common.strings.followNow': '立即關注！',
		'common.strings.worldFinalsWinner':
			'恭喜<TEAM>榮獲2026年全球總冠軍！<br/><br/>期待2026年再見到你們的精彩表現。',
		'common.starts': '開始時間',
		'common.ends': '結束時間',
		'common.eliminationType': '採用賽制：',
		'common.eliminationType.doubleElim': '採用賽制：雙敗淘汰賽',
		'common.eliminationType.swiss': '採用賽制：積分循環賽',
		'common.eliminationType.ladder': '採用賽制：天梯賽',
		'common.strings.maxLimitMatchesHeader': '已達對戰場次上限',
		'common.strings.maxLimitMatchesPerDay': '你已在過去24小時內進行6場對戰。請稍後再試。',
		'common.strings.homeTeam': '主隊',
		'common.strings.awayTeam': '客隊',
		'common.strings.wfDay1': '全球總決賽比賽日第1天',
		'common.strings.wfDay2': '全球總決賽比賽日第2天',
		'common.strings.wfDay3': '全球總決賽比賽日第3天',
		'common.strings.wfHeroText':
			'全球8支頂尖隊伍將在喬治亞州亞特蘭大舉行的部落衝突全球錦標賽上展開角逐，爭奪70萬美金的獎金和2026年全球總冠軍的頭銜！<br /><br>\n\n10月31日至11月2日，鎖定<a href="[EVENT LINK]" target=""_blank"">賽事平台</a>，還可獲取遊戲內獎勵！',
		'common.strings.wfCongrats':
			'恭喜[TEAM]榮獲2026年全球總冠軍！部落衝突全球錦標賽將在2026年精彩回歸，我們不見不散！記得追蹤我們的Esports Twitter和Instagram，第一時間獲取最新賽事資訊！',
		'common.strings.seeYouNextYear':
			'恭喜[TEAM]榮獲全球總冠軍！部落衝突全球錦標賽將在2026年精彩回歸，我們不見不散！記得追蹤我們的Esports <a href="https://twitter.com/CoCEsports">Twitter</a>和<a href="https://www.instagram.com/esportscoc">Instagram</a>，第一時間獲取2026年的最新賽事資訊！\n',
		'common.strings.wfFinalists': '2026全球總決賽參賽隊伍',
		'common.strings.wfHowToWatch':
			'全球最強的8支隊伍將在世界舞台上展開顛峰對決，爭奪2026《部落衝突》全球總冠軍頭銜，以及70萬美元獎金池中最大的一份！<br /><br />11月14日至15日鎖定<a href="https://event.supercell.com/clashofclans/zh-tc">賽事網站</a>，在觀看比賽的同時獲取遊戲內獎勵吧！',
		'common.strings.wfSchedule':
			'參賽隊伍將在雙敗淘汰賽中展開對決，爭奪2026年部落衝突全球總冠軍的頭銜。<br><br>\n\n比賽日第1天：10月31日[LOCAL TIME DAY 1]<br>\n\n- 第1至6回合<br><br>\n\n比賽日第2天：11月1日[LOCAL TIME DAY 1]<br>\n\n- 第7至12回合<br><br>\n\n比賽日第3天：11月2日[LOCAL TIME DAY 1]<br>\n\n- 第13至15回合<br><br>\n\n鎖定<a href="[EVENT LINK]" target="_blank">https://event.supercell.com/clashofclans/en</a>，並獲取遊戲內獎勵！',
		'common.strings.mfPrizes': '月度決賽總獎金',
		'common.strings.championshipPrizes': '總決賽總獎金',
		'common.message.selectFivePlayersForWar': '請選擇將參加對戰的{rosterMinSize}名選手。',
		'common.strings.selectFivePlayersForMq':
			'請確認將參加月度資格賽和月度決賽的{rosterMinSize}名選手。只有{rosterMinSize}名被選擇的選手才能留在隊伍陣容中。',
		'common.strings.lcqWinner': '最終席位資格賽第1名隊伍',
		'common.strings.chinaQualifier': '中國大陸區域資格賽',
		'common.strings.chinaWinner': '中國大陸區域資格賽第1名隊伍',
		'common.strings.communityTournament': '玩家社群賽事',
		'common.strings.chinaRegionalQualifier': '中國大陸區域資格賽',
		'common.strings.townHall': '大本營',
		'common.strings.townHallLevel': '大本營等級',
		'common.button.waitMatchFinish': '等待比賽結束中',
		'common.strings.checkInMonthlyQualifier': '為你的隊伍報名月度資格賽',
		'common.strings.checkedin': '報到完成',
		'common.strings.leaderboard': '積分排行榜',
		'common.strings.noResults': '沒有結果',
		'common.thcup.worldChampionship': 'Town Hall Cups',
		'common.thcup.homeMessage.phase1InProgress':
			'2026 Town Hall Cup現正火熱進行中。你可以透過「賽事」頁面或追蹤<a href="https://twitter.com/CoCEsports">@CoCEsports</a>，即時了解接下來的賽事資訊！',
		'common.thcup.homeMessage.getReady': '準備迎接部落衝突Town Hall Cup！',
		'common.thcup.homeMessage.thNotHighEnough': '大本營等級必須達到9級、12級或15級才能參賽。',
		'common.thcup.homeMessage.leaderHasntRegisteredYet':
			'你的部落首領並未報名參加部落衝突Town Hall Cup。',
		'common.thcup.homeMessage.registerAndSelectATeam':
			'請選擇至少{rosterMinSize}名部落成員加入部落並完成報名，代表你的部落參加部落衝Town Hall Cup。',
		'common.thcup.homeMessage.clanRequired':
			'你必須加入一個部落才能參加部落衝突Town Hall Cup。',
		'common.thcup.homeMessage.rosterLocked':
			'你隊伍裡的至少{rosterMinSize}位選手已成功報名，隊伍陣容也已鎖定！天梯賽開始後，隊伍隊長點擊「尋找比賽」按鈕即可開始比賽。請謹記，所有選手都必須在部落中，並且該部落在Town Hall Cup對戰期間，不得參加任何其他對戰。在Town Hall Cup對戰期間，選手可以在其他部落正常參加部落對戰和部落對戰聯盟賽，但不得參加部落友誼戰。',
		'common.thcup.homeMessage.rosterLocked.captain':
			'你隊伍裡的至少{rosterMinSize}位選手已成功報名，隊伍陣容也已鎖定！天梯賽開始後，請點擊「尋找比賽」按鈕以開始比賽。請謹記，所有選手都必須在部落中，並且該部落在Town Hall Cup對戰期間，不得參加任何其他對戰。在Town Hall Cup對戰期間，選手可以在其他部落正常參加部落對戰和部落對戰聯盟賽，但不得參加部落友誼戰。',
		'common.thcup.homeMessage.preSegment.ladder.captain':
			'如果你所在隊伍的天梯賽排名為前8名，請前往Discord查看重要通知。排名前8的隊伍將直接晉級決賽。隊伍成員必須在比賽場次報到開始前回到部落。',
		'common.thcup.homeMessage.preSegment.ladder.member':
			'如果你所在隊伍的天梯賽排名為前8名，請前往Discord查看重要通知。前8強隊伍將晉級決賽，由隊長負責賽事報到。',
		'common.thcup.homeMessage.finishedTop90.captain':
			'如果你所在隊伍的天梯賽排名為前8名，請前往Discord查看重要通知。排名前8的隊伍將直接晉級決賽。隊伍成員必須在比賽場次報到開始前回到部落。',
		'common.thcup.homeMessage.finishedTop90.member':
			'如果你所在隊伍的天梯賽排名為前8名，請前往Discord查看重要通知。前8強隊伍將晉級決賽，由隊長負責賽事報到。',
		'common.thcup.homeMessage.preSegment.postLadder.captain':
			'晉級下一階段賽事的隊伍將需要完成比賽場次報到程序。請注意，所有隊伍成員必須在比賽場次報到開始前回到部落。你負責完成比賽場次報到程序。比賽場次報到時間為5分鐘。',
		'common.thcup.homeMessage.preSegment.postLadder.member':
			'晉級下一階段賽事的隊伍將需要完成比賽場次報到程序。請注意，所有隊伍成員必須在比賽場次報到開始前回到部落。隊伍隊長負責完成比賽場次報到程序。比賽場次報到時間為5分鐘。',
		'common.thcup.homeMessage.tournamentInProgress.captain':
			'賽事進行中！請在每輪比賽開始後的5分鐘內點擊「報到」按鈕。請進入「Clash of Clans Esports」Discord伺服器查看重要賽事資訊！',
		'common.thcup.homeMessage.tournamentInProgress.member':
			'賽事進行中！隊伍隊長必須在每輪比賽開始後的5分鐘內點擊「報到」按鈕。請進入「Clash of Clans Esports」Discord伺服器查看重要賽事資訊！',
		'common.thcup.strings.stage1': '天梯賽',
		'common.thcup.strings.stage2': '月度資格賽',
		'common.thcup.strings.mfPrizes': '決賽總獎金',
		'common.worldChampionship': '2026部落衝突全球錦標賽',
		'common.strings.dayTwoAttackOrder3v3':
			'<u>在本賽事中，參賽隊伍需按照規定的進攻順序發動進攻。</u><br/><strong>{HOMETEAM}先攻方在離對戰結束還剩21分鐘、13分鐘、5分鐘時發動進攻</strong>。<br/><strong>{AWAYTEAM}後攻方在離對戰結束還剩17分鐘、9分鐘、1分鐘時發動進攻</strong>',
		'common.strings.dayTwoAttackOrder2v2':
			'<u>在本賽事中，參賽隊伍需按照規定的進攻順序發動進攻。</u><br/><strong>{HOMETEAM}先攻方在離對戰結束還剩13分鐘、5分鐘時發動進攻</strong>。<br/><strong>{AWAYTEAM}後攻方在離對戰結束還剩9分鐘、1分鐘時發動進攻</strong>',
	},
}
